//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
// @ts-nocheck

export class AuthorizedApiBase {
  private authToken = ''

  protected constructor(config: IAuthorizedApiBaseConfig) {
    this.authToken = config.token
  }

  protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${this.authToken}`,
    }
    return Promise.resolve(options)
  }
}

export class Client extends AuthorizedApiBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  private baseUrl: string
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined

  constructor(configuration: IAuthorizedApiBaseConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super(configuration)
    this.http = http ? http : (window as any)
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : ''
  }

  /**
   * @return Success
   * @deprecated
   */
  updateIdentity(provider: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Account/Identity({provider})'
    if (provider === undefined || provider === null) throw new Error("The parameter 'provider' must be defined.")
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpdateIdentity(_response)
      })
  }

  protected processUpdateIdentity(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  getAppConfig(): Promise<AppConfig> {
    let url_ = this.baseUrl + '/api/v1/AppConfig'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAppConfig(_response)
      })
  }

  protected processGetAppConfig(response: Response): Promise<AppConfig> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppConfig.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppConfig>(null as any)
  }

  /**
   * @param name (optional)
   * @param description (optional)
   * @param roleStr (optional)
   * @return Success
   */
  create(name: string | null | undefined, description: string | null | undefined, roleStr: string | null | undefined): Promise<AppConfig> {
    let url_ = this.baseUrl + '/api/v1/AppConfig?'
    if (name !== undefined && name !== null) url_ += 'name=' + encodeURIComponent('' + name) + '&'
    if (description !== undefined && description !== null) url_ += 'description=' + encodeURIComponent('' + description) + '&'
    if (roleStr !== undefined && roleStr !== null) url_ += 'roleStr=' + encodeURIComponent('' + roleStr) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processCreate(_response)
      })
  }

  protected processCreate(response: Response): Promise<AppConfig> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppConfig.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppConfig>(null as any)
  }

  /**
   * @return Success
   */
  getPageFromConfig(name: string): Promise<Page> {
    let url_ = this.baseUrl + '/api/v1/AppConfig/Page/{name}'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetPageFromConfig(_response)
      })
  }

  protected processGetPageFromConfig(response: Response): Promise<Page> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Page.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Page>(null as any)
  }

  /**
   * @return Success
   */
  getPageFromConfig2(name: string): Promise<Page> {
    let url_ = this.baseUrl + '/api/v1/AppConfig/{name}/DataPage'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetPageFromConfig2(_response)
      })
  }

  protected processGetPageFromConfig2(response: Response): Promise<Page> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Page.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Page>(null as any)
  }

  /**
   * @return Success
   */
  getDataViewFromConfig(name: string): Promise<DataView> {
    let url_ = this.baseUrl + '/api/v1/AppConfig/DataView/{name}'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetDataViewFromConfig(_response)
      })
  }

  protected processGetDataViewFromConfig(response: Response): Promise<DataView> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataView.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataView>(null as any)
  }

  /**
   * @return Success
   */
  getFormFromConfig(name: string): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/AppConfig/Form/{name}'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetFormFromConfig(_response)
      })
  }

  protected processGetFormFromConfig(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @return Success
   */
  getMenuFromConfig(name: string): Promise<Menu> {
    let url_ = this.baseUrl + '/api/v1/AppConfig/Menu/{name}'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetMenuFromConfig(_response)
      })
  }

  protected processGetMenuFromConfig(response: Response): Promise<Menu> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Menu.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Menu>(null as any)
  }

  /**
   * @return Success
   */
  getManiMenuFromConfig(): Promise<Menu> {
    let url_ = this.baseUrl + '/api/v1/AppConfig/Menu'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetManiMenuFromConfig(_response)
      })
  }

  protected processGetManiMenuFromConfig(response: Response): Promise<Menu> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Menu.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Menu>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   * @deprecated
   */
  getFormsDataView(body: DataViewRequest | null | undefined): Promise<DataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/AppConfig/Form/DataView'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetFormsDataView(_response)
      })
  }

  protected processGetFormsDataView(response: Response): Promise<DataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataViewResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addPage(body: Page | null | undefined): Promise<AppPage> {
    let url_ = this.baseUrl + '/api/v1/AppConfig/Page'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAddPage(_response)
      })
  }

  protected processAddPage(response: Response): Promise<AppPage> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppPage.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppPage>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addDataView(body: DataView | null | undefined): Promise<AppDataView> {
    let url_ = this.baseUrl + '/api/v1/AppConfig/DataView'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAddDataView(_response)
      })
  }

  protected processAddDataView(response: Response): Promise<AppDataView> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppDataView.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppDataView>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  setAppConfig(id: string, body: any | null | undefined): Promise<AppConfig> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType({id})/AppConfig'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processSetAppConfig(_response)
      })
  }

  protected processSetAppConfig(response: Response): Promise<AppConfig> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppConfig.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppConfig>(null as any)
  }

  /**
   * @return Success
   */
  getDataForm(name: string): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/AppDataForm/{name}/DataForm'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetDataForm(_response)
      })
  }

  protected processGetDataForm(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @return Success
   */
  getById(id: string): Promise<AppDataView> {
    let url_ = this.baseUrl + '/api/v1/AppDataView({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetById(_response)
      })
  }

  protected processGetById(response: Response): Promise<AppDataView> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppDataView.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppDataView>(null as any)
  }

  /**
   * @return Success
   */
  getByName(name: string): Promise<AppDataView> {
    let url_ = this.baseUrl + '/api/v1/AppDataView/{name}'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetByName(_response)
      })
  }

  protected processGetByName(response: Response): Promise<AppDataView> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppDataView.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppDataView>(null as any)
  }

  /**
   * @return Success
   */
  getByName2(name: string): Promise<AppDataView> {
    let url_ = this.baseUrl + '/api/v1/AppDataView({name})'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetByName2(_response)
      })
  }

  protected processGetByName2(response: Response): Promise<AppDataView> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppDataView.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppDataView>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  dataViewById(id: string, body: DataViewRequest | null | undefined): Promise<IDataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/AppDataView({id})/DataView'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewById(_response)
      })
  }

  protected processDataViewById(response: Response): Promise<IDataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = IDataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IDataViewResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  dataViewByName(name: string, body: DataViewRequest | null | undefined): Promise<IDataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/AppDataView/{name}/DataView'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewByName(_response)
      })
  }

  protected processDataViewByName(response: Response): Promise<IDataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = IDataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IDataViewResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  dataViewByName2(name: string, body: DataViewRequest | null | undefined): Promise<IDataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/AppDataView({name})/DataView'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewByName2(_response)
      })
  }

  protected processDataViewByName2(response: Response): Promise<IDataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = IDataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IDataViewResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  dataView(id: string, body: DataViewRequest | null | undefined): Promise<IDataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/AppDataView/ObjectType({id})/DataView'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataView(_response)
      })
  }

  protected processDataView(response: Response): Promise<IDataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = IDataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IDataViewResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  dataViewByName3(name: string, body: DataViewRequest | null | undefined): Promise<IDataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/AppDataView/ObjectType/{name}/DataView'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewByName3(_response)
      })
  }

  protected processDataViewByName3(response: Response): Promise<IDataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = IDataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IDataViewResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  dataViewByName4(name: string, body: DataViewRequest | null | undefined): Promise<IDataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/AppDataView/ObjectType({name})/DataView'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewByName4(_response)
      })
  }

  protected processDataViewByName4(response: Response): Promise<IDataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = IDataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IDataViewResponse>(null as any)
  }

  /**
   * @return Success
   */
  dataViewImportById(id: string): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/AppDataView/ObjectType({id})/Import'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewImportById(_response)
      })
  }

  protected processDataViewImportById(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @return Success
   */
  dataViewImportByName(name: string): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/AppDataView/ObjectType/{name}/Import'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewImportByName(_response)
      })
  }

  protected processDataViewImportByName(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @return Success
   */
  dataViewImportByName2(name: string): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/AppDataView/ObjectType({name})/Import'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewImportByName2(_response)
      })
  }

  protected processDataViewImportByName2(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @return Success
   */
  getById2(id: string): Promise<Appointment> {
    let url_ = this.baseUrl + '/api/v1/Appointment({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetById2(_response)
      })
  }

  protected processGetById2(response: Response): Promise<Appointment> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Appointment.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Appointment>(null as any)
  }

  /**
   * @return Success
   */
  cancel(id: string): Promise<Appointment> {
    let url_ = this.baseUrl + '/api/v1/Appointment({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processCancel(_response)
      })
  }

  protected processCancel(response: Response): Promise<Appointment> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Appointment.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Appointment>(null as any)
  }

  /**
   * @param start (optional)
   * @return Success
   * @deprecated
   */
  getAll(start: Date | null | undefined): Promise<Appointment[]> {
    let url_ = this.baseUrl + '/api/v1/Appointment?'
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAll(_response)
      })
  }

  protected processGetAll(response: Response): Promise<Appointment[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(Appointment.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Appointment[]>(null as any)
  }

  /**
   * @param start (optional)
   * @return Success
   * @deprecated
   */
  getOrgAppointments(start: Date | null | undefined): Promise<Appointment[]> {
    let url_ = this.baseUrl + '/api/v1/Organization/Appointment?'
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrgAppointments(_response)
      })
  }

  protected processGetOrgAppointments(response: Response): Promise<Appointment[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(Appointment.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Appointment[]>(null as any)
  }

  /**
   * @param start (optional)
   * @return Success
   * @deprecated
   */
  getAppointmentsForOrg(id: string, start: Date | null | undefined): Promise<Appointment[]> {
    let url_ = this.baseUrl + '/api/v1/Organization({id})/Appointment?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAppointmentsForOrg(_response)
      })
  }

  protected processGetAppointmentsForOrg(response: Response): Promise<Appointment[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(Appointment.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Appointment[]>(null as any)
  }

  /**
   * @param start (optional)
   * @return Success
   * @deprecated
   */
  getOrgAppointmentsByType(id: string, start: Date | null | undefined): Promise<Appointment[]> {
    let url_ = this.baseUrl + '/api/v1/Organization/AppointmentType({id})/Appointment?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrgAppointmentsByType(_response)
      })
  }

  protected processGetOrgAppointmentsByType(response: Response): Promise<Appointment[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(Appointment.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Appointment[]>(null as any)
  }

  /**
   * @param start (optional)
   * @return Success
   * @deprecated
   */
  getByTypeAll(id: string, start: Date | null | undefined): Promise<Appointment[]> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType({id})/Appointment?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetByTypeAll(_response)
      })
  }

  protected processGetByTypeAll(response: Response): Promise<Appointment[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(Appointment.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Appointment[]>(null as any)
  }

  /**
   * @return Success
   * @deprecated
   */
  getByLead(id: string): Promise<Appointment[]> {
    let url_ = this.baseUrl + '/api/v1/Lead({id})/Appointment'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetByLead(_response)
      })
  }

  protected processGetByLead(response: Response): Promise<Appointment[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(Appointment.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Appointment[]>(null as any)
  }

  /**
   * @return Success
   */
  getUserSettingsForOrganization(id: string): Promise<UserWithSchedulingSettings[]> {
    let url_ = this.baseUrl + '/api/v1/Scheduler/Organization({id})/Settings'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetUserSettingsForOrganization(_response)
      })
  }

  protected processGetUserSettingsForOrganization(response: Response): Promise<UserWithSchedulingSettings[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(UserWithSchedulingSettings.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<UserWithSchedulingSettings[]>(null as any)
  }

  /**
   * @param appointmentTypeId (optional)
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  getSlotsForUser(
    userId: string,
    appointmentTypeId: string | null | undefined,
    start: Date | null | undefined,
    end: Date | null | undefined
  ): Promise<SlotsResp> {
    let url_ = this.baseUrl + '/api/v1/Scheduler/User({userId})/Slots?'
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.")
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId))
    if (appointmentTypeId !== undefined && appointmentTypeId !== null) url_ += 'appointmentTypeId=' + encodeURIComponent('' + appointmentTypeId) + '&'
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetSlotsForUser(_response)
      })
  }

  protected processGetSlotsForUser(response: Response): Promise<SlotsResp> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = SlotsResp.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<SlotsResp>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  getSlots(id: string, start: Date | null | undefined, end: Date | null | undefined): Promise<SlotsResp> {
    let url_ = this.baseUrl + '/api/v1/Scheduler/Lead({id})/Slots?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetSlots(_response)
      })
  }

  protected processGetSlots(response: Response): Promise<SlotsResp> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = SlotsResp.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<SlotsResp>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  cancelAppointment(body: CancelAppointmentRequest | null | undefined): Promise<Appointment> {
    let url_ = this.baseUrl + '/api/v1/Scheduler/Appointment'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processCancelAppointment(_response)
      })
  }

  protected processCancelAppointment(response: Response): Promise<Appointment> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Appointment.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Appointment>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  scheduleAppointment(body: ScheduleAppointmentRequest | null | undefined): Promise<Appointment> {
    let url_ = this.baseUrl + '/api/v1/Scheduler/Appointment'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processScheduleAppointment(_response)
      })
  }

  protected processScheduleAppointment(response: Response): Promise<Appointment> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Appointment.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Appointment>(null as any)
  }

  /**
   * @return Success
   */
  getAll2(): Promise<AppointmentType[]> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAll2(_response)
      })
  }

  protected processGetAll2(response: Response): Promise<AppointmentType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(AppointmentType.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentType[]>(null as any)
  }

  /**
   * @param name (optional)
   * @return Success
   */
  add(name: string | null | undefined): Promise<AppointmentType> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType?'
    if (name !== undefined && name !== null) url_ += 'name=' + encodeURIComponent('' + name) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAdd(_response)
      })
  }

  protected processAdd(response: Response): Promise<AppointmentType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppointmentType.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentType>(null as any)
  }

  /**
   * @return Success
   */
  getById3(id: string): Promise<AppointmentType> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetById3(_response)
      })
  }

  protected processGetById3(response: Response): Promise<AppointmentType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppointmentType.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentType>(null as any)
  }

  /**
   * @param name (optional)
   * @return Success
   */
  updateName(id: string, name: string | null | undefined): Promise<AppointmentType> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType({id})?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (name !== undefined && name !== null) url_ += 'name=' + encodeURIComponent('' + name) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpdateName(_response)
      })
  }

  protected processUpdateName(response: Response): Promise<AppointmentType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppointmentType.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentType>(null as any)
  }

  /**
   * @return Success
   */
  delete(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDelete(_response)
      })
  }

  protected processDelete(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateSettings(id: string, body: SchedulingSettings | null | undefined): Promise<AppointmentType> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType({id})/Settings'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpdateSettings(_response)
      })
  }

  protected processUpdateSettings(response: Response): Promise<AppointmentType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppointmentType.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentType>(null as any)
  }

  /**
   * @param leadTypeId (optional)
   * @return Success
   */
  updateLeadType(id: string, leadTypeId: string | null | undefined): Promise<AppointmentType> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType({id})/LeadType?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (leadTypeId !== undefined && leadTypeId !== null) url_ += 'leadTypeId=' + encodeURIComponent('' + leadTypeId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpdateLeadType(_response)
      })
  }

  protected processUpdateLeadType(response: Response): Promise<AppointmentType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppointmentType.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentType>(null as any)
  }

  /**
   * @return Success
   */
  availabilityAll(): Promise<Availability[]> {
    let url_ = this.baseUrl + '/api/v1/Availability'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAvailabilityAll(_response)
      })
  }

  protected processAvailabilityAll(response: Response): Promise<Availability[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(Availability.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Availability[]>(null as any)
  }

  /**
   * @return Success
   */
  deleteAvailability(): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Availability'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDeleteAvailability(_response)
      })
  }

  protected processDeleteAvailability(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  putAvailability(body: Availability[] | null | undefined): Promise<Availability[]> {
    let url_ = this.baseUrl + '/api/v1/Availability'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processPutAvailability(_response)
      })
  }

  protected processPutAvailability(response: Response): Promise<Availability[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(Availability.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Availability[]>(null as any)
  }

  /**
   * @return Success
   */
  deleteAvailability2(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Availability({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDeleteAvailability2(_response)
      })
  }

  protected processDeleteAvailability2(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  availability(id: string): Promise<AppointmentTypeAvailability> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType({id})/Availability'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAvailability(_response)
      })
  }

  protected processAvailability(response: Response): Promise<AppointmentTypeAvailability> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppointmentTypeAvailability.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentTypeAvailability>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  getUserAvailability(body: DataViewRequest | null | undefined): Promise<DataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/User/Availability/DataView'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetUserAvailability(_response)
      })
  }

  protected processGetUserAvailability(response: Response): Promise<DataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataViewResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  getOrgAvailabilityPOST(body: DataViewRequest | null | undefined): Promise<DataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/Organization/Availability/DataView'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrgAvailabilityPOST(_response)
      })
  }

  protected processGetOrgAvailabilityPOST(response: Response): Promise<DataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataViewResponse>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  allSlots(id: string, start: Date | null | undefined, end: Date | null | undefined): Promise<TimeSlot[]> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType({id})/Slot?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAllSlots(_response)
      })
  }

  protected processAllSlots(response: Response): Promise<TimeSlot[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(TimeSlot.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<TimeSlot[]>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  openSlots(id: string, start: Date | null | undefined, end: Date | null | undefined): Promise<TimeSlot[]> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType({id})/Open?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processOpenSlots(_response)
      })
  }

  protected processOpenSlots(response: Response): Promise<TimeSlot[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(TimeSlot.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<TimeSlot[]>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  organizationAvailability(start: Date | null | undefined, end: Date | null | undefined): Promise<TimeSlotWithCount[]> {
    let url_ = this.baseUrl + '/api/v1/Organization/Availability?'
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processOrganizationAvailability(_response)
      })
  }

  protected processOrganizationAvailability(response: Response): Promise<TimeSlotWithCount[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(TimeSlotWithCount.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<TimeSlotWithCount[]>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  organizationAvailability2(id: string, start: Date | null | undefined, end: Date | null | undefined): Promise<TimeSlotWithCount[]> {
    let url_ = this.baseUrl + '/api/v1/Organization({id})/Availability?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processOrganizationAvailability2(_response)
      })
  }

  protected processOrganizationAvailability2(response: Response): Promise<TimeSlotWithCount[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(TimeSlotWithCount.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<TimeSlotWithCount[]>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  userAvailability(userId: string, appointmentTypeId: string, start: Date | null | undefined, end: Date | null | undefined): Promise<EntityOpenSlots> {
    let url_ = this.baseUrl + '/api/v1/User({userId})/AppointmentType({appointmentTypeId})/Availability?'
    if (userId === undefined || userId === null) throw new Error("The parameter 'userId' must be defined.")
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId))
    if (appointmentTypeId === undefined || appointmentTypeId === null) throw new Error("The parameter 'appointmentTypeId' must be defined.")
    url_ = url_.replace('{appointmentTypeId}', encodeURIComponent('' + appointmentTypeId))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUserAvailability(_response)
      })
  }

  protected processUserAvailability(response: Response): Promise<EntityOpenSlots> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = EntityOpenSlots.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<EntityOpenSlots>(null as any)
  }

  /**
   * @return Success
   */
  getOrganizationBalance(id: string): Promise<EntityBalance> {
    let url_ = this.baseUrl + '/api/v1/Billing/Organization({id})/Balance'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrganizationBalance(_response)
      })
  }

  protected processGetOrganizationBalance(response: Response): Promise<EntityBalance> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = EntityBalance.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<EntityBalance>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  setOrganizationAutoRefill(id: string, body: AutoRefillRequest | null | undefined): Promise<EntityBalance> {
    let url_ = this.baseUrl + '/api/v1/Billing/Organization({id})/AutoRefill'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processSetOrganizationAutoRefill(_response)
      })
  }

  protected processSetOrganizationAutoRefill(response: Response): Promise<EntityBalance> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = EntityBalance.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<EntityBalance>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  adjustOrganizationBalance(id: string, body: BalanceAdjustment | null | undefined): Promise<EntityBalance> {
    let url_ = this.baseUrl + '/api/v1/Billing/Organization({id})/Adjustment'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAdjustOrganizationBalance(_response)
      })
  }

  protected processAdjustOrganizationBalance(response: Response): Promise<EntityBalance> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = EntityBalance.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<EntityBalance>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resolveDispute(id: string, body: ResolveDisputeRequest | null | undefined): Promise<TransactionResponse> {
    let url_ = this.baseUrl + '/api/v1/Billing/Transaction({id})/Resolve'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processResolveDispute(_response)
      })
  }

  protected processResolveDispute(response: Response): Promise<TransactionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = TransactionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<TransactionResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  disputeTransaction(id: string, body: DisputeRequest | null | undefined): Promise<Dispute> {
    let url_ = this.baseUrl + '/api/v1/Billing/Transaction({id})/Dispute'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDisputeTransaction(_response)
      })
  }

  protected processDisputeTransaction(response: Response): Promise<Dispute> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Dispute.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Dispute>(null as any)
  }

  /**
   * @return Success
   */
  getBalance(id: string): Promise<EntityBalance> {
    let url_ = this.baseUrl + '/api/v1/Billing/Organization/Balance'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetBalance(_response)
      })
  }

  protected processGetBalance(response: Response): Promise<EntityBalance> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = EntityBalance.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<EntityBalance>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  getMyCalendar(start: Date | null | undefined, end: Date | null | undefined): Promise<EntityOpenSlots> {
    let url_ = this.baseUrl + '/api/v1/Calendar?'
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetMyCalendar(_response)
      })
  }

  protected processGetMyCalendar(response: Response): Promise<EntityOpenSlots> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = EntityOpenSlots.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<EntityOpenSlots>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  getUserCalendar(id: string, start: Date | null | undefined, end: Date | null | undefined): Promise<EntityOpenSlots> {
    let url_ = this.baseUrl + '/api/v1/User({id})/Calendar?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetUserCalendar(_response)
      })
  }

  protected processGetUserCalendar(response: Response): Promise<EntityOpenSlots> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = EntityOpenSlots.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<EntityOpenSlots>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  dataView2(id: string, body: DataViewRequest | null | undefined): Promise<IDataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/CustomObject({id})/DataView'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataView2(_response)
      })
  }

  protected processDataView2(response: Response): Promise<IDataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = IDataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IDataViewResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  dataViewByName5(objectType: string, body: DataViewRequest | null | undefined): Promise<IDataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/{objectType}/DataView'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewByName5(_response)
      })
  }

  protected processDataViewByName5(response: Response): Promise<IDataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = IDataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IDataViewResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  dataViewByName6(objectType: string, body: DataViewRequest | null | undefined): Promise<IDataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/CustomObject({objectType})/DataView'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewByName6(_response)
      })
  }

  protected processDataViewByName6(response: Response): Promise<IDataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = IDataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IDataViewResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  dataViewChildrenByName(objectType: string, id: string, expandPath: string, body: DataViewRequest | null | undefined): Promise<IDataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/{objectType}({id})/{expandPath}/DataView'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (expandPath === undefined || expandPath === null) throw new Error("The parameter 'expandPath' must be defined.")
    url_ = url_.replace('{expandPath}', encodeURIComponent('' + expandPath))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewChildrenByName(_response)
      })
  }

  protected processDataViewChildrenByName(response: Response): Promise<IDataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = IDataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IDataViewResponse>(null as any)
  }

  /**
   * @param contentType (optional)
   * @param contentDisposition (optional)
   * @param headers (optional)
   * @param length (optional)
   * @param name (optional)
   * @param fileName (optional)
   * @return Success
   */
  dataViewImportById2(
    id: string,
    contentType: string | null | undefined,
    contentDisposition: string | null | undefined,
    headers: string | null | undefined,
    length: number | null | undefined,
    name: string | null | undefined,
    fileName: string | null | undefined
  ): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/CustomObject({id})/Import'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = new FormData()
    if (contentType !== null && contentType !== undefined) content_.append('ContentType', contentType.toString())
    if (contentDisposition !== null && contentDisposition !== undefined) content_.append('ContentDisposition', contentDisposition.toString())
    if (headers !== null && headers !== undefined) content_.append('Headers', headers.toString())
    if (length !== null && length !== undefined) content_.append('Length', length.toString())
    if (name !== null && name !== undefined) content_.append('Name', name.toString())
    if (fileName !== null && fileName !== undefined) content_.append('FileName', fileName.toString())

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewImportById2(_response)
      })
  }

  protected processDataViewImportById2(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @param contentType (optional)
   * @param contentDisposition (optional)
   * @param headers (optional)
   * @param length (optional)
   * @param name (optional)
   * @param fileName (optional)
   * @return Success
   */
  dataViewImport(
    objectType: string,
    contentType: string | null | undefined,
    contentDisposition: string | null | undefined,
    headers: string | null | undefined,
    length: number | null | undefined,
    name: string | null | undefined,
    fileName: string | null | undefined
  ): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/{objectType}/Import'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = new FormData()
    if (contentType !== null && contentType !== undefined) content_.append('ContentType', contentType.toString())
    if (contentDisposition !== null && contentDisposition !== undefined) content_.append('ContentDisposition', contentDisposition.toString())
    if (headers !== null && headers !== undefined) content_.append('Headers', headers.toString())
    if (length !== null && length !== undefined) content_.append('Length', length.toString())
    if (name !== null && name !== undefined) content_.append('Name', name.toString())
    if (fileName !== null && fileName !== undefined) content_.append('FileName', fileName.toString())

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewImport(_response)
      })
  }

  protected processDataViewImport(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @param contentType (optional)
   * @param contentDisposition (optional)
   * @param headers (optional)
   * @param length (optional)
   * @param name (optional)
   * @param fileName (optional)
   * @return Success
   */
  dataViewImport2(
    objectType: string,
    contentType: string | null | undefined,
    contentDisposition: string | null | undefined,
    headers: string | null | undefined,
    length: number | null | undefined,
    name: string | null | undefined,
    fileName: string | null | undefined
  ): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/CustomObject({objectType})/Import'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = new FormData()
    if (contentType !== null && contentType !== undefined) content_.append('ContentType', contentType.toString())
    if (contentDisposition !== null && contentDisposition !== undefined) content_.append('ContentDisposition', contentDisposition.toString())
    if (headers !== null && headers !== undefined) content_.append('Headers', headers.toString())
    if (length !== null && length !== undefined) content_.append('Length', length.toString())
    if (name !== null && name !== undefined) content_.append('Name', name.toString())
    if (fileName !== null && fileName !== undefined) content_.append('FileName', fileName.toString())

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewImport2(_response)
      })
  }

  protected processDataViewImport2(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  lookupById(id: string, body: DataViewRequest | null | undefined): Promise<ReferenceValue[]> {
    let url_ = this.baseUrl + '/api/v1/CustomObject({id})/Lookup'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processLookupById(_response)
      })
  }

  protected processLookupById(response: Response): Promise<ReferenceValue[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(ReferenceValue.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ReferenceValue[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  lookupByName(objectType: string, body: DataViewRequest | null | undefined): Promise<ReferenceValue[]> {
    let url_ = this.baseUrl + '/api/v1/CustomObject({objectType})/Lookup'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processLookupByName(_response)
      })
  }

  protected processLookupByName(response: Response): Promise<ReferenceValue[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(ReferenceValue.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ReferenceValue[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  lookupByName2(objectType: string, body: DataViewRequest | null | undefined): Promise<ReferenceValue[]> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/{objectType}/Lookup'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processLookupByName2(_response)
      })
  }

  protected processLookupByName2(response: Response): Promise<ReferenceValue[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(ReferenceValue.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ReferenceValue[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  editFormOnAction(objectType: string, body: DataFormActionRequest | null | undefined): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/{objectType}/DataForm'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processEditFormOnAction(_response)
      })
  }

  protected processEditFormOnAction(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getEditForm(objectType: string, id: string | null | undefined, formName: any): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/{objectType}/DataForm?'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (formName === undefined || formName === null) throw new Error("The parameter 'formName' must be defined.")
    url_ = url_.replace('{formName}', encodeURIComponent('' + formName))
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetEditForm(_response)
      })
  }

  protected processGetEditForm(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  editFormOnAction2(objectType: string, formName: string, body: DataFormActionRequest | null | undefined): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/{objectType}/{formName}/DataForm'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (formName === undefined || formName === null) throw new Error("The parameter 'formName' must be defined.")
    url_ = url_.replace('{formName}', encodeURIComponent('' + formName))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processEditFormOnAction2(_response)
      })
  }

  protected processEditFormOnAction2(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getEditForm2(objectType: string, id: string | null | undefined, formName: any): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/{objectType}/{formName}/DataForm?'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (formName === undefined || formName === null) throw new Error("The parameter 'formName' must be defined.")
    url_ = url_.replace('{formName}', encodeURIComponent('' + formName))
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetEditForm2(_response)
      })
  }

  protected processGetEditForm2(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  editFormOnAction3(objectType: string, body: DataFormActionRequest | null | undefined): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/CustomObject({objectType})/DataForm'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processEditFormOnAction3(_response)
      })
  }

  protected processEditFormOnAction3(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getEditForm3(objectType: string, id: string | null | undefined, formName: any): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/CustomObject({objectType})/DataForm?'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (formName === undefined || formName === null) throw new Error("The parameter 'formName' must be defined.")
    url_ = url_.replace('{formName}', encodeURIComponent('' + formName))
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetEditForm3(_response)
      })
  }

  protected processGetEditForm3(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  editFormOnAction4(objectType: string, formName: string, body: DataFormActionRequest | null | undefined): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/CustomObject({objectType})/{formName}/DataForm'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (formName === undefined || formName === null) throw new Error("The parameter 'formName' must be defined.")
    url_ = url_.replace('{formName}', encodeURIComponent('' + formName))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processEditFormOnAction4(_response)
      })
  }

  protected processEditFormOnAction4(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getEditForm4(objectType: string, id: string | null | undefined, formName: any): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/CustomObject({objectType})/{formName}/DataForm?'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (formName === undefined || formName === null) throw new Error("The parameter 'formName' must be defined.")
    url_ = url_.replace('{formName}', encodeURIComponent('' + formName))
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetEditForm4(_response)
      })
  }

  protected processGetEditForm4(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  editFormOnAction5(objectType: string, id: string, body: DataFormActionRequest | null | undefined): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/{objectType}({id})/DataForm'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processEditFormOnAction5(_response)
      })
  }

  protected processEditFormOnAction5(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @return Success
   */
  getEditFormUsingRoute(objectType: string, id: string, formName: any): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/{objectType}({id})/DataForm'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (formName === undefined || formName === null) throw new Error("The parameter 'formName' must be defined.")
    url_ = url_.replace('{formName}', encodeURIComponent('' + formName))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetEditFormUsingRoute(_response)
      })
  }

  protected processGetEditFormUsingRoute(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  editFormOnAction6(objectType: string, id: string, formName: string, body: DataFormActionRequest | null | undefined): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/{objectType}({id})/{formName}/DataForm'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (formName === undefined || formName === null) throw new Error("The parameter 'formName' must be defined.")
    url_ = url_.replace('{formName}', encodeURIComponent('' + formName))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processEditFormOnAction6(_response)
      })
  }

  protected processEditFormOnAction6(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @return Success
   */
  getEditFormUsingRoute2(objectType: string, id: string, formName: any): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/{objectType}({id})/{formName}/DataForm'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (formName === undefined || formName === null) throw new Error("The parameter 'formName' must be defined.")
    url_ = url_.replace('{formName}', encodeURIComponent('' + formName))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetEditFormUsingRoute2(_response)
      })
  }

  protected processGetEditFormUsingRoute2(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  lookupById2(id: string, body: DataViewRequest | null | undefined): Promise<ReferenceValue[]> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/Tags({id})/Lookup'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processLookupById2(_response)
      })
  }

  protected processLookupById2(response: Response): Promise<ReferenceValue[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(ReferenceValue.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ReferenceValue[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  lookupByName3(objectType: string, body: DataViewRequest | null | undefined): Promise<ReferenceValue[]> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/Tags({objectType})/Lookup'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processLookupByName3(_response)
      })
  }

  protected processLookupByName3(response: Response): Promise<ReferenceValue[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(ReferenceValue.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ReferenceValue[]>(null as any)
  }

  /**
   * @return Success
   */
  getObjectPage(objectType: string, id: string): Promise<LayoutPage> {
    let url_ = this.baseUrl + '/api/v1/CustomObject/{objectType}({id})/DataPage'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetObjectPage(_response)
      })
  }

  protected processGetObjectPage(response: Response): Promise<LayoutPage> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = LayoutPage.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<LayoutPage>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  dataView3(body: DataViewRequest | null | undefined): Promise<IDataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/EmailInbox/DataView'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataView3(_response)
      })
  }

  protected processDataView3(response: Response): Promise<IDataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = IDataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IDataViewResponse>(null as any)
  }

  /**
   * @param contentType (optional)
   * @param contentDisposition (optional)
   * @param headers (optional)
   * @param length (optional)
   * @param name (optional)
   * @param fileName (optional)
   * @return Success
   */
  dataViewImportById3(
    contentType: string | null | undefined,
    contentDisposition: string | null | undefined,
    headers: string | null | undefined,
    length: number | null | undefined,
    name: string | null | undefined,
    fileName: string | null | undefined
  ): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/EmailInbox/Import'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = new FormData()
    if (contentType !== null && contentType !== undefined) content_.append('ContentType', contentType.toString())
    if (contentDisposition !== null && contentDisposition !== undefined) content_.append('ContentDisposition', contentDisposition.toString())
    if (headers !== null && headers !== undefined) content_.append('Headers', headers.toString())
    if (length !== null && length !== undefined) content_.append('Length', length.toString())
    if (name !== null && name !== undefined) content_.append('Name', name.toString())
    if (fileName !== null && fileName !== undefined) content_.append('FileName', fileName.toString())

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataViewImportById3(_response)
      })
  }

  protected processDataViewImportById3(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @return Success
   */
  getForUser(): Promise<EntityIntegration[]> {
    let url_ = this.baseUrl + '/api/v1/Entity/Integration'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetForUser(_response)
      })
  }

  protected processGetForUser(response: Response): Promise<EntityIntegration[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(EntityIntegration.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<EntityIntegration[]>(null as any)
  }

  /**
   * @return Success
   */
  getFlowEventTypes(id: string): Promise<EventType[]> {
    let url_ = this.baseUrl + '/api/v1/Flow({id})/EventType'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetFlowEventTypes(_response)
      })
  }

  protected processGetFlowEventTypes(response: Response): Promise<EventType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(EventType.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<EventType[]>(null as any)
  }

  /**
   * @return Success
   */
  getAll3(): Promise<ApiModel[]> {
    let url_ = this.baseUrl + '/api/v1/EventType'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAll3(_response)
      })
  }

  protected processGetAll3(response: Response): Promise<ApiModel[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(ApiModel.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create2(body: EventType | null | undefined): Promise<ApiModel> {
    let url_ = this.baseUrl + '/api/v1/EventType'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processCreate2(_response)
      })
  }

  protected processCreate2(response: Response): Promise<ApiModel> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ApiModel.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel>(null as any)
  }

  /**
   * @return Success
   */
  getById4(id: string): Promise<ApiModel> {
    let url_ = this.baseUrl + '/api/v1/EventType({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetById4(_response)
      })
  }

  protected processGetById4(response: Response): Promise<ApiModel> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ApiModel.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel>(null as any)
  }

  /**
   * @return Success
   */
  deleteById(id: string): Promise<ApiModel> {
    let url_ = this.baseUrl + '/api/v1/EventType({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDeleteById(_response)
      })
  }

  protected processDeleteById(response: Response): Promise<ApiModel> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ApiModel.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateId(id: string, body: EventType | null | undefined): Promise<ApiModel> {
    let url_ = this.baseUrl + '/api/v1/EventType({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpdateId(_response)
      })
  }

  protected processUpdateId(response: Response): Promise<ApiModel> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ApiModel.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel>(null as any)
  }

  /**
   * @return Success
   */
  getOrganizationTerritories(): Promise<any[]> {
    let url_ = this.baseUrl + '/api/v1/External/OrganizationTerritory'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrganizationTerritories(_response)
      })
  }

  protected processGetOrganizationTerritories(response: Response): Promise<any[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(item)
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<any[]>(null as any)
  }

  /**
   * @return Success
   */
  exportData(name: string): Promise<any[]> {
    let url_ = this.baseUrl + '/api/v1/External/{name}'
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processExportData(_response)
      })
  }

  protected processExportData(response: Response): Promise<any[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(item)
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<any[]>(null as any)
  }

  /**
   * @return Success
   */
  testExportData(clientId: string, name: string): Promise<any[]> {
    let url_ = this.baseUrl + '/api/v1/External/{clientId}/{name}'
    if (clientId === undefined || clientId === null) throw new Error("The parameter 'clientId' must be defined.")
    url_ = url_.replace('{clientId}', encodeURIComponent('' + clientId))
    if (name === undefined || name === null) throw new Error("The parameter 'name' must be defined.")
    url_ = url_.replace('{name}', encodeURIComponent('' + name))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processTestExportData(_response)
      })
  }

  protected processTestExportData(response: Response): Promise<any[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(item)
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<any[]>(null as any)
  }

  /**
   * @return Success
   */
  getFieldTypes(): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Field'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetFieldTypes(_response)
      })
  }

  protected processGetFieldTypes(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  getFieldType(type: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Field({type})'
    if (type === undefined || type === null) throw new Error("The parameter 'type' must be defined.")
    url_ = url_.replace('{type}', encodeURIComponent('' + type))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetFieldType(_response)
      })
  }

  protected processGetFieldType(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  getEvents(id: string): Promise<FlowStep[]> {
    let url_ = this.baseUrl + '/api/v1/Flow({id})/Steps'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetEvents(_response)
      })
  }

  protected processGetEvents(response: Response): Promise<FlowStep[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(FlowStep.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<FlowStep[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addEvent(id: string, body: FlowStepUpdate | null | undefined): Promise<FlowStep> {
    let url_ = this.baseUrl + '/api/v1/Flow({id})/Step'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAddEvent(_response)
      })
  }

  protected processAddEvent(response: Response): Promise<FlowStep> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = FlowStep.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<FlowStep>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateStep(id: string, stepId: string, body: FlowStepUpdate | null | undefined): Promise<FlowStep> {
    let url_ = this.baseUrl + '/api/v1/Flow({id})/Step({stepId})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (stepId === undefined || stepId === null) throw new Error("The parameter 'stepId' must be defined.")
    url_ = url_.replace('{stepId}', encodeURIComponent('' + stepId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpdateStep(_response)
      })
  }

  protected processUpdateStep(response: Response): Promise<FlowStep> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = FlowStep.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<FlowStep>(null as any)
  }

  /**
   * @return Success
   */
  deleteStep(id: string, stepId: string): Promise<FlowStep> {
    let url_ = this.baseUrl + '/api/v1/Flow({id})/Step({stepId})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (stepId === undefined || stepId === null) throw new Error("The parameter 'stepId' must be defined.")
    url_ = url_.replace('{stepId}', encodeURIComponent('' + stepId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDeleteStep(_response)
      })
  }

  protected processDeleteStep(response: Response): Promise<FlowStep> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = FlowStep.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<FlowStep>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  lookup(id: string, objectType: string, body: DataViewRequest | null | undefined): Promise<ReferenceValue[]> {
    let url_ = this.baseUrl + '/api/v1/Flow({id})/{objectType}/Lookup'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processLookup(_response)
      })
  }

  protected processLookup(response: Response): Promise<ReferenceValue[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(ReferenceValue.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ReferenceValue[]>(null as any)
  }

  /**
   * @return Success
   */
  getAll4(): Promise<ApiModel[]> {
    let url_ = this.baseUrl + '/api/v1/Flow'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAll4(_response)
      })
  }

  protected processGetAll4(response: Response): Promise<ApiModel[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(ApiModel.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create3(body: Flow | null | undefined): Promise<ApiModel> {
    let url_ = this.baseUrl + '/api/v1/Flow'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processCreate3(_response)
      })
  }

  protected processCreate3(response: Response): Promise<ApiModel> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ApiModel.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel>(null as any)
  }

  /**
   * @return Success
   */
  getById5(id: string): Promise<ApiModel> {
    let url_ = this.baseUrl + '/api/v1/Flow({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetById5(_response)
      })
  }

  protected processGetById5(response: Response): Promise<ApiModel> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ApiModel.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel>(null as any)
  }

  /**
   * @return Success
   */
  deleteById2(id: string): Promise<ApiModel> {
    let url_ = this.baseUrl + '/api/v1/Flow({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDeleteById2(_response)
      })
  }

  protected processDeleteById2(response: Response): Promise<ApiModel> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ApiModel.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateId2(id: string, body: Flow | null | undefined): Promise<ApiModel> {
    let url_ = this.baseUrl + '/api/v1/Flow({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpdateId2(_response)
      })
  }

  protected processUpdateId2(response: Response): Promise<ApiModel> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ApiModel.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel>(null as any)
  }

  /**
   * @return Success
   */
  getAll5(): Promise<FlowAction[]> {
    let url_ = this.baseUrl + '/api/v1/FlowActions'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAll5(_response)
      })
  }

  protected processGetAll5(response: Response): Promise<FlowAction[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(FlowAction.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<FlowAction[]>(null as any)
  }

  /**
   * @return Success
   */
  getFlowActionsForEventType(flowId: string, eventTypeId: string): Promise<FlowAction[]> {
    let url_ = this.baseUrl + '/api/v1/Flow({flowId})/EventType({eventTypeId})/FlowActions'
    if (flowId === undefined || flowId === null) throw new Error("The parameter 'flowId' must be defined.")
    url_ = url_.replace('{flowId}', encodeURIComponent('' + flowId))
    if (eventTypeId === undefined || eventTypeId === null) throw new Error("The parameter 'eventTypeId' must be defined.")
    url_ = url_.replace('{eventTypeId}', encodeURIComponent('' + eventTypeId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetFlowActionsForEventType(_response)
      })
  }

  protected processGetFlowActionsForEventType(response: Response): Promise<FlowAction[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(FlowAction.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<FlowAction[]>(null as any)
  }

  /**
   * @return Success
   * @deprecated
   */
  getActionsForEventType(id: string): Promise<FlowAction[]> {
    let url_ = this.baseUrl + '/api/v1/EventType({id})/FlowActions'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetActionsForEventType(_response)
      })
  }

  protected processGetActionsForEventType(response: Response): Promise<FlowAction[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(FlowAction.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<FlowAction[]>(null as any)
  }

  /**
   * @param eventTriggerId (optional)
   * @return Success
   */
  getFlowForm(flowId: string, id: string, eventTriggerId: string | null | undefined): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/Flow({flowId})/FlowActions({id})/Form?'
    if (flowId === undefined || flowId === null) throw new Error("The parameter 'flowId' must be defined.")
    url_ = url_.replace('{flowId}', encodeURIComponent('' + flowId))
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (eventTriggerId !== undefined && eventTriggerId !== null) url_ += 'eventTriggerId=' + encodeURIComponent('' + eventTriggerId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetFlowForm(_response)
      })
  }

  protected processGetFlowForm(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @return Success
   */
  getFlowTransition(flowId: string, entityId: string, tag: string): Promise<FlowTransition> {
    let url_ = this.baseUrl + '/api/v1/Flow({flowId})/Entity({entityId})/FlowTransition({tag})'
    if (flowId === undefined || flowId === null) throw new Error("The parameter 'flowId' must be defined.")
    url_ = url_.replace('{flowId}', encodeURIComponent('' + flowId))
    if (entityId === undefined || entityId === null) throw new Error("The parameter 'entityId' must be defined.")
    url_ = url_.replace('{entityId}', encodeURIComponent('' + entityId))
    if (tag === undefined || tag === null) throw new Error("The parameter 'tag' must be defined.")
    url_ = url_.replace('{tag}', encodeURIComponent('' + tag))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetFlowTransition(_response)
      })
  }

  protected processGetFlowTransition(response: Response): Promise<FlowTransition> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = FlowTransition.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<FlowTransition>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addFlowTransition(flowId: string, entityId: string, tag: string, body: FlowTransition | null | undefined): Promise<FlowTransition> {
    let url_ = this.baseUrl + '/api/v1/Flow({flowId})/Entity({entityId})/FlowTransition({tag})'
    if (flowId === undefined || flowId === null) throw new Error("The parameter 'flowId' must be defined.")
    url_ = url_.replace('{flowId}', encodeURIComponent('' + flowId))
    if (entityId === undefined || entityId === null) throw new Error("The parameter 'entityId' must be defined.")
    url_ = url_.replace('{entityId}', encodeURIComponent('' + entityId))
    if (tag === undefined || tag === null) throw new Error("The parameter 'tag' must be defined.")
    url_ = url_.replace('{tag}', encodeURIComponent('' + tag))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAddFlowTransition(_response)
      })
  }

  protected processAddFlowTransition(response: Response): Promise<FlowTransition> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = FlowTransition.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<FlowTransition>(null as any)
  }

  /**
   * @return Success
   */
  deleteFlowTransition(flowId: string, entityId: string, tag: string): Promise<FlowTransition> {
    let url_ = this.baseUrl + '/api/v1/Flow({flowId})/Entity({entityId})/FlowTransition({tag})'
    if (flowId === undefined || flowId === null) throw new Error("The parameter 'flowId' must be defined.")
    url_ = url_.replace('{flowId}', encodeURIComponent('' + flowId))
    if (entityId === undefined || entityId === null) throw new Error("The parameter 'entityId' must be defined.")
    url_ = url_.replace('{entityId}', encodeURIComponent('' + entityId))
    if (tag === undefined || tag === null) throw new Error("The parameter 'tag' must be defined.")
    url_ = url_.replace('{tag}', encodeURIComponent('' + tag))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDeleteFlowTransition(_response)
      })
  }

  protected processDeleteFlowTransition(response: Response): Promise<FlowTransition> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = FlowTransition.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<FlowTransition>(null as any)
  }

  /**
   * @return Success
   */
  identity(): Promise<Identity[]> {
    let url_ = this.baseUrl + '/api/v1/Identity'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processIdentity(_response)
      })
  }

  protected processIdentity(response: Response): Promise<Identity[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(Identity.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Identity[]>(null as any)
  }

  /**
   * @return Success
   */
  identityTrunk(): Promise<TrunkIdentity[]> {
    let url_ = this.baseUrl + '/api/v1/Identity/Trunk'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processIdentityTrunk(_response)
      })
  }

  protected processIdentityTrunk(response: Response): Promise<TrunkIdentity[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(TrunkIdentity.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<TrunkIdentity[]>(null as any)
  }

  /**
   * @return Success
   */
  getIdentity(provider: any): Promise<Identity[]> {
    let url_ = this.baseUrl + '/api/v1/Identity@{provider}'
    if (provider === undefined || provider === null) throw new Error("The parameter 'provider' must be defined.")
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetIdentity(_response)
      })
  }

  protected processGetIdentity(response: Response): Promise<Identity[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(Identity.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Identity[]>(null as any)
  }

  /**
   * @return Success
   */
  findIdentity(provider: any, externalId: string): Promise<Identity[]> {
    let url_ = this.baseUrl + '/api/v1/Identity({externalId})@{provider}'
    if (provider === undefined || provider === null) throw new Error("The parameter 'provider' must be defined.")
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider))
    if (externalId === undefined || externalId === null) throw new Error("The parameter 'externalId' must be defined.")
    url_ = url_.replace('{externalId}', encodeURIComponent('' + externalId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processFindIdentity(_response)
      })
  }

  protected processFindIdentity(response: Response): Promise<Identity[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(Identity.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Identity[]>(null as any)
  }

  /**
   * @return Success
   */
  getAll6(): Promise<AppIntegration[]> {
    let url_ = this.baseUrl + '/api/v1/Integration'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAll6(_response)
      })
  }

  protected processGetAll6(response: Response): Promise<AppIntegration[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(AppIntegration.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppIntegration[]>(null as any)
  }

  /**
   * @return Success
   */
  getSelectedIntegrations(): Promise<AppIntegration[]> {
    let url_ = this.baseUrl + '/api/v1/Integration[Selected]'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetSelectedIntegrations(_response)
      })
  }

  protected processGetSelectedIntegrations(response: Response): Promise<AppIntegration[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(AppIntegration.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppIntegration[]>(null as any)
  }

  /**
   * @return Success
   */
  getIntegrationsForEntity(id: string): Promise<AppIntegration[]> {
    let url_ = this.baseUrl + '/api/v1/Entity({id})/Integration'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetIntegrationsForEntity(_response)
      })
  }

  protected processGetIntegrationsForEntity(response: Response): Promise<AppIntegration[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(AppIntegration.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppIntegration[]>(null as any)
  }

  /**
   * @return Success
   */
  getEntityIntegrations(): Promise<AppIntegration[]> {
    let url_ = this.baseUrl + '/api/v1/User/Integration'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetEntityIntegrations(_response)
      })
  }

  protected processGetEntityIntegrations(response: Response): Promise<AppIntegration[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(AppIntegration.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppIntegration[]>(null as any)
  }

  /**
   * @return Success
   */
  getOrganizationIntegrations(): Promise<AppIntegration[]> {
    let url_ = this.baseUrl + '/api/v1/Organization/Integration'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrganizationIntegrations(_response)
      })
  }

  protected processGetOrganizationIntegrations(response: Response): Promise<AppIntegration[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(AppIntegration.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppIntegration[]>(null as any)
  }

  /**
   * @return Success
   */
  getAppointmentTypeIntegrations(id: string): Promise<AppIntegration[]> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType({id})/Integration'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAppointmentTypeIntegrations(_response)
      })
  }

  protected processGetAppointmentTypeIntegrations(response: Response): Promise<AppIntegration[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(AppIntegration.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppIntegration[]>(null as any)
  }

  /**
   * @return Success
   */
  getLeadTypeIntegrations(id: string): Promise<AppIntegration[]> {
    let url_ = this.baseUrl + '/api/v1/LeadType({id})/Integration'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetLeadTypeIntegrations(_response)
      })
  }

  protected processGetLeadTypeIntegrations(response: Response): Promise<AppIntegration[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(AppIntegration.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppIntegration[]>(null as any)
  }

  /**
   * @return Success
   */
  removeAppointmentTypeIntegration(id: string, serviceName: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType({id})/Integration({serviceName})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (serviceName === undefined || serviceName === null) throw new Error("The parameter 'serviceName' must be defined.")
    url_ = url_.replace('{serviceName}', encodeURIComponent('' + serviceName))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processRemoveAppointmentTypeIntegration(_response)
      })
  }

  protected processRemoveAppointmentTypeIntegration(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  removeLeadTypeIntegration(id: string, serviceName: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/LeadType({id})/Integration({serviceName})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (serviceName === undefined || serviceName === null) throw new Error("The parameter 'serviceName' must be defined.")
    url_ = url_.replace('{serviceName}', encodeURIComponent('' + serviceName))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processRemoveLeadTypeIntegration(_response)
      })
  }

  protected processRemoveLeadTypeIntegration(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  updateUrls(): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Integration/Salesforce/UpdateUrls'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpdateUrls(_response)
      })
  }

  protected processUpdateUrls(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  getIntegrations(id: string): Promise<AppointmentIntegration[]> {
    let url_ = this.baseUrl + '/api/v1/Appointment({id})/Integration'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetIntegrations(_response)
      })
  }

  protected processGetIntegrations(response: Response): Promise<AppointmentIntegration[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(AppointmentIntegration.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentIntegration[]>(null as any)
  }

  /**
   * @return Success
   */
  getIntegrations2(id: string): Promise<LeadIntegration[]> {
    let url_ = this.baseUrl + '/api/v1/Lead({id})/Integration'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetIntegrations2(_response)
      })
  }

  protected processGetIntegrations2(response: Response): Promise<LeadIntegration[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(LeadIntegration.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<LeadIntegration[]>(null as any)
  }

  /**
   * @return Success
   */
  get(id: string): Promise<Leads> {
    let url_ = this.baseUrl + '/api/v1/Lead({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGet(_response)
      })
  }

  protected processGet(response: Response): Promise<Leads> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Leads.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Leads>(null as any)
  }

  /**
   * @return Success
   */
  getByType(id: string): Promise<Leads> {
    let url_ = this.baseUrl + '/api/v1/LeadType({id})/Lead'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetByType(_response)
      })
  }

  protected processGetByType(response: Response): Promise<Leads> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Leads.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Leads>(null as any)
  }

  /**
   * @return Success
   */
  upsertLead(id: string, body: string): Promise<Leads> {
    let url_ = this.baseUrl + '/api/v1/LeadType({id})/Lead'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'plain/text',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpsertLead(_response)
      })
  }

  protected processUpsertLead(response: Response): Promise<Leads> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Leads.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Leads>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  search(body: Search | null | undefined): Promise<LeadSearchResults> {
    let url_ = this.baseUrl + '/api/v1/Lead/search'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processSearch(_response)
      })
  }

  protected processSearch(response: Response): Promise<LeadSearchResults> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = LeadSearchResults.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<LeadSearchResults>(null as any)
  }

  /**
   * @param integrationId (optional)
   * @param externalId (optional)
   * @return Success
   */
  merge(integrationId: string | null | undefined, externalId: string | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Lead/Merge?'
    if (integrationId !== undefined && integrationId !== null) url_ += 'integrationId=' + encodeURIComponent('' + integrationId) + '&'
    if (externalId !== undefined && externalId !== null) url_ += 'externalId=' + encodeURIComponent('' + externalId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processMerge(_response)
      })
  }

  protected processMerge(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  getEditForm5(objectType: string, id: string): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/Lead({id})/Preview/DataForm'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetEditForm5(_response)
      })
  }

  protected processGetEditForm5(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateIntegration(id: string, integrationId: string, body: IntegrationEvent | null | undefined): Promise<IntegrationEvent> {
    let url_ = this.baseUrl + '/api/v1/Lead({id})/Integration({integrationId})/event'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (integrationId === undefined || integrationId === null) throw new Error("The parameter 'integrationId' must be defined.")
    url_ = url_.replace('{integrationId}', encodeURIComponent('' + integrationId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpdateIntegration(_response)
      })
  }

  protected processUpdateIntegration(response: Response): Promise<IntegrationEvent> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = IntegrationEvent.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IntegrationEvent>(null as any)
  }

  /**
   * @return Success
   */
  getAll7(): Promise<ApiModel[]> {
    let url_ = this.baseUrl + '/api/v1/LeadStatus'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAll7(_response)
      })
  }

  protected processGetAll7(response: Response): Promise<ApiModel[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(ApiModel.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create4(body: LeadStatus | null | undefined): Promise<ApiModel> {
    let url_ = this.baseUrl + '/api/v1/LeadStatus'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processCreate4(_response)
      })
  }

  protected processCreate4(response: Response): Promise<ApiModel> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ApiModel.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel>(null as any)
  }

  /**
   * @return Success
   */
  getById6(id: string): Promise<ApiModel> {
    let url_ = this.baseUrl + '/api/v1/LeadStatus({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetById6(_response)
      })
  }

  protected processGetById6(response: Response): Promise<ApiModel> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ApiModel.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel>(null as any)
  }

  /**
   * @return Success
   */
  deleteById3(id: string): Promise<ApiModel> {
    let url_ = this.baseUrl + '/api/v1/LeadStatus({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDeleteById3(_response)
      })
  }

  protected processDeleteById3(response: Response): Promise<ApiModel> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ApiModel.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateId3(id: string, body: LeadStatus | null | undefined): Promise<ApiModel> {
    let url_ = this.baseUrl + '/api/v1/LeadStatus({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpdateId3(_response)
      })
  }

  protected processUpdateId3(response: Response): Promise<ApiModel> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ApiModel.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ApiModel>(null as any)
  }

  /**
   * @return Success
   */
  getById7(id: string): Promise<LeadType> {
    let url_ = this.baseUrl + '/api/v1/LeadType({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetById7(_response)
      })
  }

  protected processGetById7(response: Response): Promise<LeadType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = LeadType.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<LeadType>(null as any)
  }

  /**
   * @return Success
   */
  delete2(id: string): Promise<LeadType> {
    let url_ = this.baseUrl + '/api/v1/LeadType({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDelete2(_response)
      })
  }

  protected processDelete2(response: Response): Promise<LeadType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = LeadType.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<LeadType>(null as any)
  }

  /**
   * @param name (optional)
   * @param flowId (optional)
   * @return Success
   */
  update(id: string, name: string | null | undefined, flowId: string | null | undefined): Promise<LeadType> {
    let url_ = this.baseUrl + '/api/v1/LeadType({id})?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (name !== undefined && name !== null) url_ += 'name=' + encodeURIComponent('' + name) + '&'
    if (flowId !== undefined && flowId !== null) url_ += 'flowId=' + encodeURIComponent('' + flowId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpdate(_response)
      })
  }

  protected processUpdate(response: Response): Promise<LeadType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = LeadType.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<LeadType>(null as any)
  }

  /**
   * @return Success
   */
  getMapping(id: string): Promise<LeadTypeSettings> {
    let url_ = this.baseUrl + '/api/v1/LeadType({id})/Mapping'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetMapping(_response)
      })
  }

  protected processGetMapping(response: Response): Promise<LeadTypeSettings> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = LeadTypeSettings.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<LeadTypeSettings>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addMapping(id: string, body: LeadTypeSettings | null | undefined): Promise<LeadTypeSettings> {
    let url_ = this.baseUrl + '/api/v1/LeadType({id})/Mapping'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAddMapping(_response)
      })
  }

  protected processAddMapping(response: Response): Promise<LeadTypeSettings> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = LeadTypeSettings.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<LeadTypeSettings>(null as any)
  }

  /**
   * @return Success
   */
  calculateMapping(id: string): Promise<LeadTypeSettings> {
    let url_ = this.baseUrl + '/api/v1/LeadType({id})/Mapping/Refresh'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processCalculateMapping(_response)
      })
  }

  protected processCalculateMapping(response: Response): Promise<LeadTypeSettings> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = LeadTypeSettings.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<LeadTypeSettings>(null as any)
  }

  /**
   * @return Success
   */
  getAll8(): Promise<IEntityMetadata[]> {
    let url_ = this.baseUrl + '/api/v1/MetaData'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAll8(_response)
      })
  }

  protected processGetAll8(response: Response): Promise<IEntityMetadata[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(IEntityMetadata.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IEntityMetadata[]>(null as any)
  }

  /**
   * @return Success
   */
  getByOrganization(id: string): Promise<IEntityMetadata[]> {
    let url_ = this.baseUrl + '/api/v1/Organization({id})/MetaData'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetByOrganization(_response)
      })
  }

  protected processGetByOrganization(response: Response): Promise<IEntityMetadata[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(IEntityMetadata.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IEntityMetadata[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  deleteFromOrganization(id: string, body: EntityMetadata[] | null | undefined): Promise<IEntityMetadata[]> {
    let url_ = this.baseUrl + '/api/v1/Organization({id})/MetaData'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDeleteFromOrganization(_response)
      })
  }

  protected processDeleteFromOrganization(response: Response): Promise<IEntityMetadata[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(IEntityMetadata.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IEntityMetadata[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  upsertToOrganization(id: string, body: EntityMetadata[] | null | undefined): Promise<IEntityMetadata[]> {
    let url_ = this.baseUrl + '/api/v1/Organization({id})/MetaData'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpsertToOrganization(_response)
      })
  }

  protected processUpsertToOrganization(response: Response): Promise<IEntityMetadata[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(IEntityMetadata.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<IEntityMetadata[]>(null as any)
  }

  /**
   * @return Success
   */
  getAll9(objectType: string): Promise<ObjectStatus[]> {
    let url_ = this.baseUrl + '/api/v1/{objectType}/ObjectStatus'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAll9(_response)
      })
  }

  protected processGetAll9(response: Response): Promise<ObjectStatus[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(ObjectStatus.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ObjectStatus[]>(null as any)
  }

  /**
   * @return Success
   */
  getAll10(): Promise<ObjectStatus[]> {
    let url_ = this.baseUrl + '/api/v1/ObjectStatus'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAll10(_response)
      })
  }

  protected processGetAll10(response: Response): Promise<ObjectStatus[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(ObjectStatus.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ObjectStatus[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create5(body: ObjectStatus | null | undefined): Promise<ObjectStatus> {
    let url_ = this.baseUrl + '/api/v1/ObjectStatus'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processCreate5(_response)
      })
  }

  protected processCreate5(response: Response): Promise<ObjectStatus> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ObjectStatus.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ObjectStatus>(null as any)
  }

  /**
   * @return Success
   */
  getById8(id: string): Promise<ObjectStatus> {
    let url_ = this.baseUrl + '/api/v1/ObjectStatus({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetById8(_response)
      })
  }

  protected processGetById8(response: Response): Promise<ObjectStatus> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ObjectStatus.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ObjectStatus>(null as any)
  }

  /**
   * @return Success
   */
  deleteById4(id: string): Promise<ObjectStatus> {
    let url_ = this.baseUrl + '/api/v1/ObjectStatus({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDeleteById4(_response)
      })
  }

  protected processDeleteById4(response: Response): Promise<ObjectStatus> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ObjectStatus.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ObjectStatus>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  replace(id: string, body: ObjectStatus | null | undefined): Promise<ObjectStatus> {
    let url_ = this.baseUrl + '/api/v1/ObjectStatus({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processReplace(_response)
      })
  }

  protected processReplace(response: Response): Promise<ObjectStatus> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ObjectStatus.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ObjectStatus>(null as any)
  }

  /**
   * @return Success
   */
  getObjectTypeById(objectType: string): Promise<ObjectType> {
    let url_ = this.baseUrl + '/api/v1/ObjectType/{objectType}'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetObjectTypeById(_response)
      })
  }

  protected processGetObjectTypeById(response: Response): Promise<ObjectType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ObjectType.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ObjectType>(null as any)
  }

  /**
   * @return Success
   */
  getObjectTypeById2(id: string, objectType: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/ObjectType/{objectType}({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetObjectTypeById2(_response)
      })
  }

  protected processGetObjectTypeById2(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  dataView4(body: DataViewRequest | null | undefined): Promise<DataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/ObjectType/DataView'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataView4(_response)
      })
  }

  protected processDataView4(response: Response): Promise<DataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataViewResponse>(null as any)
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getEditForm6(id: string | null | undefined): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/ObjectType/DataForm?'
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetEditForm6(_response)
      })
  }

  protected processGetEditForm6(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  editFormOnAction7(body: DataFormActionRequest | null | undefined): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/ObjectType/DataForm'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processEditFormOnAction7(_response)
      })
  }

  protected processEditFormOnAction7(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @param contentType (optional)
   * @param contentDisposition (optional)
   * @param headers (optional)
   * @param length (optional)
   * @param name (optional)
   * @param fileName (optional)
   * @return Success
   */
  importCsv(
    id: string,
    contentType: string | null | undefined,
    contentDisposition: string | null | undefined,
    headers: string | null | undefined,
    length: number | null | undefined,
    name: string | null | undefined,
    fileName: string | null | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/ObjectType({id})/Import'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = new FormData()
    if (contentType !== null && contentType !== undefined) content_.append('ContentType', contentType.toString())
    if (contentDisposition !== null && contentDisposition !== undefined) content_.append('ContentDisposition', contentDisposition.toString())
    if (headers !== null && headers !== undefined) content_.append('Headers', headers.toString())
    if (length !== null && length !== undefined) content_.append('Length', length.toString())
    if (name !== null && name !== undefined) content_.append('Name', name.toString())
    if (fileName !== null && fileName !== undefined) content_.append('FileName', fileName.toString())

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processImportCsv(_response)
      })
  }

  protected processImportCsv(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  getAll11(): Promise<ObjectType[]> {
    let url_ = this.baseUrl + '/api/v1/ObjectType'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAll11(_response)
      })
  }

  protected processGetAll11(response: Response): Promise<ObjectType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(ObjectType.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ObjectType[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create6(body: ObjectType | null | undefined): Promise<ObjectType> {
    let url_ = this.baseUrl + '/api/v1/ObjectType'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processCreate6(_response)
      })
  }

  protected processCreate6(response: Response): Promise<ObjectType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ObjectType.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ObjectType>(null as any)
  }

  /**
   * @return Success
   */
  getById9(id: string): Promise<ObjectType> {
    let url_ = this.baseUrl + '/api/v1/ObjectType({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetById9(_response)
      })
  }

  protected processGetById9(response: Response): Promise<ObjectType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ObjectType.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ObjectType>(null as any)
  }

  /**
   * @return Success
   */
  deleteById5(id: string): Promise<ObjectType> {
    let url_ = this.baseUrl + '/api/v1/ObjectType({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDeleteById5(_response)
      })
  }

  protected processDeleteById5(response: Response): Promise<ObjectType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ObjectType.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ObjectType>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  replace2(id: string, body: ObjectType | null | undefined): Promise<ObjectType> {
    let url_ = this.baseUrl + '/api/v1/ObjectType({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processReplace2(_response)
      })
  }

  protected processReplace2(response: Response): Promise<ObjectType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = ObjectType.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<ObjectType>(null as any)
  }

  /**
   * @return Success
   */
  getOrganization(): Promise<Organization> {
    let url_ = this.baseUrl + '/api/v1/Organization'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrganization(_response)
      })
  }

  protected processGetOrganization(response: Response): Promise<Organization> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Organization.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Organization>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addOrganization(body: AddOrganizationRequest | null | undefined): Promise<Organization> {
    let url_ = this.baseUrl + '/api/v1/Organization'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAddOrganization(_response)
      })
  }

  protected processAddOrganization(response: Response): Promise<Organization> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Organization.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Organization>(null as any)
  }

  /**
   * @return Success
   */
  getOrganizationById(id: string): Promise<Organization> {
    let url_ = this.baseUrl + '/api/v1/Organization({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrganizationById(_response)
      })
  }

  protected processGetOrganizationById(response: Response): Promise<Organization> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Organization.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Organization>(null as any)
  }

  /**
   * @return Success
   */
  getOrganizationsByAccount(accountId: string): Promise<Organization[]> {
    let url_ = this.baseUrl + '/api/v1/Account({accountId})/Organization'
    if (accountId === undefined || accountId === null) throw new Error("The parameter 'accountId' must be defined.")
    url_ = url_.replace('{accountId}', encodeURIComponent('' + accountId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrganizationsByAccount(_response)
      })
  }

  protected processGetOrganizationsByAccount(response: Response): Promise<Organization[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(Organization.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Organization[]>(null as any)
  }

  /**
   * @return Success
   */
  getOrganizations(): Promise<Organization[]> {
    let url_ = this.baseUrl + '/api/v1/Account/Organization'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrganizations(_response)
      })
  }

  protected processGetOrganizations(response: Response): Promise<Organization[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(Organization.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Organization[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  renderReport(id: string, body: DataViewRequest | null | undefined): Promise<DataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/Report({id})/DataView'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processRenderReport(_response)
      })
  }

  protected processRenderReport(response: Response): Promise<DataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataViewResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  renderReport2(report: string, body: DataViewRequest | null | undefined): Promise<DataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/Report/{report}/DataView'
    if (report === undefined || report === null) throw new Error("The parameter 'report' must be defined.")
    url_ = url_.replace('{report}', encodeURIComponent('' + report))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processRenderReport2(_response)
      })
  }

  protected processRenderReport2(response: Response): Promise<DataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataViewResponse>(null as any)
  }

  /**
   * @return Success
   */
  redirect(leadId: string): Promise<void> {
    let url_ = this.baseUrl + '/app/Scheduler/{leadId}'
    if (leadId === undefined || leadId === null) throw new Error("The parameter 'leadId' must be defined.")
    url_ = url_.replace('{leadId}', encodeURIComponent('' + leadId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processRedirect(_response)
      })
  }

  protected processRedirect(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  initSessionForLead(): Promise<SessionConfig> {
    let url_ = this.baseUrl + '/app/Scheduler/Session/Lead'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processInitSessionForLead(_response)
      })
  }

  protected processInitSessionForLead(response: Response): Promise<SessionConfig> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = SessionConfig.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<SessionConfig>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   * @deprecated
   */
  addNote(sessionId: string, body: NoteReq | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/app/Scheduler({sessionId})/Note'
    if (sessionId === undefined || sessionId === null) throw new Error("The parameter 'sessionId' must be defined.")
    url_ = url_.replace('{sessionId}', encodeURIComponent('' + sessionId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAddNote(_response)
      })
  }

  protected processAddNote(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  getOrganizatioForSession(sessionId: string): Promise<OrganizationResp> {
    let url_ = this.baseUrl + '/app/Scheduler({sessionId})/Organization'
    if (sessionId === undefined || sessionId === null) throw new Error("The parameter 'sessionId' must be defined.")
    url_ = url_.replace('{sessionId}', encodeURIComponent('' + sessionId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrganizatioForSession(_response)
      })
  }

  protected processGetOrganizatioForSession(response: Response): Promise<OrganizationResp> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = OrganizationResp.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<OrganizationResp>(null as any)
  }

  /**
   * @return Success
   */
  initSessionByPostalCode(postalCode: string, types: string | undefined): Promise<SessionConfig> {
    let url_ = this.baseUrl + '/app/Scheduler/Session/PostalCode({postalCode})'
    if (postalCode === undefined || postalCode === null) throw new Error("The parameter 'postalCode' must be defined.")
    url_ = url_.replace('{postalCode}', encodeURIComponent('' + postalCode))
    url_ = url_.replace(/[?&]$/, '')
    if (types !== undefined && types !== null) url_ += '?types=' + encodeURIComponent(types)

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processInitSessionByPostalCode(_response)
      })
  }

  protected processInitSessionByPostalCode(response: Response): Promise<SessionConfig> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = SessionConfig.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<SessionConfig>(null as any)
  }

  /**
   * @return Success
   */
  initSessionForOrganizationGET(orgId: string): Promise<SessionConfig> {
    let url_ = this.baseUrl + '/app/Scheduler/Organization({orgId})'
    if (orgId === undefined || orgId === null) throw new Error("The parameter 'orgId' must be defined.")
    url_ = url_.replace('{orgId}', encodeURIComponent('' + orgId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processInitSessionForOrganizationGET(_response)
      })
  }

  protected processInitSessionForOrganizationGET(response: Response): Promise<SessionConfig> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = SessionConfig.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<SessionConfig>(null as any)
  }

  /**
   * @return Success
   */
  initSessionForOrganizationPOST(orgId: string): Promise<SessionConfig> {
    let url_ = this.baseUrl + '/app/Scheduler/Session/Organization({orgId})'
    if (orgId === undefined || orgId === null) throw new Error("The parameter 'orgId' must be defined.")
    url_ = url_.replace('{orgId}', encodeURIComponent('' + orgId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processInitSessionForOrganizationPOST(_response)
      })
  }

  protected processInitSessionForOrganizationPOST(response: Response): Promise<SessionConfig> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = SessionConfig.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<SessionConfig>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   * @deprecated
   */
  oldGetSlots(sessionId: string, start: Date | null | undefined, end: Date | null | undefined): Promise<TimeSlot[]> {
    let url_ = this.baseUrl + '/app/Scheduler({sessionId})/Slots?'
    if (sessionId === undefined || sessionId === null) throw new Error("The parameter 'sessionId' must be defined.")
    url_ = url_.replace('{sessionId}', encodeURIComponent('' + sessionId))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processOldGetSlots(_response)
      })
  }

  protected processOldGetSlots(response: Response): Promise<TimeSlot[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(TimeSlot.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<TimeSlot[]>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  getSlots2(sessionId: string, start: Date | null | undefined, end: Date | null | undefined, showUnavailable: boolean): Promise<SlotsResp> {
    let url_ = this.baseUrl + '/app/v1/Scheduler({sessionId})/Slots?'
    if (sessionId === undefined || sessionId === null) throw new Error("The parameter 'sessionId' must be defined.")
    url_ = url_.replace('{sessionId}', encodeURIComponent('' + sessionId))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ += 'includeUnavailable=' + showUnavailable + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetSlots2(_response)
      })
  }

  protected processGetSlots2(response: Response): Promise<SlotsResp> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = SlotsResp.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<SlotsResp>(null as any)
  }

  /**
   * @return Success
   */
  getLead(sessionId: string): Promise<Lead> {
    let url_ = this.baseUrl + '/app/Scheduler({sessionId})/Lead'
    if (sessionId === undefined || sessionId === null) throw new Error("The parameter 'sessionId' must be defined.")
    url_ = url_.replace('{sessionId}', encodeURIComponent('' + sessionId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetLead(_response)
      })
  }

  protected processGetLead(response: Response): Promise<Lead> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Lead.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Lead>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateLead(sessionId: string, body: UpdateLeadRequest | null | undefined): Promise<Lead> {
    let url_ = this.baseUrl + '/app/Scheduler({sessionId})/Lead'
    if (sessionId === undefined || sessionId === null) throw new Error("The parameter 'sessionId' must be defined.")
    url_ = url_.replace('{sessionId}', encodeURIComponent('' + sessionId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUpdateLead(_response)
      })
  }

  protected processUpdateLead(response: Response): Promise<Lead> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Lead.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Lead>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addLead(sessionId: string, leadTypeId: string, body: { [key: string]: any } | null | undefined): Promise<Lead> {
    let url_ = this.baseUrl + '/app/Scheduler({sessionId})/Lead'
    if (sessionId === undefined || sessionId === null) throw new Error("The parameter 'sessionId' must be defined.")
    url_ = url_.replace('{sessionId}', encodeURIComponent('' + sessionId))
    if (leadTypeId === undefined || leadTypeId === null) throw new Error("The parameter 'leadTypeId' must be defined.")
    url_ = url_.replace('{leadTypeId}', encodeURIComponent('' + leadTypeId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAddLead(_response)
      })
  }

  protected processAddLead(response: Response): Promise<Lead> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Lead.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Lead>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addLead2(sessionId: string, leadTypeId: string, body: { [key: string]: any } | null | undefined): Promise<Lead> {
    let url_ = this.baseUrl + '/app/Scheduler({sessionId})/Lead({leadTypeId})'
    if (sessionId === undefined || sessionId === null) throw new Error("The parameter 'sessionId' must be defined.")
    url_ = url_.replace('{sessionId}', encodeURIComponent('' + sessionId))
    if (leadTypeId === undefined || leadTypeId === null) throw new Error("The parameter 'leadTypeId' must be defined.")
    url_ = url_.replace('{leadTypeId}', encodeURIComponent('' + leadTypeId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAddLead2(_response)
      })
  }

  protected processAddLead2(response: Response): Promise<Lead> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Lead.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Lead>(null as any)
  }

  /**
   * @return Success
   */
  deleteAppointment(sessionId: string, id: string): Promise<Appointment> {
    let url_ = this.baseUrl + '/app/Scheduler({sessionId})/Appointment({id})'
    if (sessionId === undefined || sessionId === null) throw new Error("The parameter 'sessionId' must be defined.")
    url_ = url_.replace('{sessionId}', encodeURIComponent('' + sessionId))
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDeleteAppointment(_response)
      })
  }

  protected processDeleteAppointment(response: Response): Promise<Appointment> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Appointment.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Appointment>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appointment(sessionId: string, body: AppointmentReq | null | undefined): Promise<Appointment> {
    let url_ = this.baseUrl + '/app/Scheduler({sessionId})/Appointment'
    if (sessionId === undefined || sessionId === null) throw new Error("The parameter 'sessionId' must be defined.")
    url_ = url_.replace('{sessionId}', encodeURIComponent('' + sessionId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAppointment(_response)
      })
  }

  protected processAppointment(response: Response): Promise<Appointment> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Appointment.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Appointment>(null as any)
  }

  /**
   * @param value (optional)
   * @return Success
   */
  setTimeZone(value: string | null | undefined): Promise<TimeZone> {
    let url_ = this.baseUrl + '/api/v1/Setting(TimeZone)?'
    if (value !== undefined && value !== null) url_ += 'value=' + encodeURIComponent('' + value) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processSetTimeZone(_response)
      })
  }

  protected processSetTimeZone(response: Response): Promise<TimeZone> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = TimeZone.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<TimeZone>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  setWorkingHours(body: WorkingHoursSetting | null | undefined): Promise<WorkingHoursSetting> {
    let url_ = this.baseUrl + '/api/v1/Setting(WorkingHours)'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processSetWorkingHours(_response)
      })
  }

  protected processSetWorkingHours(response: Response): Promise<WorkingHoursSetting> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = WorkingHoursSetting.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<WorkingHoursSetting>(null as any)
  }

  /**
   * @return Success
   */
  calculate(): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/Statement/Recalculate'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processCalculate(_response)
      })
  }

  protected processCalculate(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  getInvoicesDataView(body: DataViewRequest | null | undefined): Promise<DataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/Statement/Invoice/DataView'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetInvoicesDataView(_response)
      })
  }

  protected processGetInvoicesDataView(response: Response): Promise<DataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataViewResponse>(null as any)
  }

  /**
   * @return Success
   */
  getDisputesDataView(): Promise<DataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/Statement/Dispute/DataView'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetDisputesDataView(_response)
      })
  }

  protected processGetDisputesDataView(response: Response): Promise<DataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataViewResponse>(null as any)
  }

  /**
   * @return Success
   */
  getTransactionById(id: string): Promise<TransactionResponse> {
    let url_ = this.baseUrl + '/api/v1/Statement/Transaction({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetTransactionById(_response)
      })
  }

  protected processGetTransactionById(response: Response): Promise<TransactionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = TransactionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<TransactionResponse>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  aggregateAppointmentsByStart(start: Date | null | undefined, end: Date | null | undefined): Promise<AppointmentAggregation> {
    let url_ = this.baseUrl + '/api/v1/Stats/AggregateByStart?'
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAggregateAppointmentsByStart(_response)
      })
  }

  protected processAggregateAppointmentsByStart(response: Response): Promise<AppointmentAggregation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppointmentAggregation.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentAggregation>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  aggregateAppointmentsByCreation(start: Date | null | undefined, end: Date | null | undefined): Promise<AppointmentAggregation> {
    let url_ = this.baseUrl + '/api/v1/Stats/AggregateByCreation?'
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAggregateAppointmentsByCreation(_response)
      })
  }

  protected processAggregateAppointmentsByCreation(response: Response): Promise<AppointmentAggregation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppointmentAggregation.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentAggregation>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  aggregateAppointmentsByTool(start: Date | null | undefined, end: Date | null | undefined): Promise<AppointmentAggregation> {
    let url_ = this.baseUrl + '/api/v1/Stats/AggregateByTool?'
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAggregateAppointmentsByTool(_response)
      })
  }

  protected processAggregateAppointmentsByTool(response: Response): Promise<AppointmentAggregation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppointmentAggregation.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentAggregation>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  aggregateAppointmentsForOrgByStart(id: string, start: Date | null | undefined, end: Date | null | undefined): Promise<AppointmentAggregation> {
    let url_ = this.baseUrl + '/api/v1/Stats/Org({id})/Appointments/AggregateByStart?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAggregateAppointmentsForOrgByStart(_response)
      })
  }

  protected processAggregateAppointmentsForOrgByStart(response: Response): Promise<AppointmentAggregation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppointmentAggregation.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentAggregation>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  aggregateAppointmentsForOrgByCreation(id: string, start: Date | null | undefined, end: Date | null | undefined): Promise<AppointmentAggregation> {
    let url_ = this.baseUrl + '/api/v1/Stats/Org({id})/Appointments/AggregateByCreation?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAggregateAppointmentsForOrgByCreation(_response)
      })
  }

  protected processAggregateAppointmentsForOrgByCreation(response: Response): Promise<AppointmentAggregation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppointmentAggregation.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentAggregation>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  aggregateAppointmentsByTool2(id: string, start: Date | null | undefined, end: Date | null | undefined): Promise<AppointmentAggregation> {
    let url_ = this.baseUrl + '/api/v1/Stats/Org({id})/Appointments/AggregateByTool?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAggregateAppointmentsByTool2(_response)
      })
  }

  protected processAggregateAppointmentsByTool2(response: Response): Promise<AppointmentAggregation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AppointmentAggregation.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AppointmentAggregation>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  getLeadsPerDay(start: Date | null | undefined, end: Date | null | undefined): Promise<LeadAggregation> {
    let url_ = this.baseUrl + '/api/v1/Stats/Leads?'
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetLeadsPerDay(_response)
      })
  }

  protected processGetLeadsPerDay(response: Response): Promise<LeadAggregation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = LeadAggregation.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<LeadAggregation>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  getLeadsPerHour(start: Date | null | undefined, end: Date | null | undefined): Promise<LeadAggregation> {
    let url_ = this.baseUrl + '/api/v1/Stats/LeadsPerHour?'
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetLeadsPerHour(_response)
      })
  }

  protected processGetLeadsPerHour(response: Response): Promise<LeadAggregation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = LeadAggregation.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<LeadAggregation>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  aggregateLeadsForOrg(id: string, start: Date | null | undefined, end: Date | null | undefined): Promise<LeadAggregation> {
    let url_ = this.baseUrl + '/api/v1/Stats/Org({id})/Leads?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAggregateLeadsForOrg(_response)
      })
  }

  protected processAggregateLeadsForOrg(response: Response): Promise<LeadAggregation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = LeadAggregation.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<LeadAggregation>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  aggregateLeadsForOrgByHour(id: string, start: Date | null | undefined, end: Date | null | undefined): Promise<LeadAggregation> {
    let url_ = this.baseUrl + '/api/v1/Stats/Org({id})/LeadsPerHour?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAggregateLeadsForOrgByHour(_response)
      })
  }

  protected processAggregateLeadsForOrgByHour(response: Response): Promise<LeadAggregation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = LeadAggregation.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<LeadAggregation>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  getOrgAvailabilityGET(start: Date | null | undefined, end: Date | null | undefined): Promise<AvailabilityStats> {
    let url_ = this.baseUrl + '/api/v1/Stats/Availability?'
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrgAvailabilityGET(_response)
      })
  }

  protected processGetOrgAvailabilityGET(response: Response): Promise<AvailabilityStats> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AvailabilityStats.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AvailabilityStats>(null as any)
  }

  /**
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  getAvailabilityForOrg(id: string, start: Date | null | undefined, end: Date | null | undefined): Promise<AvailabilityStats> {
    let url_ = this.baseUrl + '/api/v1/Stats/Org({id})/Availability?'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAvailabilityForOrg(_response)
      })
  }

  protected processGetAvailabilityForOrg(response: Response): Promise<AvailabilityStats> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AvailabilityStats.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AvailabilityStats>(null as any)
  }

  /**
   * @param id (optional)
   * @param start (optional)
   * @param end (optional)
   * @return Success
   */
  getOrgAvailabilityForType(id: string | null | undefined, start: Date | null | undefined, end: Date | null | undefined): Promise<AvailabilityStats> {
    let url_ = this.baseUrl + '/api/v1/Stats/AppointmentType(id)/Availability?'
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&'
    if (start !== undefined && start !== null) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&'
    if (end !== undefined && end !== null) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrgAvailabilityForType(_response)
      })
  }

  protected processGetOrgAvailabilityForType(response: Response): Promise<AvailabilityStats> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = AvailabilityStats.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<AvailabilityStats>(null as any)
  }

  /**
   * @return Success
   */
  stopApplication(): Promise<void> {
    let url_ = this.baseUrl + '/Test/Abort'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processStopApplication(_response)
      })
  }

  protected processStopApplication(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  users(): Promise<void> {
    let url_ = this.baseUrl + '/Test/User'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUsers(_response)
      })
  }

  protected processUsers(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  partner(): Promise<void> {
    let url_ = this.baseUrl + '/Test/Partner'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processPartner(_response)
      })
  }

  protected processPartner(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @param value (optional)
   * @return Success
   */
  addSecret(value: string | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/Test/Protect?'
    if (value !== undefined && value !== null) url_ += 'value=' + encodeURIComponent('' + value) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAddSecret(_response)
      })
  }

  protected processAddSecret(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @param value (optional)
   * @return Success
   */
  unprotectSecret(value: string | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/Test/Unprotect?'
    if (value !== undefined && value !== null) url_ += 'value=' + encodeURIComponent('' + value) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processUnprotectSecret(_response)
      })
  }

  protected processUnprotectSecret(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @param sessionId (optional)
   * @return Success
   */
  replaySchedulingSession(sessionId: string | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/Test/Scheduler/Replay?'
    if (sessionId !== undefined && sessionId !== null) url_ += 'sessionId=' + encodeURIComponent('' + sessionId) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processReplaySchedulingSession(_response)
      })
  }

  protected processReplaySchedulingSession(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  getAll12(): Promise<TimeZone[]> {
    let url_ = this.baseUrl + '/api/v1/TimeZone'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAll12(_response)
      })
  }

  protected processGetAll12(response: Response): Promise<TimeZone[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(TimeZone.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<TimeZone[]>(null as any)
  }

  /**
   * @return Success
   */
  me(): Promise<User> {
    let url_ = this.baseUrl + '/api/v1/User'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processMe(_response)
      })
  }

  protected processMe(response: Response): Promise<User> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = User.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<User>(null as any)
  }

  /**
   * @return Success
   */
  delete3(): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/User'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDelete3(_response)
      })
  }

  protected processDelete3(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  getById10(id: string): Promise<User> {
    let url_ = this.baseUrl + '/api/v1/User({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetById10(_response)
      })
  }

  protected processGetById10(response: Response): Promise<User> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = User.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<User>(null as any)
  }

  /**
   * @return Success
   */
  deleteUser(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/User({id})'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDeleteUser(_response)
      })
  }

  protected processDeleteUser(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * @return Success
   */
  getOrganizationUsers(organizationId: string): Promise<User[]> {
    let url_ = this.baseUrl + '/api/v1/Organization({organizationId})/User'
    if (organizationId === undefined || organizationId === null) throw new Error("The parameter 'organizationId' must be defined.")
    url_ = url_.replace('{organizationId}', encodeURIComponent('' + organizationId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetOrganizationUsers(_response)
      })
  }

  protected processGetOrganizationUsers(response: Response): Promise<User[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(User.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<User[]>(null as any)
  }

  /**
   * @return Success
   */
  getMyOrganizationUsers(): Promise<User[]> {
    let url_ = this.baseUrl + '/api/v1/Organization/User'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetMyOrganizationUsers(_response)
      })
  }

  protected processGetMyOrganizationUsers(response: Response): Promise<User[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(User.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<User[]>(null as any)
  }

  /**
   * @return Success
   */
  getUsers(): Promise<User[]> {
    let url_ = this.baseUrl + '/api/v1/Entity/User'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetUsers(_response)
      })
  }

  protected processGetUsers(response: Response): Promise<User[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(User.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<User[]>(null as any)
  }

  /**
   * @return Success
   */
  getAvailableUsers(id: string): Promise<User[]> {
    let url_ = this.baseUrl + '/api/v1/AppointmentType({id})/User'
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.")
    url_ = url_.replace('{id}', encodeURIComponent('' + id))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAvailableUsers(_response)
      })
  }

  protected processGetAvailableUsers(response: Response): Promise<User[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(User.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<User[]>(null as any)
  }

  /**
   * @return Success
   */
  getPossibleUsers(leadId: string, appointmentTypeId: string): Promise<User[]> {
    let url_ = this.baseUrl + '/api/v1/Lead({leadId})/AppointmentType({appointmentTypeId})/User'
    if (leadId === undefined || leadId === null) throw new Error("The parameter 'leadId' must be defined.")
    url_ = url_.replace('{leadId}', encodeURIComponent('' + leadId))
    if (appointmentTypeId === undefined || appointmentTypeId === null) throw new Error("The parameter 'appointmentTypeId' must be defined.")
    url_ = url_.replace('{appointmentTypeId}', encodeURIComponent('' + appointmentTypeId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetPossibleUsers(_response)
      })
  }

  protected processGetPossibleUsers(response: Response): Promise<User[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(User.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<User[]>(null as any)
  }

  /**
   * @return Success
   */
  getMergeCandidates(): Promise<MergeUserCandidateMatch[]> {
    let url_ = this.baseUrl + '/api/v1/User/MergeCandidates'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetMergeCandidates(_response)
      })
  }

  protected processGetMergeCandidates(response: Response): Promise<MergeUserCandidateMatch[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(MergeUserCandidateMatch.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<MergeUserCandidateMatch[]>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  mergeUsers(body: string[] | null | undefined): Promise<User> {
    let url_ = this.baseUrl + '/api/v1/User/Merge'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processMergeUsers(_response)
      })
  }

  protected processMergeUsers(response: Response): Promise<User> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = User.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<User>(null as any)
  }

  /**
   * @return Success
   */
  getAction(objectTypeName: string, eventId: string): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/{objectTypeName}/UserAction({eventId})/DataForm'
    if (objectTypeName === undefined || objectTypeName === null) throw new Error("The parameter 'objectTypeName' must be defined.")
    url_ = url_.replace('{objectTypeName}', encodeURIComponent('' + objectTypeName))
    if (eventId === undefined || eventId === null) throw new Error("The parameter 'eventId' must be defined.")
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAction(_response)
      })
  }

  protected processGetAction(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  runAction(objectType: string, eventId: string, body: DataFormActionRequest | null | undefined): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/{objectType}/UserAction({eventId})/DataForm'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (eventId === undefined || eventId === null) throw new Error("The parameter 'eventId' must be defined.")
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processRunAction(_response)
      })
  }

  protected processRunAction(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @return Success
   */
  getActionForObject(objectTypeName: string, objectId: string, eventId: string): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/{objectTypeName}({objectId})/UserAction({eventId})/DataForm'
    if (objectTypeName === undefined || objectTypeName === null) throw new Error("The parameter 'objectTypeName' must be defined.")
    url_ = url_.replace('{objectTypeName}', encodeURIComponent('' + objectTypeName))
    if (objectId === undefined || objectId === null) throw new Error("The parameter 'objectId' must be defined.")
    url_ = url_.replace('{objectId}', encodeURIComponent('' + objectId))
    if (eventId === undefined || eventId === null) throw new Error("The parameter 'eventId' must be defined.")
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetActionForObject(_response)
      })
  }

  protected processGetActionForObject(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  runActionForObject(objectType: string, objectId: string, eventId: string, body: DataFormActionRequest | null | undefined): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/{objectType}({objectId})/UserAction({eventId})/DataForm'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (objectId === undefined || objectId === null) throw new Error("The parameter 'objectId' must be defined.")
    url_ = url_.replace('{objectId}', encodeURIComponent('' + objectId))
    if (eventId === undefined || eventId === null) throw new Error("The parameter 'eventId' must be defined.")
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processRunActionForObject(_response)
      })
  }

  protected processRunActionForObject(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @return Success
   */
  getAction2(objectType: string, objectId: string, eventId: string, flowRunId: string): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/{objectType}({objectId})/Flow({flowRunId})/UserAction({eventId})/DataForm'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (objectId === undefined || objectId === null) throw new Error("The parameter 'objectId' must be defined.")
    url_ = url_.replace('{objectId}', encodeURIComponent('' + objectId))
    if (eventId === undefined || eventId === null) throw new Error("The parameter 'eventId' must be defined.")
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId))
    if (flowRunId === undefined || flowRunId === null) throw new Error("The parameter 'flowRunId' must be defined.")
    url_ = url_.replace('{flowRunId}', encodeURIComponent('' + flowRunId))
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAction2(_response)
      })
  }

  protected processGetAction2(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  runActionInFlow(
    objectType: string,
    objectId: string,
    eventId: string,
    flowRunId: string,
    body: DataFormActionRequest | null | undefined
  ): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/{objectType}({objectId})/Flow({flowRunId})/UserAction({eventId})/DataForm'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (objectId === undefined || objectId === null) throw new Error("The parameter 'objectId' must be defined.")
    url_ = url_.replace('{objectId}', encodeURIComponent('' + objectId))
    if (eventId === undefined || eventId === null) throw new Error("The parameter 'eventId' must be defined.")
    url_ = url_.replace('{eventId}', encodeURIComponent('' + eventId))
    if (flowRunId === undefined || flowRunId === null) throw new Error("The parameter 'flowRunId' must be defined.")
    url_ = url_.replace('{flowRunId}', encodeURIComponent('' + flowRunId))
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processRunActionInFlow(_response)
      })
  }

  protected processRunActionInFlow(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   */
  triggerAction(body: UserActionRequest | null | undefined): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/UserAction'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processTriggerAction(_response)
      })
  }

  protected processTriggerAction(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   * @deprecated
   */
  dataView5(body: DataViewRequest | null | undefined): Promise<DataViewResponse> {
    let url_ = this.baseUrl + '/api/v1/UserAction/DataView'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processDataView5(_response)
      })
  }

  protected processDataView5(response: Response): Promise<DataViewResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataViewResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataViewResponse>(null as any)
  }

  /**
   * @param multiple (optional)
   * @return Success
   * @deprecated
   */
  getActions(objectType: string, multiple: boolean | null | undefined): Promise<UserAction[]> {
    let url_ = this.baseUrl + '/api/v1/{objectType}/UserAction?'
    if (objectType === undefined || objectType === null) throw new Error("The parameter 'objectType' must be defined.")
    url_ = url_.replace('{objectType}', encodeURIComponent('' + objectType))
    if (multiple !== undefined && multiple !== null) url_ += 'multiple=' + encodeURIComponent('' + multiple) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetActions(_response)
      })
  }

  protected processGetActions(response: Response): Promise<UserAction[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        if (Array.isArray(resultData200)) {
          result200 = [] as any
          for (let item of resultData200) result200!.push(UserAction.fromJS(item))
        } else {
          result200 = <any>null
        }
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<UserAction[]>(null as any)
  }

  /**
   * @param id (optional)
   * @return Success
   * @deprecated
   */
  getAction3(id: string | null | undefined): Promise<Form> {
    let url_ = this.baseUrl + '/api/v1/UserAction/DataForm?'
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processGetAction3(_response)
      })
  }

  protected processGetAction3(response: Response): Promise<Form> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = Form.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<Form>(null as any)
  }

  /**
   * @param body (optional)
   * @return Success
   * @deprecated
   */
  addEdit(body: DataFormActionRequest | null | undefined): Promise<DataFormActionResponse> {
    let url_ = this.baseUrl + '/api/v1/UserAction/DataForm'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(body)

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_)
      })
      .then((_response: Response) => {
        return this.processAddEdit(_response)
      })
  }

  protected processAddEdit(response: Response): Promise<DataFormActionResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver)
        result200 = DataFormActionResponse.fromJS(resultData200)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException('Unauthorized', status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException('Forbidden', status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers)
      })
    }
    return Promise.resolve<DataFormActionResponse>(null as any)
  }
}

export class ActionMenuItem implements IActionMenuItem {
  action?: string | undefined
  readonly _t?: string | undefined
  icon?: Icons | undefined
  readonly type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IActionMenuItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.action = _data['action']
      ;(<any>this)._t = _data['_t']
      this.icon = _data['icon']
      ;(<any>this).type = _data['type']
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): ActionMenuItem {
    data = typeof data === 'object' ? data : {}
    let result = new ActionMenuItem()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['action'] = this.action
    data['_t'] = this._t
    data['icon'] = this.icon
    data['type'] = this.type
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IActionMenuItem {
  action?: string | undefined
  _t?: string | undefined
  icon?: Icons | undefined
  type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class ActionOutput implements IActionOutput {
  eventId?: string | undefined
  name?: string | undefined

  constructor(data?: IActionOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.eventId = _data['eventId']
      this.name = _data['name']
    }
  }

  static fromJS(data: any): ActionOutput {
    data = typeof data === 'object' ? data : {}
    let result = new ActionOutput()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['eventId'] = this.eventId
    data['name'] = this.name
    return data
  }
}

export interface IActionOutput {
  eventId?: string | undefined
  name?: string | undefined
}

export class Actor implements IActor {
  readonly _t?: string | undefined

  constructor(data?: IActor) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this)._t = _data['_t']
    }
  }

  static fromJS(data: any): Actor {
    data = typeof data === 'object' ? data : {}
    let result = new Actor()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['_t'] = this._t
    return data
  }
}

export interface IActor {
  _t?: string | undefined
}

export class AddOrganizationRequest implements IAddOrganizationRequest {
  name?: string | undefined
  timeZoneId?: string | undefined

  constructor(data?: IAddOrganizationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name']
      this.timeZoneId = _data['timeZoneId']
    }
  }

  static fromJS(data: any): AddOrganizationRequest {
    data = typeof data === 'object' ? data : {}
    let result = new AddOrganizationRequest()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['timeZoneId'] = this.timeZoneId
    return data
  }
}

export interface IAddOrganizationRequest {
  name?: string | undefined
  timeZoneId?: string | undefined
}

export class AddressField implements IAddressField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IAddressField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): AddressField {
    data = typeof data === 'object' ? data : {}
    let result = new AddressField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IAddressField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class Adjustment implements IAdjustment {
  transactionId?: string | undefined
  adjustedByEntityId?: string | undefined
  adjustedBy?: string | undefined
  organizationId?: string | undefined
  entityId?: string | undefined
  externalId?: string | undefined
  description?: string | undefined
  total?: number | undefined
  referenceDate?: Date | undefined
  balance?: number | undefined
  number?: number | undefined
  refs?: Reference[] | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined

  constructor(data?: IAdjustment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transactionId = _data['transactionId']
      this.adjustedByEntityId = _data['adjustedByEntityId']
      this.adjustedBy = _data['adjustedBy']
      this.organizationId = _data['organizationId']
      this.entityId = _data['entityId']
      this.externalId = _data['externalId']
      this.description = _data['description']
      this.total = _data['total']
      this.referenceDate = _data['referenceDate'] ? new Date(_data['referenceDate'].toString()) : <any>undefined
      this.balance = _data['balance']
      this.number = _data['number']
      if (Array.isArray(_data['refs'])) {
        this.refs = [] as any
        for (let item of _data['refs']) this.refs!.push(Reference.fromJS(item))
      }
      this.id = _data['id']
      this.accountId = _data['accountId']
      this.name = _data['name']
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.lastModifiedOn = _data['lastModifiedOn'] ? new Date(_data['lastModifiedOn'].toString()) : <any>undefined
      this.lastActor = _data['lastActor'] ? Actor.fromJS(_data['lastActor']) : <any>undefined
    }
  }

  static fromJS(data: any): Adjustment {
    data = typeof data === 'object' ? data : {}
    let result = new Adjustment()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['transactionId'] = this.transactionId
    data['adjustedByEntityId'] = this.adjustedByEntityId
    data['adjustedBy'] = this.adjustedBy
    data['organizationId'] = this.organizationId
    data['entityId'] = this.entityId
    data['externalId'] = this.externalId
    data['description'] = this.description
    data['total'] = this.total
    data['referenceDate'] = this.referenceDate ? this.referenceDate.toISOString() : <any>undefined
    data['balance'] = this.balance
    data['number'] = this.number
    if (Array.isArray(this.refs)) {
      data['refs'] = []
      for (let item of this.refs) data['refs'].push(item.toJSON())
    }
    data['id'] = this.id
    data['accountId'] = this.accountId
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['lastModifiedOn'] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined
    data['lastActor'] = this.lastActor ? this.lastActor.toJSON() : <any>undefined
    return data
  }
}

export interface IAdjustment {
  transactionId?: string | undefined
  adjustedByEntityId?: string | undefined
  adjustedBy?: string | undefined
  organizationId?: string | undefined
  entityId?: string | undefined
  externalId?: string | undefined
  description?: string | undefined
  total?: number | undefined
  referenceDate?: Date | undefined
  balance?: number | undefined
  number?: number | undefined
  refs?: Reference[] | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined
}

export class AggregateStoredProcedure implements IAggregateStoredProcedure {
  pipeline?: string[] | undefined
  readonly body?: string | undefined
  id?: string | undefined
  collection?: string | undefined
  databaseName?: string | undefined
  name?: string | undefined
  description?: string | undefined
  parameters?: Parameter[] | undefined
  readonly namespace?: string | undefined
  createdOn?: Date | undefined
  lastUpdatedOn?: Date | undefined
  version?: number | undefined
  isActive?: boolean | undefined

  constructor(data?: IAggregateStoredProcedure) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['pipeline'])) {
        this.pipeline = [] as any
        for (let item of _data['pipeline']) this.pipeline!.push(item)
      }
      ;(<any>this).body = _data['body']
      this.id = _data['id']
      this.collection = _data['collection']
      this.databaseName = _data['databaseName']
      this.name = _data['name']
      this.description = _data['description']
      if (Array.isArray(_data['parameters'])) {
        this.parameters = [] as any
        for (let item of _data['parameters']) this.parameters!.push(Parameter.fromJS(item))
      }
      ;(<any>this).namespace = _data['namespace']
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.lastUpdatedOn = _data['lastUpdatedOn'] ? new Date(_data['lastUpdatedOn'].toString()) : <any>undefined
      this.version = _data['version']
      this.isActive = _data['isActive']
    }
  }

  static fromJS(data: any): AggregateStoredProcedure {
    data = typeof data === 'object' ? data : {}
    let result = new AggregateStoredProcedure()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.pipeline)) {
      data['pipeline'] = []
      for (let item of this.pipeline) data['pipeline'].push(item)
    }
    data['body'] = this.body
    data['id'] = this.id
    data['collection'] = this.collection
    data['databaseName'] = this.databaseName
    data['name'] = this.name
    data['description'] = this.description
    if (Array.isArray(this.parameters)) {
      data['parameters'] = []
      for (let item of this.parameters) data['parameters'].push(item.toJSON())
    }
    data['namespace'] = this.namespace
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['lastUpdatedOn'] = this.lastUpdatedOn ? this.lastUpdatedOn.toISOString() : <any>undefined
    data['version'] = this.version
    data['isActive'] = this.isActive
    return data
  }
}

export interface IAggregateStoredProcedure {
  pipeline?: string[] | undefined
  body?: string | undefined
  id?: string | undefined
  collection?: string | undefined
  databaseName?: string | undefined
  name?: string | undefined
  description?: string | undefined
  parameters?: Parameter[] | undefined
  namespace?: string | undefined
  createdOn?: Date | undefined
  lastUpdatedOn?: Date | undefined
  version?: number | undefined
  isActive?: boolean | undefined
}

export class ApiModel implements IApiModel {
  id?: string | undefined
  name?: string | undefined

  constructor(data?: IApiModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
    }
  }

  static fromJS(data: any): ApiModel {
    data = typeof data === 'object' ? data : {}
    let result = new ApiModel()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    return data
  }
}

export interface IApiModel {
  id?: string | undefined
  name?: string | undefined
}

export class AppConfig implements IAppConfig {
  accountId?: string | undefined
  name?: string | undefined
  menu?: string | undefined
  initialPage?: string | undefined
  disableHistory?: boolean | undefined

  constructor(data?: IAppConfig) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accountId = _data['accountId']
      this.name = _data['name']
      this.menu = _data['menu']
      this.initialPage = _data['initialPage']
      this.disableHistory = _data['disableHistory']
    }
  }

  static fromJS(data: any): AppConfig {
    data = typeof data === 'object' ? data : {}
    let result = new AppConfig()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['accountId'] = this.accountId
    data['name'] = this.name
    data['menu'] = this.menu
    data['initialPage'] = this.initialPage
    data['disableHistory'] = this.disableHistory
    return data
  }
}

export interface IAppConfig {
  accountId?: string | undefined
  name?: string | undefined
  menu?: string | undefined
  initialPage?: string | undefined
  disableHistory?: boolean | undefined
}

export class AppDataView implements IAppDataView {
  storedProcedure?: AggregateStoredProcedure | undefined
  dataView?: DataView | undefined
  objectType?: string | undefined
  profileIds?: string[] | undefined
  role?: EntityRoleId | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  description?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined

  constructor(data?: IAppDataView) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.storedProcedure = _data['storedProcedure'] ? AggregateStoredProcedure.fromJS(_data['storedProcedure']) : <any>undefined
      this.dataView = _data['dataView'] ? DataView.fromJS(_data['dataView']) : <any>undefined
      this.objectType = _data['objectType']
      if (Array.isArray(_data['profileIds'])) {
        this.profileIds = [] as any
        for (let item of _data['profileIds']) this.profileIds!.push(item)
      }
      this.role = _data['role']
      this.id = _data['id']
      this.accountId = _data['accountId']
      this.name = _data['name']
      this.description = _data['description']
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.lastModifiedOn = _data['lastModifiedOn'] ? new Date(_data['lastModifiedOn'].toString()) : <any>undefined
      this.lastActor = _data['lastActor'] ? Actor.fromJS(_data['lastActor']) : <any>undefined
    }
  }

  static fromJS(data: any): AppDataView {
    data = typeof data === 'object' ? data : {}
    let result = new AppDataView()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['storedProcedure'] = this.storedProcedure ? this.storedProcedure.toJSON() : <any>undefined
    data['dataView'] = this.dataView ? this.dataView.toJSON() : <any>undefined
    data['objectType'] = this.objectType
    if (Array.isArray(this.profileIds)) {
      data['profileIds'] = []
      for (let item of this.profileIds) data['profileIds'].push(item)
    }
    data['role'] = this.role
    data['id'] = this.id
    data['accountId'] = this.accountId
    data['name'] = this.name
    data['description'] = this.description
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['lastModifiedOn'] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined
    data['lastActor'] = this.lastActor ? this.lastActor.toJSON() : <any>undefined
    return data
  }
}

export interface IAppDataView {
  storedProcedure?: AggregateStoredProcedure | undefined
  dataView?: DataView | undefined
  objectType?: string | undefined
  profileIds?: string[] | undefined
  role?: EntityRoleId | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  description?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined
}

export class AppIntegration implements IAppIntegration {
  id?: string | undefined
  accountId?: string | undefined
  description?: string | undefined
  serviceName?: string | undefined
  name?: string | undefined

  constructor(data?: IAppIntegration) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.accountId = _data['accountId']
      this.description = _data['description']
      this.serviceName = _data['serviceName']
      this.name = _data['name']
    }
  }

  static fromJS(data: any): AppIntegration {
    data = typeof data === 'object' ? data : {}
    let result = new AppIntegration()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['accountId'] = this.accountId
    data['description'] = this.description
    data['serviceName'] = this.serviceName
    data['name'] = this.name
    return data
  }
}

export interface IAppIntegration {
  id?: string | undefined
  accountId?: string | undefined
  description?: string | undefined
  serviceName?: string | undefined
  name?: string | undefined
}

export class Appointment implements IAppointment {
  leadId?: string | undefined
  appointmentTypeId?: string | undefined
  isAllDay?: boolean | undefined
  subject?: string | undefined
  start?: Date | undefined
  end?: Date | undefined
  webLink?: string | undefined
  expiresOn?: Date | undefined
  cancelledOn?: Date | undefined
  addedToCalendarOn?: Date | undefined
  localDate?: string | undefined
  localTime?: string | undefined
  timeZoneId?: string | undefined
  data?: { [key: string]: any } | undefined
  createdBy?: string | undefined
  notes?: string | undefined
  tool?: string | undefined
  state?: AppointmentState | undefined
  readonly objectType?: string | undefined
  objectStatusId?: string | undefined
  flowId?: string | undefined
  isActive?: boolean | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined

  constructor(data?: IAppointment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.leadId = _data['leadId']
      this.appointmentTypeId = _data['appointmentTypeId']
      this.isAllDay = _data['isAllDay']
      this.subject = _data['subject']
      this.start = _data['start'] ? new Date(_data['start'].toString()) : <any>undefined
      this.end = _data['end'] ? new Date(_data['end'].toString()) : <any>undefined
      this.webLink = _data['webLink']
      this.expiresOn = _data['expiresOn'] ? new Date(_data['expiresOn'].toString()) : <any>undefined
      this.cancelledOn = _data['cancelledOn'] ? new Date(_data['cancelledOn'].toString()) : <any>undefined
      this.addedToCalendarOn = _data['addedToCalendarOn'] ? new Date(_data['addedToCalendarOn'].toString()) : <any>undefined
      this.localDate = _data['localDate']
      this.localTime = _data['localTime']
      this.timeZoneId = _data['timeZoneId']
      if (_data['data']) {
        this.data = {} as any
        for (let key in _data['data']) {
          if (_data['data'].hasOwnProperty(key)) (<any>this.data)![key] = _data['data'][key]
        }
      }
      this.createdBy = _data['createdBy']
      this.notes = _data['notes']
      this.tool = _data['tool']
      this.state = _data['state']
      ;(<any>this).objectType = _data['objectType']
      this.objectStatusId = _data['objectStatusId']
      this.flowId = _data['flowId']
      this.isActive = _data['isActive']
      this.description = _data['description']
      this.entityId = _data['entityId']
      this.id = _data['id']
      this.accountId = _data['accountId']
      this.name = _data['name']
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.lastModifiedOn = _data['lastModifiedOn'] ? new Date(_data['lastModifiedOn'].toString()) : <any>undefined
      this.lastActor = _data['lastActor'] ? Actor.fromJS(_data['lastActor']) : <any>undefined
    }
  }

  static fromJS(data: any): Appointment {
    data = typeof data === 'object' ? data : {}
    let result = new Appointment()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['leadId'] = this.leadId
    data['appointmentTypeId'] = this.appointmentTypeId
    data['isAllDay'] = this.isAllDay
    data['subject'] = this.subject
    data['start'] = this.start ? this.start.toISOString() : <any>undefined
    data['end'] = this.end ? this.end.toISOString() : <any>undefined
    data['webLink'] = this.webLink
    data['expiresOn'] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined
    data['cancelledOn'] = this.cancelledOn ? this.cancelledOn.toISOString() : <any>undefined
    data['addedToCalendarOn'] = this.addedToCalendarOn ? this.addedToCalendarOn.toISOString() : <any>undefined
    data['localDate'] = this.localDate
    data['localTime'] = this.localTime
    data['timeZoneId'] = this.timeZoneId
    if (this.data) {
      data['data'] = {}
      for (let key in this.data) {
        if (this.data.hasOwnProperty(key)) (<any>data['data'])[key] = (<any>this.data)[key]
      }
    }
    data['createdBy'] = this.createdBy
    data['notes'] = this.notes
    data['tool'] = this.tool
    data['state'] = this.state
    data['objectType'] = this.objectType
    data['objectStatusId'] = this.objectStatusId
    data['flowId'] = this.flowId
    data['isActive'] = this.isActive
    data['description'] = this.description
    data['entityId'] = this.entityId
    data['id'] = this.id
    data['accountId'] = this.accountId
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['lastModifiedOn'] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined
    data['lastActor'] = this.lastActor ? this.lastActor.toJSON() : <any>undefined
    return data
  }
}

export interface IAppointment {
  leadId?: string | undefined
  appointmentTypeId?: string | undefined
  isAllDay?: boolean | undefined
  subject?: string | undefined
  start?: Date | undefined
  end?: Date | undefined
  webLink?: string | undefined
  expiresOn?: Date | undefined
  cancelledOn?: Date | undefined
  addedToCalendarOn?: Date | undefined
  localDate?: string | undefined
  localTime?: string | undefined
  timeZoneId?: string | undefined
  data?: { [key: string]: any } | undefined
  createdBy?: string | undefined
  notes?: string | undefined
  tool?: string | undefined
  state?: AppointmentState | undefined
  objectType?: string | undefined
  objectStatusId?: string | undefined
  flowId?: string | undefined
  isActive?: boolean | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined
}

export class AppointmentAggregation implements IAppointmentAggregation {
  start?: Date | undefined
  end?: Date | undefined
  entityId?: string | undefined
  data?: AppointmentAggregationRow[] | undefined

  constructor(data?: IAppointmentAggregation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.start = _data['start'] ? new Date(_data['start'].toString()) : <any>undefined
      this.end = _data['end'] ? new Date(_data['end'].toString()) : <any>undefined
      this.entityId = _data['entityId']
      if (Array.isArray(_data['data'])) {
        this.data = [] as any
        for (let item of _data['data']) this.data!.push(AppointmentAggregationRow.fromJS(item))
      }
    }
  }

  static fromJS(data: any): AppointmentAggregation {
    data = typeof data === 'object' ? data : {}
    let result = new AppointmentAggregation()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['start'] = this.start ? this.start.toISOString() : <any>undefined
    data['end'] = this.end ? this.end.toISOString() : <any>undefined
    data['entityId'] = this.entityId
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    return data
  }
}

export interface IAppointmentAggregation {
  start?: Date | undefined
  end?: Date | undefined
  entityId?: string | undefined
  data?: AppointmentAggregationRow[] | undefined
}

export class AppointmentAggregationRow implements IAppointmentAggregationRow {
  date?: string | undefined
  tool?: string | undefined
  cancelled?: number | undefined
  active?: number | undefined

  constructor(data?: IAppointmentAggregationRow) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.date = _data['date']
      this.tool = _data['tool']
      this.cancelled = _data['cancelled']
      this.active = _data['active']
    }
  }

  static fromJS(data: any): AppointmentAggregationRow {
    data = typeof data === 'object' ? data : {}
    let result = new AppointmentAggregationRow()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['date'] = this.date
    data['tool'] = this.tool
    data['cancelled'] = this.cancelled
    data['active'] = this.active
    return data
  }
}

export interface IAppointmentAggregationRow {
  date?: string | undefined
  tool?: string | undefined
  cancelled?: number | undefined
  active?: number | undefined
}

export class AppointmentIntegration implements IAppointmentIntegration {
  integrationId?: string | undefined
  externalId?: string | undefined
  integration?: string | undefined
  status?: string | undefined
  url?: string | undefined

  constructor(data?: IAppointmentIntegration) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.integrationId = _data['integrationId']
      this.externalId = _data['externalId']
      this.integration = _data['integration']
      this.status = _data['status']
      this.url = _data['url']
    }
  }

  static fromJS(data: any): AppointmentIntegration {
    data = typeof data === 'object' ? data : {}
    let result = new AppointmentIntegration()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['integrationId'] = this.integrationId
    data['externalId'] = this.externalId
    data['integration'] = this.integration
    data['status'] = this.status
    data['url'] = this.url
    return data
  }
}

export interface IAppointmentIntegration {
  integrationId?: string | undefined
  externalId?: string | undefined
  integration?: string | undefined
  status?: string | undefined
  url?: string | undefined
}

export class AppointmentReq implements IAppointmentReq {
  start?: Date | undefined
  end?: Date | undefined
  contentFormat?: ContentFormat | undefined
  content?: string | undefined
  subject?: string | undefined

  constructor(data?: IAppointmentReq) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.start = _data['start'] ? new Date(_data['start'].toString()) : <any>undefined
      this.end = _data['end'] ? new Date(_data['end'].toString()) : <any>undefined
      this.contentFormat = _data['contentFormat']
      this.content = _data['content']
      this.subject = _data['subject']
    }
  }

  static fromJS(data: any): AppointmentReq {
    data = typeof data === 'object' ? data : {}
    let result = new AppointmentReq()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['start'] = this.start ? this.start.toISOString() : <any>undefined
    data['end'] = this.end ? this.end.toISOString() : <any>undefined
    data['contentFormat'] = this.contentFormat
    data['content'] = this.content
    data['subject'] = this.subject
    return data
  }
}

export interface IAppointmentReq {
  start?: Date | undefined
  end?: Date | undefined
  contentFormat?: ContentFormat | undefined
  content?: string | undefined
  subject?: string | undefined
}

export enum AppointmentState {
  Created = 'Created',
  Exported = 'Exported',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
}

export class AppointmentType implements IAppointmentType {
  leadTypeId?: string | undefined
  settings?: SchedulingSettings | undefined
  integrations?: AppointmentTypeIntegration[] | undefined
  initialFlowId?: string | undefined
  initialObjectStatusId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined

  constructor(data?: IAppointmentType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.leadTypeId = _data['leadTypeId']
      this.settings = _data['settings'] ? SchedulingSettings.fromJS(_data['settings']) : <any>undefined
      if (Array.isArray(_data['integrations'])) {
        this.integrations = [] as any
        for (let item of _data['integrations']) this.integrations!.push(AppointmentTypeIntegration.fromJS(item))
      }
      this.initialFlowId = _data['initialFlowId']
      this.initialObjectStatusId = _data['initialObjectStatusId']
      this.description = _data['description']
      this.entityId = _data['entityId']
      this.id = _data['id']
      this.accountId = _data['accountId']
      this.name = _data['name']
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.lastModifiedOn = _data['lastModifiedOn'] ? new Date(_data['lastModifiedOn'].toString()) : <any>undefined
      this.lastActor = _data['lastActor'] ? Actor.fromJS(_data['lastActor']) : <any>undefined
    }
  }

  static fromJS(data: any): AppointmentType {
    data = typeof data === 'object' ? data : {}
    let result = new AppointmentType()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['leadTypeId'] = this.leadTypeId
    data['settings'] = this.settings ? this.settings.toJSON() : <any>undefined
    if (Array.isArray(this.integrations)) {
      data['integrations'] = []
      for (let item of this.integrations) data['integrations'].push(item.toJSON())
    }
    data['initialFlowId'] = this.initialFlowId
    data['initialObjectStatusId'] = this.initialObjectStatusId
    data['description'] = this.description
    data['entityId'] = this.entityId
    data['id'] = this.id
    data['accountId'] = this.accountId
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['lastModifiedOn'] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined
    data['lastActor'] = this.lastActor ? this.lastActor.toJSON() : <any>undefined
    return data
  }
}

export interface IAppointmentType {
  leadTypeId?: string | undefined
  settings?: SchedulingSettings | undefined
  integrations?: AppointmentTypeIntegration[] | undefined
  initialFlowId?: string | undefined
  initialObjectStatusId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined
}

export class AppointmentTypeAvailability implements IAppointmentTypeAvailability {
  appointmentTypeId?: string | undefined
  readonly days?: DayAvailability[] | undefined

  constructor(data?: IAppointmentTypeAvailability) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.appointmentTypeId = _data['appointmentTypeId']
      if (Array.isArray(_data['days'])) {
        ;(<any>this).days = [] as any
        for (let item of _data['days']) (<any>this).days!.push(DayAvailability.fromJS(item))
      }
    }
  }

  static fromJS(data: any): AppointmentTypeAvailability {
    data = typeof data === 'object' ? data : {}
    let result = new AppointmentTypeAvailability()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['appointmentTypeId'] = this.appointmentTypeId
    if (Array.isArray(this.days)) {
      data['days'] = []
      for (let item of this.days) data['days'].push(item.toJSON())
    }
    return data
  }
}

export interface IAppointmentTypeAvailability {
  appointmentTypeId?: string | undefined
  days?: DayAvailability[] | undefined
}

export class AppointmentTypeIntegration implements IAppointmentTypeIntegration {
  integrationId?: string | undefined
  data?: string | undefined
  authentication?: string | undefined
  appointmentTypeId?: string | undefined

  constructor(data?: IAppointmentTypeIntegration) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.integrationId = _data['integrationId']
      this.data = _data['data']
      this.authentication = _data['authentication']
      this.appointmentTypeId = _data['appointmentTypeId']
    }
  }

  static fromJS(data: any): AppointmentTypeIntegration {
    data = typeof data === 'object' ? data : {}
    let result = new AppointmentTypeIntegration()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['integrationId'] = this.integrationId
    data['data'] = this.data
    data['authentication'] = this.authentication
    data['appointmentTypeId'] = this.appointmentTypeId
    return data
  }
}

export interface IAppointmentTypeIntegration {
  integrationId?: string | undefined
  data?: string | undefined
  authentication?: string | undefined
  appointmentTypeId?: string | undefined
}

export class AppPage implements IAppPage {
  page?: Page | undefined
  profileIds?: string[] | undefined
  role?: EntityRoleId | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  description?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined

  constructor(data?: IAppPage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page'] ? Page.fromJS(_data['page']) : <any>undefined
      if (Array.isArray(_data['profileIds'])) {
        this.profileIds = [] as any
        for (let item of _data['profileIds']) this.profileIds!.push(item)
      }
      this.role = _data['role']
      this.id = _data['id']
      this.accountId = _data['accountId']
      this.name = _data['name']
      this.description = _data['description']
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.lastModifiedOn = _data['lastModifiedOn'] ? new Date(_data['lastModifiedOn'].toString()) : <any>undefined
      this.lastActor = _data['lastActor'] ? Actor.fromJS(_data['lastActor']) : <any>undefined
    }
  }

  static fromJS(data: any): AppPage {
    data = typeof data === 'object' ? data : {}
    let result = new AppPage()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['page'] = this.page ? this.page.toJSON() : <any>undefined
    if (Array.isArray(this.profileIds)) {
      data['profileIds'] = []
      for (let item of this.profileIds) data['profileIds'].push(item)
    }
    data['role'] = this.role
    data['id'] = this.id
    data['accountId'] = this.accountId
    data['name'] = this.name
    data['description'] = this.description
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['lastModifiedOn'] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined
    data['lastActor'] = this.lastActor ? this.lastActor.toJSON() : <any>undefined
    return data
  }
}

export interface IAppPage {
  page?: Page | undefined
  profileIds?: string[] | undefined
  role?: EntityRoleId | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  description?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined
}

export class AutoRefillRequest implements IAutoRefillRequest {
  autoRefill?: boolean | undefined
  minBalance?: number | undefined
  maxBalance?: number | undefined

  constructor(data?: IAutoRefillRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.autoRefill = _data['autoRefill']
      this.minBalance = _data['minBalance']
      this.maxBalance = _data['maxBalance']
    }
  }

  static fromJS(data: any): AutoRefillRequest {
    data = typeof data === 'object' ? data : {}
    let result = new AutoRefillRequest()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['autoRefill'] = this.autoRefill
    data['minBalance'] = this.minBalance
    data['maxBalance'] = this.maxBalance
    return data
  }
}

export interface IAutoRefillRequest {
  autoRefill?: boolean | undefined
  minBalance?: number | undefined
  maxBalance?: number | undefined
}

export class Availability implements IAvailability {
  id?: string | undefined
  dayId?: DayOfWeek | undefined
  startMinutes?: number | undefined
  durationMinutes?: number | undefined
  readonly endMinutes?: number | undefined
  appointmentTypeIds?: string[] | undefined

  constructor(data?: IAvailability) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.dayId = _data['dayId']
      this.startMinutes = _data['startMinutes']
      this.durationMinutes = _data['durationMinutes']
      ;(<any>this).endMinutes = _data['endMinutes']
      if (Array.isArray(_data['appointmentTypeIds'])) {
        this.appointmentTypeIds = [] as any
        for (let item of _data['appointmentTypeIds']) this.appointmentTypeIds!.push(item)
      }
    }
  }

  static fromJS(data: any): Availability {
    data = typeof data === 'object' ? data : {}
    let result = new Availability()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['dayId'] = this.dayId
    data['startMinutes'] = this.startMinutes
    data['durationMinutes'] = this.durationMinutes
    data['endMinutes'] = this.endMinutes
    if (Array.isArray(this.appointmentTypeIds)) {
      data['appointmentTypeIds'] = []
      for (let item of this.appointmentTypeIds) data['appointmentTypeIds'].push(item)
    }
    return data
  }
}

export interface IAvailability {
  id?: string | undefined
  dayId?: DayOfWeek | undefined
  startMinutes?: number | undefined
  durationMinutes?: number | undefined
  endMinutes?: number | undefined
  appointmentTypeIds?: string[] | undefined
}

export class AvailabilityStats implements IAvailabilityStats {
  start?: Date | undefined
  end?: Date | undefined
  appointmentTypeId?: string | undefined
  durationInMinutes?: number | undefined
  data?: AvailabilityStatsRow[] | undefined

  constructor(data?: IAvailabilityStats) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.start = _data['start'] ? new Date(_data['start'].toString()) : <any>undefined
      this.end = _data['end'] ? new Date(_data['end'].toString()) : <any>undefined
      this.appointmentTypeId = _data['appointmentTypeId']
      this.durationInMinutes = _data['durationInMinutes']
      if (Array.isArray(_data['data'])) {
        this.data = [] as any
        for (let item of _data['data']) this.data!.push(AvailabilityStatsRow.fromJS(item))
      }
    }
  }

  static fromJS(data: any): AvailabilityStats {
    data = typeof data === 'object' ? data : {}
    let result = new AvailabilityStats()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['start'] = this.start ? this.start.toISOString() : <any>undefined
    data['end'] = this.end ? this.end.toISOString() : <any>undefined
    data['appointmentTypeId'] = this.appointmentTypeId
    data['durationInMinutes'] = this.durationInMinutes
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    return data
  }
}

export interface IAvailabilityStats {
  start?: Date | undefined
  end?: Date | undefined
  appointmentTypeId?: string | undefined
  durationInMinutes?: number | undefined
  data?: AvailabilityStatsRow[] | undefined
}

export class AvailabilityStatsRow implements IAvailabilityStatsRow {
  userId?: string | undefined
  date?: Date | undefined
  appointmentsCount?: number | undefined
  openSlotsCount?: number | undefined

  constructor(data?: IAvailabilityStatsRow) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId']
      this.date = _data['date'] ? new Date(_data['date'].toString()) : <any>undefined
      this.appointmentsCount = _data['appointmentsCount']
      this.openSlotsCount = _data['openSlotsCount']
    }
  }

  static fromJS(data: any): AvailabilityStatsRow {
    data = typeof data === 'object' ? data : {}
    let result = new AvailabilityStatsRow()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['userId'] = this.userId
    data['date'] = this.date ? this.date.toISOString() : <any>undefined
    data['appointmentsCount'] = this.appointmentsCount
    data['openSlotsCount'] = this.openSlotsCount
    return data
  }
}

export interface IAvailabilityStatsRow {
  userId?: string | undefined
  date?: Date | undefined
  appointmentsCount?: number | undefined
  openSlotsCount?: number | undefined
}

export class BalanceAdjustment implements IBalanceAdjustment {
  value?: number | undefined
  description?: string | undefined
  notes?: string | undefined

  constructor(data?: IBalanceAdjustment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data['value']
      this.description = _data['description']
      this.notes = _data['notes']
    }
  }

  static fromJS(data: any): BalanceAdjustment {
    data = typeof data === 'object' ? data : {}
    let result = new BalanceAdjustment()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['value'] = this.value
    data['description'] = this.description
    data['notes'] = this.notes
    return data
  }
}

export interface IBalanceAdjustment {
  value?: number | undefined
  description?: string | undefined
  notes?: string | undefined
}

export enum BsonType {
  EndOfDocument = 'EndOfDocument',
  Double = 'Double',
  String = 'String',
  Document = 'Document',
  Array = 'Array',
  Binary = 'Binary',
  Undefined = 'Undefined',
  ObjectId = 'ObjectId',
  Boolean = 'Boolean',
  DateTime = 'DateTime',
  Null = 'Null',
  RegularExpression = 'RegularExpression',
  JavaScript = 'JavaScript',
  Symbol = 'Symbol',
  JavaScriptWithScope = 'JavaScriptWithScope',
  Int32 = 'Int32',
  Timestamp = 'Timestamp',
  Int64 = 'Int64',
  Decimal128 = 'Decimal128',
  MaxKey = 'MaxKey',
  MinKey = 'MinKey',
}

export class CalendarEvent implements ICalendarEvent {
  id?: string | undefined
  showAs?: FreeBusyStatus | undefined
  type?: CalendarEventType | undefined
  isCancelled?: boolean | undefined
  isAllDay?: boolean | undefined
  subject?: string | undefined
  start?: Date | undefined
  end?: Date | undefined
  webLink?: string | undefined
  source?: string | undefined

  constructor(data?: ICalendarEvent) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.showAs = _data['showAs']
      this.type = _data['type']
      this.isCancelled = _data['isCancelled']
      this.isAllDay = _data['isAllDay']
      this.subject = _data['subject']
      this.start = _data['start'] ? new Date(_data['start'].toString()) : <any>undefined
      this.end = _data['end'] ? new Date(_data['end'].toString()) : <any>undefined
      this.webLink = _data['webLink']
      this.source = _data['source']
    }
  }

  static fromJS(data: any): CalendarEvent {
    data = typeof data === 'object' ? data : {}
    let result = new CalendarEvent()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['showAs'] = this.showAs
    data['type'] = this.type
    data['isCancelled'] = this.isCancelled
    data['isAllDay'] = this.isAllDay
    data['subject'] = this.subject
    data['start'] = this.start ? this.start.toISOString() : <any>undefined
    data['end'] = this.end ? this.end.toISOString() : <any>undefined
    data['webLink'] = this.webLink
    data['source'] = this.source
    return data
  }
}

export interface ICalendarEvent {
  id?: string | undefined
  showAs?: FreeBusyStatus | undefined
  type?: CalendarEventType | undefined
  isCancelled?: boolean | undefined
  isAllDay?: boolean | undefined
  subject?: string | undefined
  start?: Date | undefined
  end?: Date | undefined
  webLink?: string | undefined
  source?: string | undefined
}

export enum CalendarEventType {
  SingleInstance = 'SingleInstance',
  Occurrence = 'Occurrence',
  Exception = 'Exception',
  SeriesMaster = 'SeriesMaster',
}

export class CancelAppointmentRequest implements ICancelAppointmentRequest {
  appointmentId?: string | undefined
  notes?: string | undefined
  parentObjectId?: string | undefined
  readonly parentObjectType?: string | undefined
  parentFieldName?: string | undefined

  constructor(data?: ICancelAppointmentRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.appointmentId = _data['appointmentId']
      this.notes = _data['notes']
      this.parentObjectId = _data['parentObjectId']
      ;(<any>this).parentObjectType = _data['parentObjectType']
      this.parentFieldName = _data['parentFieldName']
    }
  }

  static fromJS(data: any): CancelAppointmentRequest {
    data = typeof data === 'object' ? data : {}
    let result = new CancelAppointmentRequest()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['appointmentId'] = this.appointmentId
    data['notes'] = this.notes
    data['parentObjectId'] = this.parentObjectId
    data['parentObjectType'] = this.parentObjectType
    data['parentFieldName'] = this.parentFieldName
    return data
  }
}

export interface ICancelAppointmentRequest {
  appointmentId?: string | undefined
  notes?: string | undefined
  parentObjectId?: string | undefined
  parentObjectType?: string | undefined
  parentFieldName?: string | undefined
}

export class CheckboxField implements ICheckboxField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: ICheckboxField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): CheckboxField {
    data = typeof data === 'object' ? data : {}
    let result = new CheckboxField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface ICheckboxField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class ChildrenField implements IChildrenField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IChildrenField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): ChildrenField {
    data = typeof data === 'object' ? data : {}
    let result = new ChildrenField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IChildrenField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class ChildrenFieldOptions implements IChildrenFieldOptions {
  url?: string | undefined
  criteria?: Condition[] | undefined
  objectType?: string | undefined
  keyType?: string | undefined
  forms?: { [key: string]: Form } | undefined
  readonly _t?: string | undefined
  linkUrl?: string | undefined

  constructor(data?: IChildrenFieldOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.url = _data['url']
      if (Array.isArray(_data['criteria'])) {
        this.criteria = [] as any
        for (let item of _data['criteria']) this.criteria!.push(Condition.fromJS(item))
      }
      this.objectType = _data['objectType']
      this.keyType = _data['keyType']
      if (_data['forms']) {
        this.forms = {} as any
        for (let key in _data['forms']) {
          if (_data['forms'].hasOwnProperty(key)) (<any>this.forms)![key] = _data['forms'][key] ? Form.fromJS(_data['forms'][key]) : new Form()
        }
      }
      ;(<any>this)._t = _data['_t']
      this.linkUrl = _data['linkUrl']
    }
  }

  static fromJS(data: any): ChildrenFieldOptions {
    data = typeof data === 'object' ? data : {}
    let result = new ChildrenFieldOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['url'] = this.url
    if (Array.isArray(this.criteria)) {
      data['criteria'] = []
      for (let item of this.criteria) data['criteria'].push(item.toJSON())
    }
    data['objectType'] = this.objectType
    data['keyType'] = this.keyType
    if (this.forms) {
      data['forms'] = {}
      for (let key in this.forms) {
        if (this.forms.hasOwnProperty(key)) (<any>data['forms'])[key] = this.forms[key] ? this.forms[key].toJSON() : <any>undefined
      }
    }
    data['_t'] = this._t
    data['linkUrl'] = this.linkUrl
    return data
  }
}

export interface IChildrenFieldOptions {
  url?: string | undefined
  criteria?: Condition[] | undefined
  objectType?: string | undefined
  keyType?: string | undefined
  forms?: { [key: string]: Form } | undefined
  _t?: string | undefined
  linkUrl?: string | undefined
}

export class Condition implements ICondition {
  fieldName?: string | undefined
  operator?: Operator | undefined
  value?: any | undefined

  constructor(data?: ICondition) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fieldName = _data['fieldName']
      this.operator = _data['operator']
      this.value = _data['value']
    }
  }

  static fromJS(data: any): Condition {
    data = typeof data === 'object' ? data : {}
    let result = new Condition()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['fieldName'] = this.fieldName
    data['operator'] = this.operator
    data['value'] = this.value
    return data
  }
}

export interface ICondition {
  fieldName?: string | undefined
  operator?: Operator | undefined
  value?: any | undefined
}

export enum ContentFormat {
  PlainText = 'PlainText',
  Html = 'Html',
  Markdown = 'Markdown',
}

export class CustomPage implements ICustomPage {
  componentName?: string | undefined
  readonly _t?: string | undefined
  menu?: Menu | undefined
  appMenu?: string | undefined
  hideAppBar?: boolean | undefined
  readonly type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: ICustomPage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.componentName = _data['componentName']
      ;(<any>this)._t = _data['_t']
      this.menu = _data['menu'] ? Menu.fromJS(_data['menu']) : <any>undefined
      this.appMenu = _data['appMenu']
      this.hideAppBar = _data['hideAppBar']
      ;(<any>this).type = _data['type']
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): CustomPage {
    data = typeof data === 'object' ? data : {}
    let result = new CustomPage()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['componentName'] = this.componentName
    data['_t'] = this._t
    data['menu'] = this.menu ? this.menu.toJSON() : <any>undefined
    data['appMenu'] = this.appMenu
    data['hideAppBar'] = this.hideAppBar
    data['type'] = this.type
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface ICustomPage {
  componentName?: string | undefined
  _t?: string | undefined
  menu?: Menu | undefined
  appMenu?: string | undefined
  hideAppBar?: boolean | undefined
  type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class DataFormActionRequest implements IDataFormActionRequest {
  action?: string | undefined
  parameters?: { [key: string]: any } | undefined
  selectedIds?: string[] | undefined

  constructor(data?: IDataFormActionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.action = _data['action']
      if (_data['parameters']) {
        this.parameters = {} as any
        for (let key in _data['parameters']) {
          if (_data['parameters'].hasOwnProperty(key)) (<any>this.parameters)![key] = _data['parameters'][key]
        }
      }
      if (Array.isArray(_data['selectedIds'])) {
        this.selectedIds = [] as any
        for (let item of _data['selectedIds']) this.selectedIds!.push(item)
      }
    }
  }

  static fromJS(data: any): DataFormActionRequest {
    data = typeof data === 'object' ? data : {}
    let result = new DataFormActionRequest()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['action'] = this.action
    if (this.parameters) {
      data['parameters'] = {}
      for (let key in this.parameters) {
        if (this.parameters.hasOwnProperty(key)) (<any>data['parameters'])[key] = (<any>this.parameters)[key]
      }
    }
    if (Array.isArray(this.selectedIds)) {
      data['selectedIds'] = []
      for (let item of this.selectedIds) data['selectedIds'].push(item)
    }
    return data
  }
}

export interface IDataFormActionRequest {
  action?: string | undefined
  parameters?: { [key: string]: any } | undefined
  selectedIds?: string[] | undefined
}

export class DataFormActionResponse implements IDataFormActionResponse {
  action?: string | undefined
  ids?: string[] | undefined
  success?: boolean | undefined
  message?: string | undefined
  nextUrl?: string | undefined

  constructor(data?: IDataFormActionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.action = _data['action']
      if (Array.isArray(_data['ids'])) {
        this.ids = [] as any
        for (let item of _data['ids']) this.ids!.push(item)
      }
      this.success = _data['success']
      this.message = _data['message']
      this.nextUrl = _data['nextUrl']
    }
  }

  static fromJS(data: any): DataFormActionResponse {
    data = typeof data === 'object' ? data : {}
    let result = new DataFormActionResponse()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['action'] = this.action
    if (Array.isArray(this.ids)) {
      data['ids'] = []
      for (let item of this.ids) data['ids'].push(item)
    }
    data['success'] = this.success
    data['message'] = this.message
    data['nextUrl'] = this.nextUrl
    return data
  }
}

export interface IDataFormActionResponse {
  action?: string | undefined
  ids?: string[] | undefined
  success?: boolean | undefined
  message?: string | undefined
  nextUrl?: string | undefined
}

export class DataQuery implements IDataQuery {
  forceReload?: boolean | undefined
  query?: any | undefined
  args?: any[] | undefined

  constructor(data?: IDataQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.forceReload = _data['forceReload']
      this.query = _data['query']
      if (Array.isArray(_data['args'])) {
        this.args = [] as any
        for (let item of _data['args']) this.args!.push(item)
      }
    }
  }

  static fromJS(data: any): DataQuery {
    data = typeof data === 'object' ? data : {}
    let result = new DataQuery()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['forceReload'] = this.forceReload
    data['query'] = this.query
    if (Array.isArray(this.args)) {
      data['args'] = []
      for (let item of this.args) data['args'].push(item)
    }
    return data
  }
}

export interface IDataQuery {
  forceReload?: boolean | undefined
  query?: any | undefined
  args?: any[] | undefined
}

export class DataView implements IDataView {
  name?: string | undefined
  title?: string | undefined
  fields?: FormField[] | undefined
  defaultSort?: string | undefined
  keyField?: string | undefined
  isSelectable?: boolean | undefined
  actions?: FormAction[] | undefined
  detail?: DataViewDetail | undefined
  filter?: string[] | undefined
  isFilterableLocally?: boolean | undefined
  filterForm?: Form | undefined
  searchable?: boolean | undefined
  pageSize?: number | undefined
  menu?: Menu | undefined

  constructor(data?: IDataView) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name']
      this.title = _data['title']
      if (Array.isArray(_data['fields'])) {
        this.fields = [] as any
        for (let item of _data['fields']) this.fields!.push(FormField.fromJS(item))
      }
      this.defaultSort = _data['defaultSort']
      this.keyField = _data['keyField']
      this.isSelectable = _data['isSelectable']
      if (Array.isArray(_data['actions'])) {
        this.actions = [] as any
        for (let item of _data['actions']) this.actions!.push(FormAction.fromJS(item))
      }
      this.detail = _data['detail'] ? DataViewDetail.fromJS(_data['detail']) : <any>undefined
      if (Array.isArray(_data['filter'])) {
        this.filter = [] as any
        for (let item of _data['filter']) this.filter!.push(item)
      }
      this.isFilterableLocally = _data['isFilterableLocally']
      this.filterForm = _data['filterForm'] ? Form.fromJS(_data['filterForm']) : <any>undefined
      this.searchable = _data['searchable']
      this.pageSize = _data['pageSize']
      this.menu = _data['menu'] ? Menu.fromJS(_data['menu']) : <any>undefined
    }
  }

  static fromJS(data: any): DataView {
    data = typeof data === 'object' ? data : {}
    let result = new DataView()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['title'] = this.title
    if (Array.isArray(this.fields)) {
      data['fields'] = []
      for (let item of this.fields) data['fields'].push(item.toJSON())
    }
    data['defaultSort'] = this.defaultSort
    data['keyField'] = this.keyField
    data['isSelectable'] = this.isSelectable
    if (Array.isArray(this.actions)) {
      data['actions'] = []
      for (let item of this.actions) data['actions'].push(item.toJSON())
    }
    data['detail'] = this.detail ? this.detail.toJSON() : <any>undefined
    if (Array.isArray(this.filter)) {
      data['filter'] = []
      for (let item of this.filter) data['filter'].push(item)
    }
    data['isFilterableLocally'] = this.isFilterableLocally
    data['filterForm'] = this.filterForm ? this.filterForm.toJSON() : <any>undefined
    data['searchable'] = this.searchable
    data['pageSize'] = this.pageSize
    data['menu'] = this.menu ? this.menu.toJSON() : <any>undefined
    return data
  }
}

export interface IDataView {
  name?: string | undefined
  title?: string | undefined
  fields?: FormField[] | undefined
  defaultSort?: string | undefined
  keyField?: string | undefined
  isSelectable?: boolean | undefined
  actions?: FormAction[] | undefined
  detail?: DataViewDetail | undefined
  filter?: string[] | undefined
  isFilterableLocally?: boolean | undefined
  filterForm?: Form | undefined
  searchable?: boolean | undefined
  pageSize?: number | undefined
  menu?: Menu | undefined
}

export enum DataViewComponent {
  Grid = 'Grid',
  Chart = 'Chart',
  Card = 'Card',
}

export class DataViewDetail implements IDataViewDetail {
  page?: string | undefined

  constructor(data?: IDataViewDetail) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page']
    }
  }

  static fromJS(data: any): DataViewDetail {
    data = typeof data === 'object' ? data : {}
    let result = new DataViewDetail()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['page'] = this.page
    return data
  }
}

export interface IDataViewDetail {
  page?: string | undefined
}

export class DataViewRequest implements IDataViewRequest {
  criteria?: Condition[] | undefined
  top?: number | undefined
  orderBy?: string | undefined
  skip?: number | undefined
  fields?: string[] | undefined
  contentType?: string | undefined
  lookupField?: string | undefined
  hash?: string | undefined

  constructor(data?: IDataViewRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['criteria'])) {
        this.criteria = [] as any
        for (let item of _data['criteria']) this.criteria!.push(Condition.fromJS(item))
      }
      this.top = _data['top']
      this.orderBy = _data['orderBy']
      this.skip = _data['skip']
      if (Array.isArray(_data['fields'])) {
        this.fields = [] as any
        for (let item of _data['fields']) this.fields!.push(item)
      }
      this.contentType = _data['contentType']
      this.lookupField = _data['lookupField']
      this.hash = _data['hash']
    }
  }

  static fromJS(data: any): DataViewRequest {
    data = typeof data === 'object' ? data : {}
    let result = new DataViewRequest()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.criteria)) {
      data['criteria'] = []
      for (let item of this.criteria) data['criteria'].push(item.toJSON())
    }
    data['top'] = this.top
    data['orderBy'] = this.orderBy
    data['skip'] = this.skip
    if (Array.isArray(this.fields)) {
      data['fields'] = []
      for (let item of this.fields) data['fields'].push(item)
    }
    data['contentType'] = this.contentType
    data['lookupField'] = this.lookupField
    data['hash'] = this.hash
    return data
  }
}

export interface IDataViewRequest {
  criteria?: Condition[] | undefined
  top?: number | undefined
  orderBy?: string | undefined
  skip?: number | undefined
  fields?: string[] | undefined
  contentType?: string | undefined
  lookupField?: string | undefined
  hash?: string | undefined
}

export class DataViewResponse implements IDataViewResponse {
  request?: DataViewRequest | undefined
  result?: any[] | undefined
  view?: DataView | undefined
  message?: string | undefined
  nextUrl?: string | undefined
  objectType?: string | undefined
  id?: string | undefined
  objectId?: string | undefined
  options?: DataViewResponseOptions | undefined

  constructor(data?: IDataViewResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.request = _data['request'] ? DataViewRequest.fromJS(_data['request']) : <any>undefined
      if (Array.isArray(_data['result'])) {
        this.result = [] as any
        for (let item of _data['result']) this.result!.push(item)
      }
      this.view = _data['view'] ? DataView.fromJS(_data['view']) : <any>undefined
      this.message = _data['message']
      this.nextUrl = _data['nextUrl']
      this.objectType = _data['objectType']
      this.id = _data['id']
      this.objectId = _data['objectId']
      this.options = _data['options'] ? DataViewResponseOptions.fromJS(_data['options']) : <any>undefined
    }
  }

  static fromJS(data: any): DataViewResponse {
    data = typeof data === 'object' ? data : {}
    let result = new DataViewResponse()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['request'] = this.request ? this.request.toJSON() : <any>undefined
    if (Array.isArray(this.result)) {
      data['result'] = []
      for (let item of this.result) data['result'].push(item)
    }
    data['view'] = this.view ? this.view.toJSON() : <any>undefined
    data['message'] = this.message
    data['nextUrl'] = this.nextUrl
    data['objectType'] = this.objectType
    data['id'] = this.id
    data['objectId'] = this.objectId
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    return data
  }
}

export interface IDataViewResponse {
  request?: DataViewRequest | undefined
  result?: any[] | undefined
  view?: DataView | undefined
  message?: string | undefined
  nextUrl?: string | undefined
  objectType?: string | undefined
  id?: string | undefined
  objectId?: string | undefined
  options?: DataViewResponseOptions | undefined
}

export class DataViewResponseOptions implements IDataViewResponseOptions {
  component?: DataViewComponent | undefined

  constructor(data?: IDataViewResponseOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.component = _data['component']
    }
  }

  static fromJS(data: any): DataViewResponseOptions {
    data = typeof data === 'object' ? data : {}
    let result = new DataViewResponseOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['component'] = this.component
    return data
  }
}

export interface IDataViewResponseOptions {
  component?: DataViewComponent | undefined
}

export class DateField implements IDateField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IDateField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): DateField {
    data = typeof data === 'object' ? data : {}
    let result = new DateField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IDateField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class DateTimeField implements IDateTimeField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IDateTimeField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): DateTimeField {
    data = typeof data === 'object' ? data : {}
    let result = new DateTimeField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IDateTimeField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class DayAvailability implements IDayAvailability {
  dayOfWeek?: DayOfWeek | undefined
  slots?: Slot[] | undefined

  constructor(data?: IDayAvailability) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dayOfWeek = _data['dayOfWeek']
      if (Array.isArray(_data['slots'])) {
        this.slots = [] as any
        for (let item of _data['slots']) this.slots!.push(Slot.fromJS(item))
      }
    }
  }

  static fromJS(data: any): DayAvailability {
    data = typeof data === 'object' ? data : {}
    let result = new DayAvailability()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['dayOfWeek'] = this.dayOfWeek
    if (Array.isArray(this.slots)) {
      data['slots'] = []
      for (let item of this.slots) data['slots'].push(item.toJSON())
    }
    return data
  }
}

export interface IDayAvailability {
  dayOfWeek?: DayOfWeek | undefined
  slots?: Slot[] | undefined
}

export enum DayOfWeek {
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
}

export class DictionaryField implements IDictionaryField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IDictionaryField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): DictionaryField {
    data = typeof data === 'object' ? data : {}
    let result = new DictionaryField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IDictionaryField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class DictionaryFieldOptions implements IDictionaryFieldOptions {
  keyFieldName?: string | undefined
  valueFieldName?: string | undefined
  expandAllKeys?: boolean | undefined
  readonly _t?: string | undefined
  linkUrl?: string | undefined

  constructor(data?: IDictionaryFieldOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.keyFieldName = _data['keyFieldName']
      this.valueFieldName = _data['valueFieldName']
      this.expandAllKeys = _data['expandAllKeys']
      ;(<any>this)._t = _data['_t']
      this.linkUrl = _data['linkUrl']
    }
  }

  static fromJS(data: any): DictionaryFieldOptions {
    data = typeof data === 'object' ? data : {}
    let result = new DictionaryFieldOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['keyFieldName'] = this.keyFieldName
    data['valueFieldName'] = this.valueFieldName
    data['expandAllKeys'] = this.expandAllKeys
    data['_t'] = this._t
    data['linkUrl'] = this.linkUrl
    return data
  }
}

export interface IDictionaryFieldOptions {
  keyFieldName?: string | undefined
  valueFieldName?: string | undefined
  expandAllKeys?: boolean | undefined
  _t?: string | undefined
  linkUrl?: string | undefined
}

export class Dispute implements IDispute {
  disputedValue?: number | undefined
  transactionId?: string | undefined
  initiatedByEntityId?: string | undefined
  initiatedBy?: string | undefined
  resolvedByEntityId?: string | undefined
  resolvedBy?: string | undefined
  adjustmentId?: string | undefined
  resolvedOn?: Date | undefined
  resolution?: DisputeResolution | undefined
  extraMetadata?: { [key: string]: any } | undefined
  organizationId?: string | undefined
  entityId?: string | undefined
  externalId?: string | undefined
  description?: string | undefined
  total?: number | undefined
  referenceDate?: Date | undefined
  balance?: number | undefined
  number?: number | undefined
  refs?: Reference[] | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined

  constructor(data?: IDispute) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.disputedValue = _data['disputedValue']
      this.transactionId = _data['transactionId']
      this.initiatedByEntityId = _data['initiatedByEntityId']
      this.initiatedBy = _data['initiatedBy']
      this.resolvedByEntityId = _data['resolvedByEntityId']
      this.resolvedBy = _data['resolvedBy']
      this.adjustmentId = _data['adjustmentId']
      this.resolvedOn = _data['resolvedOn'] ? new Date(_data['resolvedOn'].toString()) : <any>undefined
      this.resolution = _data['resolution']
      if (_data['extraMetadata']) {
        this.extraMetadata = {} as any
        for (let key in _data['extraMetadata']) {
          if (_data['extraMetadata'].hasOwnProperty(key)) (<any>this.extraMetadata)![key] = _data['extraMetadata'][key]
        }
      }
      this.organizationId = _data['organizationId']
      this.entityId = _data['entityId']
      this.externalId = _data['externalId']
      this.description = _data['description']
      this.total = _data['total']
      this.referenceDate = _data['referenceDate'] ? new Date(_data['referenceDate'].toString()) : <any>undefined
      this.balance = _data['balance']
      this.number = _data['number']
      if (Array.isArray(_data['refs'])) {
        this.refs = [] as any
        for (let item of _data['refs']) this.refs!.push(Reference.fromJS(item))
      }
      this.id = _data['id']
      this.accountId = _data['accountId']
      this.name = _data['name']
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.lastModifiedOn = _data['lastModifiedOn'] ? new Date(_data['lastModifiedOn'].toString()) : <any>undefined
      this.lastActor = _data['lastActor'] ? Actor.fromJS(_data['lastActor']) : <any>undefined
    }
  }

  static fromJS(data: any): Dispute {
    data = typeof data === 'object' ? data : {}
    let result = new Dispute()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['disputedValue'] = this.disputedValue
    data['transactionId'] = this.transactionId
    data['initiatedByEntityId'] = this.initiatedByEntityId
    data['initiatedBy'] = this.initiatedBy
    data['resolvedByEntityId'] = this.resolvedByEntityId
    data['resolvedBy'] = this.resolvedBy
    data['adjustmentId'] = this.adjustmentId
    data['resolvedOn'] = this.resolvedOn ? this.resolvedOn.toISOString() : <any>undefined
    data['resolution'] = this.resolution
    if (this.extraMetadata) {
      data['extraMetadata'] = {}
      for (let key in this.extraMetadata) {
        if (this.extraMetadata.hasOwnProperty(key)) (<any>data['extraMetadata'])[key] = (<any>this.extraMetadata)[key]
      }
    }
    data['organizationId'] = this.organizationId
    data['entityId'] = this.entityId
    data['externalId'] = this.externalId
    data['description'] = this.description
    data['total'] = this.total
    data['referenceDate'] = this.referenceDate ? this.referenceDate.toISOString() : <any>undefined
    data['balance'] = this.balance
    data['number'] = this.number
    if (Array.isArray(this.refs)) {
      data['refs'] = []
      for (let item of this.refs) data['refs'].push(item.toJSON())
    }
    data['id'] = this.id
    data['accountId'] = this.accountId
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['lastModifiedOn'] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined
    data['lastActor'] = this.lastActor ? this.lastActor.toJSON() : <any>undefined
    return data
  }
}

export interface IDispute {
  disputedValue?: number | undefined
  transactionId?: string | undefined
  initiatedByEntityId?: string | undefined
  initiatedBy?: string | undefined
  resolvedByEntityId?: string | undefined
  resolvedBy?: string | undefined
  adjustmentId?: string | undefined
  resolvedOn?: Date | undefined
  resolution?: DisputeResolution | undefined
  extraMetadata?: { [key: string]: any } | undefined
  organizationId?: string | undefined
  entityId?: string | undefined
  externalId?: string | undefined
  description?: string | undefined
  total?: number | undefined
  referenceDate?: Date | undefined
  balance?: number | undefined
  number?: number | undefined
  refs?: Reference[] | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined
}

export class DisputeRequest implements IDisputeRequest {
  reason?: string | undefined
  description?: string | undefined
  extraMetadata?: { [key: string]: any } | undefined

  constructor(data?: IDisputeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reason = _data['reason']
      this.description = _data['description']
      if (_data['extraMetadata']) {
        this.extraMetadata = {} as any
        for (let key in _data['extraMetadata']) {
          if (_data['extraMetadata'].hasOwnProperty(key)) (<any>this.extraMetadata)![key] = _data['extraMetadata'][key]
        }
      }
    }
  }

  static fromJS(data: any): DisputeRequest {
    data = typeof data === 'object' ? data : {}
    let result = new DisputeRequest()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['reason'] = this.reason
    data['description'] = this.description
    if (this.extraMetadata) {
      data['extraMetadata'] = {}
      for (let key in this.extraMetadata) {
        if (this.extraMetadata.hasOwnProperty(key)) (<any>data['extraMetadata'])[key] = (<any>this.extraMetadata)[key]
      }
    }
    return data
  }
}

export interface IDisputeRequest {
  reason?: string | undefined
  description?: string | undefined
  extraMetadata?: { [key: string]: any } | undefined
}

export enum DisputeResolution {
  Unknown = 'Unknown',
  Approve = 'Approve',
  Reject = 'Reject',
}

export class EmailField implements IEmailField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IEmailField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): EmailField {
    data = typeof data === 'object' ? data : {}
    let result = new EmailField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IEmailField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class EntityBalance implements IEntityBalance {
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  balance?: number | undefined
  transactionNumber?: number | undefined
  pendingTotal?: number | undefined
  minBalance?: number | undefined
  maxBalance?: number | undefined
  autoRefill?: boolean | undefined

  constructor(data?: IEntityBalance) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.accountId = _data['accountId']
      this.name = _data['name']
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.lastModifiedOn = _data['lastModifiedOn'] ? new Date(_data['lastModifiedOn'].toString()) : <any>undefined
      this.balance = _data['balance']
      this.transactionNumber = _data['transactionNumber']
      this.pendingTotal = _data['pendingTotal']
      this.minBalance = _data['minBalance']
      this.maxBalance = _data['maxBalance']
      this.autoRefill = _data['autoRefill']
    }
  }

  static fromJS(data: any): EntityBalance {
    data = typeof data === 'object' ? data : {}
    let result = new EntityBalance()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['accountId'] = this.accountId
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['lastModifiedOn'] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined
    data['balance'] = this.balance
    data['transactionNumber'] = this.transactionNumber
    data['pendingTotal'] = this.pendingTotal
    data['minBalance'] = this.minBalance
    data['maxBalance'] = this.maxBalance
    data['autoRefill'] = this.autoRefill
    return data
  }
}

export interface IEntityBalance {
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  balance?: number | undefined
  transactionNumber?: number | undefined
  pendingTotal?: number | undefined
  minBalance?: number | undefined
  maxBalance?: number | undefined
  autoRefill?: boolean | undefined
}

export class EntityIntegration implements IEntityIntegration {
  integrationId?: string | undefined
  data?: string | undefined
  authentication?: string | undefined
  serviceName?: string | undefined
  isActive?: boolean | undefined

  constructor(data?: IEntityIntegration) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.integrationId = _data['integrationId']
      this.data = _data['data']
      this.authentication = _data['authentication']
      this.serviceName = _data['serviceName']
      this.isActive = _data['isActive']
    }
  }

  static fromJS(data: any): EntityIntegration {
    data = typeof data === 'object' ? data : {}
    let result = new EntityIntegration()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['integrationId'] = this.integrationId
    data['data'] = this.data
    data['authentication'] = this.authentication
    data['serviceName'] = this.serviceName
    data['isActive'] = this.isActive
    return data
  }
}

export interface IEntityIntegration {
  integrationId?: string | undefined
  data?: string | undefined
  authentication?: string | undefined
  serviceName?: string | undefined
  isActive?: boolean | undefined
}

export class EntityMetadata implements IEntityMetadata {
  entityId?: string | undefined
  partitionId?: string | undefined
  key?: string | undefined
  value?: string | undefined

  constructor(data?: IEntityMetadata) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityId = _data['entityId']
      this.partitionId = _data['partitionId']
      this.key = _data['key']
      this.value = _data['value']
    }
  }

  static fromJS(data: any): EntityMetadata {
    data = typeof data === 'object' ? data : {}
    let result = new EntityMetadata()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['entityId'] = this.entityId
    data['partitionId'] = this.partitionId
    data['key'] = this.key
    data['value'] = this.value
    return data
  }
}

export interface IEntityMetadata {
  entityId?: string | undefined
  partitionId?: string | undefined
  key?: string | undefined
  value?: string | undefined
}

export class EntityOpenSlots implements IEntityOpenSlots {
  accountId?: string | undefined
  entityId?: string | undefined
  appointmentTypeId?: string | undefined
  start?: Date | undefined
  end?: Date | undefined
  availability?: AppointmentTypeAvailability | undefined
  slots?: TimeSlot[] | undefined
  events?: CalendarEvent[] | undefined
  timeZoneInfo?: any | undefined
  appointmentType?: AppointmentType | undefined

  constructor(data?: IEntityOpenSlots) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accountId = _data['accountId']
      this.entityId = _data['entityId']
      this.appointmentTypeId = _data['appointmentTypeId']
      this.start = _data['start'] ? new Date(_data['start'].toString()) : <any>undefined
      this.end = _data['end'] ? new Date(_data['end'].toString()) : <any>undefined
      this.availability = _data['availability'] ? AppointmentTypeAvailability.fromJS(_data['availability']) : <any>undefined
      if (Array.isArray(_data['slots'])) {
        this.slots = [] as any
        for (let item of _data['slots']) this.slots!.push(TimeSlot.fromJS(item))
      }
      if (Array.isArray(_data['events'])) {
        this.events = [] as any
        for (let item of _data['events']) this.events!.push(CalendarEvent.fromJS(item))
      }
      this.timeZoneInfo = _data['timeZoneInfo']
      this.appointmentType = _data['appointmentType'] ? AppointmentType.fromJS(_data['appointmentType']) : <any>undefined
    }
  }

  static fromJS(data: any): EntityOpenSlots {
    data = typeof data === 'object' ? data : {}
    let result = new EntityOpenSlots()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['accountId'] = this.accountId
    data['entityId'] = this.entityId
    data['appointmentTypeId'] = this.appointmentTypeId
    data['start'] = this.start ? this.start.toISOString() : <any>undefined
    data['end'] = this.end ? this.end.toISOString() : <any>undefined
    data['availability'] = this.availability ? this.availability.toJSON() : <any>undefined
    if (Array.isArray(this.slots)) {
      data['slots'] = []
      for (let item of this.slots) data['slots'].push(item.toJSON())
    }
    if (Array.isArray(this.events)) {
      data['events'] = []
      for (let item of this.events) data['events'].push(item.toJSON())
    }
    data['timeZoneInfo'] = this.timeZoneInfo
    data['appointmentType'] = this.appointmentType ? this.appointmentType.toJSON() : <any>undefined
    return data
  }
}

export interface IEntityOpenSlots {
  accountId?: string | undefined
  entityId?: string | undefined
  appointmentTypeId?: string | undefined
  start?: Date | undefined
  end?: Date | undefined
  availability?: AppointmentTypeAvailability | undefined
  slots?: TimeSlot[] | undefined
  events?: CalendarEvent[] | undefined
  timeZoneInfo?: any | undefined
  appointmentType?: AppointmentType | undefined
}

export enum EntityRoleId {
  User = 'User',
  Manager = 'Manager',
  Admin = 'Admin',
  Root = 'Root',
  Disabled = 'Disabled',
  Organization = 'Organization',
  Account = 'Account',
  Integration = 'Integration',
  Contact = 'Contact',
  Profile = 'Profile',
}

export class EventType implements IEventType {
  trigger?: Trigger | undefined
  objectType?: string | undefined
  accountId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  name?: string | undefined

  constructor(data?: IEventType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.trigger = _data['trigger'] ? Trigger.fromJS(_data['trigger']) : <any>undefined
      this.objectType = _data['objectType']
      this.accountId = _data['accountId']
      this.description = _data['description']
      this.entityId = _data['entityId']
      this.id = _data['id']
      this.name = _data['name']
    }
  }

  static fromJS(data: any): EventType {
    data = typeof data === 'object' ? data : {}
    let result = new EventType()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['trigger'] = this.trigger ? this.trigger.toJSON() : <any>undefined
    data['objectType'] = this.objectType
    data['accountId'] = this.accountId
    data['description'] = this.description
    data['entityId'] = this.entityId
    data['id'] = this.id
    data['name'] = this.name
    return data
  }
}

export interface IEventType {
  trigger?: Trigger | undefined
  objectType?: string | undefined
  accountId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  name?: string | undefined
}

export class ExternalPage implements IExternalPage {
  url?: string | undefined
  openInNewWindow?: boolean | undefined
  readonly _t?: string | undefined
  menu?: Menu | undefined
  appMenu?: string | undefined
  hideAppBar?: boolean | undefined
  readonly type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IExternalPage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.url = _data['url']
      this.openInNewWindow = _data['openInNewWindow']
      ;(<any>this)._t = _data['_t']
      this.menu = _data['menu'] ? Menu.fromJS(_data['menu']) : <any>undefined
      this.appMenu = _data['appMenu']
      this.hideAppBar = _data['hideAppBar']
      ;(<any>this).type = _data['type']
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): ExternalPage {
    data = typeof data === 'object' ? data : {}
    let result = new ExternalPage()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['url'] = this.url
    data['openInNewWindow'] = this.openInNewWindow
    data['_t'] = this._t
    data['menu'] = this.menu ? this.menu.toJSON() : <any>undefined
    data['appMenu'] = this.appMenu
    data['hideAppBar'] = this.hideAppBar
    data['type'] = this.type
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IExternalPage {
  url?: string | undefined
  openInNewWindow?: boolean | undefined
  _t?: string | undefined
  menu?: Menu | undefined
  appMenu?: string | undefined
  hideAppBar?: boolean | undefined
  type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export enum ExternalProvider {
  Unknown = 'Unknown',
  Microsoft = 'Microsoft',
  InspireNet = 'InspireNet',
  Zoom = 'Zoom',
  SendGrid = 'SendGrid',
  GoToMeeting = 'GoToMeeting',
  Okta = 'Okta',
  Google = 'Google',
  RealMagic = 'RealMagic',
  Salesforce = 'Salesforce',
  Stripe = 'Stripe',
}

export class FieldMapperConfig implements IFieldMapperConfig {
  isRequired?: boolean | undefined
  name?: string | undefined
  label?: string | undefined
  source?: string | undefined
  type?: FIELDTYPE | undefined
  defaultValue?: any | undefined

  constructor(data?: IFieldMapperConfig) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isRequired = _data['isRequired']
      this.name = _data['name']
      this.label = _data['label']
      this.source = _data['source']
      this.type = _data['type']
      this.defaultValue = _data['defaultValue']
    }
  }

  static fromJS(data: any): FieldMapperConfig {
    data = typeof data === 'object' ? data : {}
    let result = new FieldMapperConfig()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['isRequired'] = this.isRequired
    data['name'] = this.name
    data['label'] = this.label
    data['source'] = this.source
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    return data
  }
}

export interface IFieldMapperConfig {
  isRequired?: boolean | undefined
  name?: string | undefined
  label?: string | undefined
  source?: string | undefined
  type?: FIELDTYPE | undefined
  defaultValue?: any | undefined
}

export class FieldOptions implements IFieldOptions {
  readonly _t?: string | undefined
  linkUrl?: string | undefined

  constructor(data?: IFieldOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this)._t = _data['_t']
      this.linkUrl = _data['linkUrl']
    }
  }

  static fromJS(data: any): FieldOptions {
    data = typeof data === 'object' ? data : {}
    let result = new FieldOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['_t'] = this._t
    data['linkUrl'] = this.linkUrl
    return data
  }
}

export interface IFieldOptions {
  _t?: string | undefined
  linkUrl?: string | undefined
}

export enum FieldPermission {
  None = 'None',
  Read = 'Read',
  Update = 'Update',
  SetOnCreate = 'SetOnCreate',
  Reset = 'Reset',
  CreateOnDemand = 'CreateOnDemand',
}

export class FieldRBAC implements IFieldRBAC {
  permissions?: { [key: string]: FieldPermission } | undefined

  constructor(data?: IFieldRBAC) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['permissions']) {
        this.permissions = {} as any
        for (let key in _data['permissions']) {
          if (_data['permissions'].hasOwnProperty(key)) (<any>this.permissions)![key] = _data['permissions'][key]
        }
      }
    }
  }

  static fromJS(data: any): FieldRBAC {
    data = typeof data === 'object' ? data : {}
    let result = new FieldRBAC()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (this.permissions) {
      data['permissions'] = {}
      for (let key in this.permissions) {
        if (this.permissions.hasOwnProperty(key)) (<any>data['permissions'])[key] = (<any>this.permissions)[key]
      }
    }
    return data
  }
}

export interface IFieldRBAC {
  permissions?: { [key: string]: FieldPermission } | undefined
}

export class FieldTemplate implements IFieldTemplate {
  field?: FormField | undefined
  rbac?: FieldRBAC | undefined
  indexed?: boolean | undefined
  initialValue?: any | undefined
  calculatedValue?: any | undefined

  constructor(data?: IFieldTemplate) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.field = _data['field'] ? FormField.fromJS(_data['field']) : <any>undefined
      this.rbac = _data['rbac'] ? FieldRBAC.fromJS(_data['rbac']) : <any>undefined
      this.indexed = _data['indexed']
      this.initialValue = _data['initialValue']
      this.calculatedValue = _data['calculatedValue']
    }
  }

  static fromJS(data: any): FieldTemplate {
    data = typeof data === 'object' ? data : {}
    let result = new FieldTemplate()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['field'] = this.field ? this.field.toJSON() : <any>undefined
    data['rbac'] = this.rbac ? this.rbac.toJSON() : <any>undefined
    data['indexed'] = this.indexed
    data['initialValue'] = this.initialValue
    data['calculatedValue'] = this.calculatedValue
    return data
  }
}

export interface IFieldTemplate {
  field?: FormField | undefined
  rbac?: FieldRBAC | undefined
  indexed?: boolean | undefined
  initialValue?: any | undefined
  calculatedValue?: any | undefined
}

export enum FIELDTYPE {
  Undefined = 'undefined',
  Address = 'address',
  Boolean = 'boolean',
  Date = 'date',
  Datetime = 'datetime',
  Email = 'email',
  Hidden = 'hidden',
  Number = 'number',
  Phone = 'phone',
  Postalcode = 'postalcode',
  Text = 'text',
  Time = 'time',
}

export class FileField implements IFileField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IFileField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): FileField {
    data = typeof data === 'object' ? data : {}
    let result = new FileField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IFileField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class Flow implements IFlow {
  embeddedFlowIds?: string[] | undefined
  objectType?: string | undefined
  accountId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  name?: string | undefined

  constructor(data?: IFlow) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['embeddedFlowIds'])) {
        this.embeddedFlowIds = [] as any
        for (let item of _data['embeddedFlowIds']) this.embeddedFlowIds!.push(item)
      }
      this.objectType = _data['objectType']
      this.accountId = _data['accountId']
      this.description = _data['description']
      this.entityId = _data['entityId']
      this.id = _data['id']
      this.name = _data['name']
    }
  }

  static fromJS(data: any): Flow {
    data = typeof data === 'object' ? data : {}
    let result = new Flow()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.embeddedFlowIds)) {
      data['embeddedFlowIds'] = []
      for (let item of this.embeddedFlowIds) data['embeddedFlowIds'].push(item)
    }
    data['objectType'] = this.objectType
    data['accountId'] = this.accountId
    data['description'] = this.description
    data['entityId'] = this.entityId
    data['id'] = this.id
    data['name'] = this.name
    return data
  }
}

export interface IFlow {
  embeddedFlowIds?: string[] | undefined
  objectType?: string | undefined
  accountId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  name?: string | undefined
}

export class FlowAction implements IFlowAction {
  accountId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  name?: string | undefined

  constructor(data?: IFlowAction) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accountId = _data['accountId']
      this.description = _data['description']
      this.entityId = _data['entityId']
      this.id = _data['id']
      this.name = _data['name']
    }
  }

  static fromJS(data: any): FlowAction {
    data = typeof data === 'object' ? data : {}
    let result = new FlowAction()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['accountId'] = this.accountId
    data['description'] = this.description
    data['entityId'] = this.entityId
    data['id'] = this.id
    data['name'] = this.name
    return data
  }
}

export interface IFlowAction {
  accountId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  name?: string | undefined
}

export class FlowStep implements IFlowStep {
  id?: string | undefined
  eventIdTrigger?: string | undefined
  currentStatusId?: string | undefined
  actionId?: string | undefined
  options?: IActionOptions | undefined
  description?: string | undefined
  iconName?: string | undefined

  constructor(data?: IFlowStep) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.eventIdTrigger = _data['eventIdTrigger']
      this.currentStatusId = _data['currentStatusId']
      this.actionId = _data['actionId']
      this.options = _data['options'] ? IActionOptions.fromJS(_data['options']) : <any>undefined
      this.description = _data['description']
      this.iconName = _data['iconName']
    }
  }

  static fromJS(data: any): FlowStep {
    data = typeof data === 'object' ? data : {}
    let result = new FlowStep()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['eventIdTrigger'] = this.eventIdTrigger
    data['currentStatusId'] = this.currentStatusId
    data['actionId'] = this.actionId
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['description'] = this.description
    data['iconName'] = this.iconName
    return data
  }
}

export interface IFlowStep {
  id?: string | undefined
  eventIdTrigger?: string | undefined
  currentStatusId?: string | undefined
  actionId?: string | undefined
  options?: IActionOptions | undefined
  description?: string | undefined
  iconName?: string | undefined
}

export class FlowStepUpdate implements IFlowStepUpdate {
  eventIdTrigger?: string | undefined
  currentStatusId?: string | undefined
  actionId?: string | undefined
  options?: any | undefined
  description?: string | undefined
  iconName?: string | undefined

  constructor(data?: IFlowStepUpdate) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.eventIdTrigger = _data['eventIdTrigger']
      this.currentStatusId = _data['currentStatusId']
      this.actionId = _data['actionId']
      this.options = _data['options']
      this.description = _data['description']
      this.iconName = _data['iconName']
    }
  }

  static fromJS(data: any): FlowStepUpdate {
    data = typeof data === 'object' ? data : {}
    let result = new FlowStepUpdate()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['eventIdTrigger'] = this.eventIdTrigger
    data['currentStatusId'] = this.currentStatusId
    data['actionId'] = this.actionId
    data['options'] = this.options
    data['description'] = this.description
    data['iconName'] = this.iconName
    return data
  }
}

export interface IFlowStepUpdate {
  eventIdTrigger?: string | undefined
  currentStatusId?: string | undefined
  actionId?: string | undefined
  options?: any | undefined
  description?: string | undefined
  iconName?: string | undefined
}

export class FlowTransition implements IFlowTransition {
  tag?: string | undefined
  entityId?: string | undefined
  currentFlowId?: string | undefined
  targetFlowId?: string | undefined

  constructor(data?: IFlowTransition) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tag = _data['tag']
      this.entityId = _data['entityId']
      this.currentFlowId = _data['currentFlowId']
      this.targetFlowId = _data['targetFlowId']
    }
  }

  static fromJS(data: any): FlowTransition {
    data = typeof data === 'object' ? data : {}
    let result = new FlowTransition()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['tag'] = this.tag
    data['entityId'] = this.entityId
    data['currentFlowId'] = this.currentFlowId
    data['targetFlowId'] = this.targetFlowId
    return data
  }
}

export interface IFlowTransition {
  tag?: string | undefined
  entityId?: string | undefined
  currentFlowId?: string | undefined
  targetFlowId?: string | undefined
}

export class Form implements IForm {
  readonly type?: string | undefined
  name?: string | undefined
  title?: string | undefined
  fields?: FormField[] | undefined
  isReadOnly?: boolean | undefined
  actions?: FormAction[] | undefined

  constructor(data?: IForm) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.name = _data['name']
      this.title = _data['title']
      if (Array.isArray(_data['fields'])) {
        this.fields = [] as any
        for (let item of _data['fields']) this.fields!.push(FormField.fromJS(item))
      }
      this.isReadOnly = _data['isReadOnly']
      if (Array.isArray(_data['actions'])) {
        this.actions = [] as any
        for (let item of _data['actions']) this.actions!.push(FormAction.fromJS(item))
      }
    }
  }

  static fromJS(data: any): Form {
    data = typeof data === 'object' ? data : {}
    let result = new Form()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['name'] = this.name
    data['title'] = this.title
    if (Array.isArray(this.fields)) {
      data['fields'] = []
      for (let item of this.fields) data['fields'].push(item.toJSON())
    }
    data['isReadOnly'] = this.isReadOnly
    if (Array.isArray(this.actions)) {
      data['actions'] = []
      for (let item of this.actions) data['actions'].push(item.toJSON())
    }
    return data
  }
}

export interface IForm {
  type?: string | undefined
  name?: string | undefined
  title?: string | undefined
  fields?: FormField[] | undefined
  isReadOnly?: boolean | undefined
  actions?: FormAction[] | undefined
}

export class FormAction implements IFormAction {
  action?: string | undefined
  readonly type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IFormAction) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.action = _data['action']
      ;(<any>this).type = _data['type']
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): FormAction {
    data = typeof data === 'object' ? data : {}
    let result = new FormAction()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['action'] = this.action
    data['type'] = this.type
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IFormAction {
  action?: string | undefined
  type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class FormField implements IFormField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IFormField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): FormField {
    data = typeof data === 'object' ? data : {}
    let result = new FormField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IFormField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export enum FormName {
  Add = 'Add',
  Edit = 'Edit',
  View = 'View',
  Details = 'Details',
}

export class FormPage implements IFormPage {
  form?: string | undefined
  readonly _t?: string | undefined
  menu?: Menu | undefined
  appMenu?: string | undefined
  hideAppBar?: boolean | undefined
  readonly type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IFormPage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.form = _data['form']
      ;(<any>this)._t = _data['_t']
      this.menu = _data['menu'] ? Menu.fromJS(_data['menu']) : <any>undefined
      this.appMenu = _data['appMenu']
      this.hideAppBar = _data['hideAppBar']
      ;(<any>this).type = _data['type']
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): FormPage {
    data = typeof data === 'object' ? data : {}
    let result = new FormPage()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['form'] = this.form
    data['_t'] = this._t
    data['menu'] = this.menu ? this.menu.toJSON() : <any>undefined
    data['appMenu'] = this.appMenu
    data['hideAppBar'] = this.hideAppBar
    data['type'] = this.type
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IFormPage {
  form?: string | undefined
  _t?: string | undefined
  menu?: Menu | undefined
  appMenu?: string | undefined
  hideAppBar?: boolean | undefined
  type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export enum FreeBusyStatus {
  Free = 'Free',
  Tentative = 'Tentative',
  Busy = 'Busy',
  Oof = 'Oof',
  WorkingElsewhere = 'WorkingElsewhere',
  Unknown = 'Unknown',
}

export class GenericField implements IGenericField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IGenericField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): GenericField {
    data = typeof data === 'object' ? data : {}
    let result = new GenericField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IGenericField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class GridPage implements IGridPage {
  grid?: string | undefined
  readonly _t?: string | undefined
  menu?: Menu | undefined
  appMenu?: string | undefined
  hideAppBar?: boolean | undefined
  readonly type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IGridPage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.grid = _data['grid']
      ;(<any>this)._t = _data['_t']
      this.menu = _data['menu'] ? Menu.fromJS(_data['menu']) : <any>undefined
      this.appMenu = _data['appMenu']
      this.hideAppBar = _data['hideAppBar']
      ;(<any>this).type = _data['type']
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): GridPage {
    data = typeof data === 'object' ? data : {}
    let result = new GridPage()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['grid'] = this.grid
    data['_t'] = this._t
    data['menu'] = this.menu ? this.menu.toJSON() : <any>undefined
    data['appMenu'] = this.appMenu
    data['hideAppBar'] = this.hideAppBar
    data['type'] = this.type
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IGridPage {
  grid?: string | undefined
  _t?: string | undefined
  menu?: Menu | undefined
  appMenu?: string | undefined
  hideAppBar?: boolean | undefined
  type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class HiddenField implements IHiddenField {
  readonly isVisible?: boolean | undefined
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined

  constructor(data?: IHiddenField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).isVisible = _data['isVisible']
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
    }
  }

  static fromJS(data: any): HiddenField {
    data = typeof data === 'object' ? data : {}
    let result = new HiddenField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['isVisible'] = this.isVisible
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    return data
  }
}

export interface IHiddenField {
  isVisible?: boolean | undefined
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
}

export class IActionOptions implements IIActionOptions {
  readonly eventDescription?: string | undefined
  readonly output?: ActionOutput[] | undefined

  constructor(data?: IIActionOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).eventDescription = _data['eventDescription']
      if (Array.isArray(_data['output'])) {
        ;(<any>this).output = [] as any
        for (let item of _data['output']) (<any>this).output!.push(ActionOutput.fromJS(item))
      }
    }
  }

  static fromJS(data: any): IActionOptions {
    data = typeof data === 'object' ? data : {}
    let result = new IActionOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['eventDescription'] = this.eventDescription
    if (Array.isArray(this.output)) {
      data['output'] = []
      for (let item of this.output) data['output'].push(item.toJSON())
    }
    return data
  }
}

export interface IIActionOptions {
  eventDescription?: string | undefined
  output?: ActionOutput[] | undefined
}

export enum Icons {
  Account = 'Account',
  Action = 'Action',
  Add = 'Add',
  Download = 'Download',
  Edit = 'Edit',
  Menu = 'Menu',
  More = 'More',
  Notifications = 'Notifications',
  Refresh = 'Refresh',
  Remove = 'Remove',
  Save = 'Save',
  Search = 'Search',
  Settings = 'Settings',
  Upload = 'Upload',
  Print = 'Print',
}

export class IDataViewResponse implements IIDataViewResponse {
  request?: DataViewRequest | undefined
  readonly result?: any[] | undefined
  view?: DataView | undefined
  readonly message?: string | undefined
  readonly nextUrl?: string | undefined
  objectType?: string | undefined
  id?: string | undefined
  objectId?: string | undefined

  constructor(data?: IIDataViewResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.request = _data['request'] ? DataViewRequest.fromJS(_data['request']) : <any>undefined
      if (Array.isArray(_data['result'])) {
        ;(<any>this).result = [] as any
        for (let item of _data['result']) (<any>this).result!.push(item)
      }
      this.view = _data['view'] ? DataView.fromJS(_data['view']) : <any>undefined
      ;(<any>this).message = _data['message']
      ;(<any>this).nextUrl = _data['nextUrl']
      this.objectType = _data['objectType']
      this.id = _data['id']
      this.objectId = _data['objectId']
    }
  }

  static fromJS(data: any): IDataViewResponse {
    data = typeof data === 'object' ? data : {}
    let result = new IDataViewResponse()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['request'] = this.request ? this.request.toJSON() : <any>undefined
    if (Array.isArray(this.result)) {
      data['result'] = []
      for (let item of this.result) data['result'].push(item)
    }
    data['view'] = this.view ? this.view.toJSON() : <any>undefined
    data['message'] = this.message
    data['nextUrl'] = this.nextUrl
    data['objectType'] = this.objectType
    data['id'] = this.id
    data['objectId'] = this.objectId
    return data
  }
}

export interface IIDataViewResponse {
  request?: DataViewRequest | undefined
  result?: any[] | undefined
  view?: DataView | undefined
  message?: string | undefined
  nextUrl?: string | undefined
  objectType?: string | undefined
  id?: string | undefined
  objectId?: string | undefined
}

export class Identity implements IIdentity {
  id?: string | undefined
  name?: string | undefined
  provider?: string | undefined
  externalId?: string | undefined

  constructor(data?: IIdentity) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.provider = _data['provider']
      this.externalId = _data['externalId']
    }
  }

  static fromJS(data: any): Identity {
    data = typeof data === 'object' ? data : {}
    let result = new Identity()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['provider'] = this.provider
    data['externalId'] = this.externalId
    return data
  }
}

export interface IIdentity {
  id?: string | undefined
  name?: string | undefined
  provider?: string | undefined
  externalId?: string | undefined
}

export class IEntityMetadata implements IIEntityMetadata {
  readonly entityId?: string | undefined
  readonly partitionId?: string | undefined
  readonly key?: string | undefined
  readonly value?: string | undefined

  constructor(data?: IIEntityMetadata) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).entityId = _data['entityId']
      ;(<any>this).partitionId = _data['partitionId']
      ;(<any>this).key = _data['key']
      ;(<any>this).value = _data['value']
    }
  }

  static fromJS(data: any): IEntityMetadata {
    data = typeof data === 'object' ? data : {}
    let result = new IEntityMetadata()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['entityId'] = this.entityId
    data['partitionId'] = this.partitionId
    data['key'] = this.key
    data['value'] = this.value
    return data
  }
}

export interface IIEntityMetadata {
  entityId?: string | undefined
  partitionId?: string | undefined
  key?: string | undefined
  value?: string | undefined
}

export class IntegrationEvent implements IIntegrationEvent {
  event?: string | undefined
  notes?: string | undefined
  data?: any | undefined

  constructor(data?: IIntegrationEvent) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.event = _data['event']
      this.notes = _data['notes']
      this.data = _data['data']
    }
  }

  static fromJS(data: any): IntegrationEvent {
    data = typeof data === 'object' ? data : {}
    let result = new IntegrationEvent()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['event'] = this.event
    data['notes'] = this.notes
    data['data'] = this.data
    return data
  }
}

export interface IIntegrationEvent {
  event?: string | undefined
  notes?: string | undefined
  data?: any | undefined
}

export class Invoice implements IInvoice {
  items?: InvoiceItem[] | undefined
  organizationId?: string | undefined
  entityId?: string | undefined
  externalId?: string | undefined
  description?: string | undefined
  total?: number | undefined
  referenceDate?: Date | undefined
  balance?: number | undefined
  number?: number | undefined
  refs?: Reference[] | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined

  constructor(data?: IInvoice) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any
        for (let item of _data['items']) this.items!.push(InvoiceItem.fromJS(item))
      }
      this.organizationId = _data['organizationId']
      this.entityId = _data['entityId']
      this.externalId = _data['externalId']
      this.description = _data['description']
      this.total = _data['total']
      this.referenceDate = _data['referenceDate'] ? new Date(_data['referenceDate'].toString()) : <any>undefined
      this.balance = _data['balance']
      this.number = _data['number']
      if (Array.isArray(_data['refs'])) {
        this.refs = [] as any
        for (let item of _data['refs']) this.refs!.push(Reference.fromJS(item))
      }
      this.id = _data['id']
      this.accountId = _data['accountId']
      this.name = _data['name']
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.lastModifiedOn = _data['lastModifiedOn'] ? new Date(_data['lastModifiedOn'].toString()) : <any>undefined
      this.lastActor = _data['lastActor'] ? Actor.fromJS(_data['lastActor']) : <any>undefined
    }
  }

  static fromJS(data: any): Invoice {
    data = typeof data === 'object' ? data : {}
    let result = new Invoice()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.items)) {
      data['items'] = []
      for (let item of this.items) data['items'].push(item.toJSON())
    }
    data['organizationId'] = this.organizationId
    data['entityId'] = this.entityId
    data['externalId'] = this.externalId
    data['description'] = this.description
    data['total'] = this.total
    data['referenceDate'] = this.referenceDate ? this.referenceDate.toISOString() : <any>undefined
    data['balance'] = this.balance
    data['number'] = this.number
    if (Array.isArray(this.refs)) {
      data['refs'] = []
      for (let item of this.refs) data['refs'].push(item.toJSON())
    }
    data['id'] = this.id
    data['accountId'] = this.accountId
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['lastModifiedOn'] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined
    data['lastActor'] = this.lastActor ? this.lastActor.toJSON() : <any>undefined
    return data
  }
}

export interface IInvoice {
  items?: InvoiceItem[] | undefined
  organizationId?: string | undefined
  entityId?: string | undefined
  externalId?: string | undefined
  description?: string | undefined
  total?: number | undefined
  referenceDate?: Date | undefined
  balance?: number | undefined
  number?: number | undefined
  refs?: Reference[] | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined
}

export class InvoiceItem implements IInvoiceItem {
  id?: string | undefined
  name?: string | undefined
  description?: string | undefined
  value?: number | undefined

  constructor(data?: IInvoiceItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.description = _data['description']
      this.value = _data['value']
    }
  }

  static fromJS(data: any): InvoiceItem {
    data = typeof data === 'object' ? data : {}
    let result = new InvoiceItem()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['description'] = this.description
    data['value'] = this.value
    return data
  }
}

export interface IInvoiceItem {
  id?: string | undefined
  name?: string | undefined
  description?: string | undefined
  value?: number | undefined
}

export class LabelField implements ILabelField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: ILabelField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): LabelField {
    data = typeof data === 'object' ? data : {}
    let result = new LabelField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface ILabelField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class LabelFieldOptions implements ILabelFieldOptions {
  style?: LabelStyle | undefined
  color?: PalletColor | undefined
  multline?: boolean | undefined
  readonly _t?: string | undefined
  linkUrl?: string | undefined

  constructor(data?: ILabelFieldOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.style = _data['style']
      this.color = _data['color']
      this.multline = _data['multline']
      ;(<any>this)._t = _data['_t']
      this.linkUrl = _data['linkUrl']
    }
  }

  static fromJS(data: any): LabelFieldOptions {
    data = typeof data === 'object' ? data : {}
    let result = new LabelFieldOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['style'] = this.style
    data['color'] = this.color
    data['multline'] = this.multline
    data['_t'] = this._t
    data['linkUrl'] = this.linkUrl
    return data
  }
}

export interface ILabelFieldOptions {
  style?: LabelStyle | undefined
  color?: PalletColor | undefined
  multline?: boolean | undefined
  _t?: string | undefined
  linkUrl?: string | undefined
}

export enum LabelStyle {
  Normal = 'Normal',
  Header = 'Header',
  Subheader = 'Subheader',
  Subheader2 = 'Subheader2',
  HTML = 'HTML',
}

export class LayoutContainer implements ILayoutContainer {
  type?: LayoutContainerType | undefined
  children?: LayoutItem[] | undefined
  spacing?: number | undefined
  justify?: LayoutJustify | undefined
  name?: string | undefined
  label?: string | undefined
  weight?: number | undefined
  style?: LayoutItemCssStyle | undefined

  constructor(data?: ILayoutContainer) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type']
      if (Array.isArray(_data['children'])) {
        this.children = [] as any
        for (let item of _data['children']) this.children!.push(LayoutItem.fromJS(item))
      }
      this.spacing = _data['spacing']
      this.justify = _data['justify']
      this.name = _data['name']
      this.label = _data['label']
      this.weight = _data['weight']
      this.style = _data['style'] ? LayoutItemCssStyle.fromJS(_data['style']) : <any>undefined
    }
  }

  static fromJS(data: any): LayoutContainer {
    data = typeof data === 'object' ? data : {}
    let result = new LayoutContainer()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    if (Array.isArray(this.children)) {
      data['children'] = []
      for (let item of this.children) data['children'].push(item.toJSON())
    }
    data['spacing'] = this.spacing
    data['justify'] = this.justify
    data['name'] = this.name
    data['label'] = this.label
    data['weight'] = this.weight
    data['style'] = this.style ? this.style.toJSON() : <any>undefined
    return data
  }
}

export interface ILayoutContainer {
  type?: LayoutContainerType | undefined
  children?: LayoutItem[] | undefined
  spacing?: number | undefined
  justify?: LayoutJustify | undefined
  name?: string | undefined
  label?: string | undefined
  weight?: number | undefined
  style?: LayoutItemCssStyle | undefined
}

export enum LayoutContainerType {
  Row = 'Row',
  Column = 'Column',
  Tabs = 'Tabs',
}

export class LayoutItem implements ILayoutItem {
  name?: string | undefined
  label?: string | undefined
  weight?: number | undefined
  style?: LayoutItemCssStyle | undefined

  constructor(data?: ILayoutItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name']
      this.label = _data['label']
      this.weight = _data['weight']
      this.style = _data['style'] ? LayoutItemCssStyle.fromJS(_data['style']) : <any>undefined
    }
  }

  static fromJS(data: any): LayoutItem {
    data = typeof data === 'object' ? data : {}
    let result = new LayoutItem()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['label'] = this.label
    data['weight'] = this.weight
    data['style'] = this.style ? this.style.toJSON() : <any>undefined
    return data
  }
}

export interface ILayoutItem {
  name?: string | undefined
  label?: string | undefined
  weight?: number | undefined
  style?: LayoutItemCssStyle | undefined
}

export class LayoutItemCssStyle implements ILayoutItemCssStyle {
  minWidth?: string | undefined
  maxWidth?: string | undefined
  minHeight?: string | undefined
  maxHeight?: string | undefined

  constructor(data?: ILayoutItemCssStyle) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.minWidth = _data['minWidth']
      this.maxWidth = _data['maxWidth']
      this.minHeight = _data['minHeight']
      this.maxHeight = _data['maxHeight']
    }
  }

  static fromJS(data: any): LayoutItemCssStyle {
    data = typeof data === 'object' ? data : {}
    let result = new LayoutItemCssStyle()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['minWidth'] = this.minWidth
    data['maxWidth'] = this.maxWidth
    data['minHeight'] = this.minHeight
    data['maxHeight'] = this.maxHeight
    return data
  }
}

export interface ILayoutItemCssStyle {
  minWidth?: string | undefined
  maxWidth?: string | undefined
  minHeight?: string | undefined
  maxHeight?: string | undefined
}

export enum LayoutJustify {
  Start = 'Start',
  End = 'End',
  Between = 'Between',
}

export class LayoutPage implements ILayoutPage {
  layout?: LayoutItem | undefined
  componentName?: string | undefined
  readonly _t?: string | undefined
  menu?: Menu | undefined
  appMenu?: string | undefined
  hideAppBar?: boolean | undefined
  readonly type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: ILayoutPage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.layout = _data['layout'] ? LayoutItem.fromJS(_data['layout']) : <any>undefined
      this.componentName = _data['componentName']
      ;(<any>this)._t = _data['_t']
      this.menu = _data['menu'] ? Menu.fromJS(_data['menu']) : <any>undefined
      this.appMenu = _data['appMenu']
      this.hideAppBar = _data['hideAppBar']
      ;(<any>this).type = _data['type']
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): LayoutPage {
    data = typeof data === 'object' ? data : {}
    let result = new LayoutPage()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['layout'] = this.layout ? this.layout.toJSON() : <any>undefined
    data['componentName'] = this.componentName
    data['_t'] = this._t
    data['menu'] = this.menu ? this.menu.toJSON() : <any>undefined
    data['appMenu'] = this.appMenu
    data['hideAppBar'] = this.hideAppBar
    data['type'] = this.type
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface ILayoutPage {
  layout?: LayoutItem | undefined
  componentName?: string | undefined
  _t?: string | undefined
  menu?: Menu | undefined
  appMenu?: string | undefined
  hideAppBar?: boolean | undefined
  type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class Lead implements ILead {
  accountId?: string | undefined
  entityId?: string | undefined
  leadTypeId?: string | undefined
  assignedEntityId?: string | undefined
  id?: string | undefined
  objectStatusId?: string | undefined
  flowId?: string | undefined
  isActive?: boolean | undefined
  communicationPreferences?: { [key: string]: string } | undefined
  convertedOn?: Date | undefined
  replacedById?: string | undefined
  timeZoneId?: string | undefined
  name?: string | undefined
  description?: string | undefined
  address?: string | undefined
  city?: string | undefined
  country?: string | undefined
  email?: string | undefined
  phone?: string | undefined
  postalCode?: string | undefined
  state?: string | undefined
  createdOn?: Date | undefined
  notes?: string | undefined

  constructor(data?: ILead) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accountId = _data['accountId']
      this.entityId = _data['entityId']
      this.leadTypeId = _data['leadTypeId']
      this.assignedEntityId = _data['assignedEntityId']
      this.id = _data['id']
      this.objectStatusId = _data['objectStatusId']
      this.flowId = _data['flowId']
      this.isActive = _data['isActive']
      if (_data['communicationPreferences']) {
        this.communicationPreferences = {} as any
        for (let key in _data['communicationPreferences']) {
          if (_data['communicationPreferences'].hasOwnProperty(key)) (<any>this.communicationPreferences)![key] = _data['communicationPreferences'][key]
        }
      }
      this.convertedOn = _data['convertedOn'] ? new Date(_data['convertedOn'].toString()) : <any>undefined
      this.replacedById = _data['replacedById']
      this.timeZoneId = _data['timeZoneId']
      this.name = _data['name']
      this.description = _data['description']
      this.address = _data['address']
      this.city = _data['city']
      this.country = _data['country']
      this.email = _data['email']
      this.phone = _data['phone']
      this.postalCode = _data['postalCode']
      this.state = _data['state']
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.notes = _data['notes']
    }
  }

  static fromJS(data: any): Lead {
    data = typeof data === 'object' ? data : {}
    let result = new Lead()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['accountId'] = this.accountId
    data['entityId'] = this.entityId
    data['leadTypeId'] = this.leadTypeId
    data['assignedEntityId'] = this.assignedEntityId
    data['id'] = this.id
    data['objectStatusId'] = this.objectStatusId
    data['flowId'] = this.flowId
    data['isActive'] = this.isActive
    if (this.communicationPreferences) {
      data['communicationPreferences'] = {}
      for (let key in this.communicationPreferences) {
        if (this.communicationPreferences.hasOwnProperty(key)) (<any>data['communicationPreferences'])[key] = (<any>this.communicationPreferences)[key]
      }
    }
    data['convertedOn'] = this.convertedOn ? this.convertedOn.toISOString() : <any>undefined
    data['replacedById'] = this.replacedById
    data['timeZoneId'] = this.timeZoneId
    data['name'] = this.name
    data['description'] = this.description
    data['address'] = this.address
    data['city'] = this.city
    data['country'] = this.country
    data['email'] = this.email
    data['phone'] = this.phone
    data['postalCode'] = this.postalCode
    data['state'] = this.state
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['notes'] = this.notes
    return data
  }
}

export interface ILead {
  accountId?: string | undefined
  entityId?: string | undefined
  leadTypeId?: string | undefined
  assignedEntityId?: string | undefined
  id?: string | undefined
  objectStatusId?: string | undefined
  flowId?: string | undefined
  isActive?: boolean | undefined
  communicationPreferences?: { [key: string]: string } | undefined
  convertedOn?: Date | undefined
  replacedById?: string | undefined
  timeZoneId?: string | undefined
  name?: string | undefined
  description?: string | undefined
  address?: string | undefined
  city?: string | undefined
  country?: string | undefined
  email?: string | undefined
  phone?: string | undefined
  postalCode?: string | undefined
  state?: string | undefined
  createdOn?: Date | undefined
  notes?: string | undefined
}

export class LeadAggregation implements ILeadAggregation {
  start?: Date | undefined
  end?: Date | undefined
  entityId?: string | undefined
  data?: LeadAggregationRow[] | undefined

  constructor(data?: ILeadAggregation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.start = _data['start'] ? new Date(_data['start'].toString()) : <any>undefined
      this.end = _data['end'] ? new Date(_data['end'].toString()) : <any>undefined
      this.entityId = _data['entityId']
      if (Array.isArray(_data['data'])) {
        this.data = [] as any
        for (let item of _data['data']) this.data!.push(LeadAggregationRow.fromJS(item))
      }
    }
  }

  static fromJS(data: any): LeadAggregation {
    data = typeof data === 'object' ? data : {}
    let result = new LeadAggregation()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['start'] = this.start ? this.start.toISOString() : <any>undefined
    data['end'] = this.end ? this.end.toISOString() : <any>undefined
    data['entityId'] = this.entityId
    if (Array.isArray(this.data)) {
      data['data'] = []
      for (let item of this.data) data['data'].push(item.toJSON())
    }
    return data
  }
}

export interface ILeadAggregation {
  start?: Date | undefined
  end?: Date | undefined
  entityId?: string | undefined
  data?: LeadAggregationRow[] | undefined
}

export class LeadAggregationRow implements ILeadAggregationRow {
  createdOn?: Date | undefined
  name?: string | undefined
  count?: number | undefined

  constructor(data?: ILeadAggregationRow) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.name = _data['name']
      this.count = _data['count']
    }
  }

  static fromJS(data: any): LeadAggregationRow {
    data = typeof data === 'object' ? data : {}
    let result = new LeadAggregationRow()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['name'] = this.name
    data['count'] = this.count
    return data
  }
}

export interface ILeadAggregationRow {
  createdOn?: Date | undefined
  name?: string | undefined
  count?: number | undefined
}

export class LeadIntegration implements ILeadIntegration {
  integrationId?: string | undefined
  externalId?: string | undefined
  integration?: string | undefined
  status?: string | undefined
  url?: string | undefined
  tag?: string | undefined

  constructor(data?: ILeadIntegration) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.integrationId = _data['integrationId']
      this.externalId = _data['externalId']
      this.integration = _data['integration']
      this.status = _data['status']
      this.url = _data['url']
      this.tag = _data['tag']
    }
  }

  static fromJS(data: any): LeadIntegration {
    data = typeof data === 'object' ? data : {}
    let result = new LeadIntegration()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['integrationId'] = this.integrationId
    data['externalId'] = this.externalId
    data['integration'] = this.integration
    data['status'] = this.status
    data['url'] = this.url
    data['tag'] = this.tag
    return data
  }
}

export interface ILeadIntegration {
  integrationId?: string | undefined
  externalId?: string | undefined
  integration?: string | undefined
  status?: string | undefined
  url?: string | undefined
  tag?: string | undefined
}

export class Leads implements ILeads {
  leadTypeId?: string | undefined
  list?: Lead[] | undefined
  fields?: FormField[] | undefined

  constructor(data?: ILeads) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.leadTypeId = _data['leadTypeId']
      if (Array.isArray(_data['list'])) {
        this.list = [] as any
        for (let item of _data['list']) this.list!.push(Lead.fromJS(item))
      }
      if (Array.isArray(_data['fields'])) {
        this.fields = [] as any
        for (let item of _data['fields']) this.fields!.push(FormField.fromJS(item))
      }
    }
  }

  static fromJS(data: any): Leads {
    data = typeof data === 'object' ? data : {}
    let result = new Leads()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['leadTypeId'] = this.leadTypeId
    if (Array.isArray(this.list)) {
      data['list'] = []
      for (let item of this.list) data['list'].push(item.toJSON())
    }
    if (Array.isArray(this.fields)) {
      data['fields'] = []
      for (let item of this.fields) data['fields'].push(item.toJSON())
    }
    return data
  }
}

export interface ILeads {
  leadTypeId?: string | undefined
  list?: Lead[] | undefined
  fields?: FormField[] | undefined
}

export class LeadSearchResult implements ILeadSearchResult {
  id?: string | undefined
  entityId?: string | undefined
  name?: string | undefined
  email?: string | undefined
  phone?: string | undefined
  address?: string | undefined
  city?: string | undefined
  state?: string | undefined
  postalCode?: string | undefined
  country?: string | undefined
  assignedEntityId?: string | undefined
  leadStatusId?: string | undefined
  createdOn?: Date | undefined
  leadTypeId?: string | undefined

  constructor(data?: ILeadSearchResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.entityId = _data['entityId']
      this.name = _data['name']
      this.email = _data['email']
      this.phone = _data['phone']
      this.address = _data['address']
      this.city = _data['city']
      this.state = _data['state']
      this.postalCode = _data['postalCode']
      this.country = _data['country']
      this.assignedEntityId = _data['assignedEntityId']
      this.leadStatusId = _data['leadStatusId']
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.leadTypeId = _data['leadTypeId']
    }
  }

  static fromJS(data: any): LeadSearchResult {
    data = typeof data === 'object' ? data : {}
    let result = new LeadSearchResult()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['entityId'] = this.entityId
    data['name'] = this.name
    data['email'] = this.email
    data['phone'] = this.phone
    data['address'] = this.address
    data['city'] = this.city
    data['state'] = this.state
    data['postalCode'] = this.postalCode
    data['country'] = this.country
    data['assignedEntityId'] = this.assignedEntityId
    data['leadStatusId'] = this.leadStatusId
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['leadTypeId'] = this.leadTypeId
    return data
  }
}

export interface ILeadSearchResult {
  id?: string | undefined
  entityId?: string | undefined
  name?: string | undefined
  email?: string | undefined
  phone?: string | undefined
  address?: string | undefined
  city?: string | undefined
  state?: string | undefined
  postalCode?: string | undefined
  country?: string | undefined
  assignedEntityId?: string | undefined
  leadStatusId?: string | undefined
  createdOn?: Date | undefined
  leadTypeId?: string | undefined
}

export class LeadSearchResults implements ILeadSearchResults {
  search?: Search | undefined
  results?: LeadSearchResult[] | undefined

  constructor(data?: ILeadSearchResults) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.search = _data['search'] ? Search.fromJS(_data['search']) : <any>undefined
      if (Array.isArray(_data['results'])) {
        this.results = [] as any
        for (let item of _data['results']) this.results!.push(LeadSearchResult.fromJS(item))
      }
    }
  }

  static fromJS(data: any): LeadSearchResults {
    data = typeof data === 'object' ? data : {}
    let result = new LeadSearchResults()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['search'] = this.search ? this.search.toJSON() : <any>undefined
    if (Array.isArray(this.results)) {
      data['results'] = []
      for (let item of this.results) data['results'].push(item.toJSON())
    }
    return data
  }
}

export interface ILeadSearchResults {
  search?: Search | undefined
  results?: LeadSearchResult[] | undefined
}

export class LeadStatus implements ILeadStatus {
  accountId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  name?: string | undefined

  constructor(data?: ILeadStatus) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accountId = _data['accountId']
      this.description = _data['description']
      this.entityId = _data['entityId']
      this.id = _data['id']
      this.name = _data['name']
    }
  }

  static fromJS(data: any): LeadStatus {
    data = typeof data === 'object' ? data : {}
    let result = new LeadStatus()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['accountId'] = this.accountId
    data['description'] = this.description
    data['entityId'] = this.entityId
    data['id'] = this.id
    data['name'] = this.name
    return data
  }
}

export interface ILeadStatus {
  accountId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  name?: string | undefined
}

export class LeadType implements ILeadType {
  id?: string | undefined
  entityId?: string | undefined
  name?: string | undefined
  flowId?: string | undefined

  constructor(data?: ILeadType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.entityId = _data['entityId']
      this.name = _data['name']
      this.flowId = _data['flowId']
    }
  }

  static fromJS(data: any): LeadType {
    data = typeof data === 'object' ? data : {}
    let result = new LeadType()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['entityId'] = this.entityId
    data['name'] = this.name
    data['flowId'] = this.flowId
    return data
  }
}

export interface ILeadType {
  id?: string | undefined
  entityId?: string | undefined
  name?: string | undefined
  flowId?: string | undefined
}

export class LeadTypeIntegrationSettings implements ILeadTypeIntegrationSettings {
  integrationId?: string | undefined
  isRequired?: boolean | undefined
  createIfMissing?: boolean | undefined
  externalIdFields?: LeadTypeIntegrationSettingsExternalField[] | undefined

  constructor(data?: ILeadTypeIntegrationSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.integrationId = _data['integrationId']
      this.isRequired = _data['isRequired']
      this.createIfMissing = _data['createIfMissing']
      if (Array.isArray(_data['externalIdFields'])) {
        this.externalIdFields = [] as any
        for (let item of _data['externalIdFields']) this.externalIdFields!.push(LeadTypeIntegrationSettingsExternalField.fromJS(item))
      }
    }
  }

  static fromJS(data: any): LeadTypeIntegrationSettings {
    data = typeof data === 'object' ? data : {}
    let result = new LeadTypeIntegrationSettings()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['integrationId'] = this.integrationId
    data['isRequired'] = this.isRequired
    data['createIfMissing'] = this.createIfMissing
    if (Array.isArray(this.externalIdFields)) {
      data['externalIdFields'] = []
      for (let item of this.externalIdFields) data['externalIdFields'].push(item.toJSON())
    }
    return data
  }
}

export interface ILeadTypeIntegrationSettings {
  integrationId?: string | undefined
  isRequired?: boolean | undefined
  createIfMissing?: boolean | undefined
  externalIdFields?: LeadTypeIntegrationSettingsExternalField[] | undefined
}

export class LeadTypeIntegrationSettingsExternalField implements ILeadTypeIntegrationSettingsExternalField {
  name?: string | undefined
  tag?: string | undefined
  saveData?: boolean | undefined
  urlField?: string | undefined
  statusField?: string | undefined

  constructor(data?: ILeadTypeIntegrationSettingsExternalField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name']
      this.tag = _data['tag']
      this.saveData = _data['saveData']
      this.urlField = _data['urlField']
      this.statusField = _data['statusField']
    }
  }

  static fromJS(data: any): LeadTypeIntegrationSettingsExternalField {
    data = typeof data === 'object' ? data : {}
    let result = new LeadTypeIntegrationSettingsExternalField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['tag'] = this.tag
    data['saveData'] = this.saveData
    data['urlField'] = this.urlField
    data['statusField'] = this.statusField
    return data
  }
}

export interface ILeadTypeIntegrationSettingsExternalField {
  name?: string | undefined
  tag?: string | undefined
  saveData?: boolean | undefined
  urlField?: string | undefined
  statusField?: string | undefined
}

export class LeadTypeSettings implements ILeadTypeSettings {
  fields?: FieldMapperConfig[] | undefined
  rejectOnValidationError?: boolean | undefined
  postValidation?: string[] | undefined
  entityIdOverrideField?: string | undefined
  createdOnOverrideField?: string | undefined
  updatePolicy?: LeadTypeUpdatePolicy | undefined
  integration?: LeadTypeIntegrationSettings | undefined

  constructor(data?: ILeadTypeSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['fields'])) {
        this.fields = [] as any
        for (let item of _data['fields']) this.fields!.push(FieldMapperConfig.fromJS(item))
      }
      this.rejectOnValidationError = _data['rejectOnValidationError']
      if (Array.isArray(_data['postValidation'])) {
        this.postValidation = [] as any
        for (let item of _data['postValidation']) this.postValidation!.push(item)
      }
      this.entityIdOverrideField = _data['entityIdOverrideField']
      this.createdOnOverrideField = _data['createdOnOverrideField']
      this.updatePolicy = _data['updatePolicy'] ? LeadTypeUpdatePolicy.fromJS(_data['updatePolicy']) : <any>undefined
      this.integration = _data['integration'] ? LeadTypeIntegrationSettings.fromJS(_data['integration']) : <any>undefined
    }
  }

  static fromJS(data: any): LeadTypeSettings {
    data = typeof data === 'object' ? data : {}
    let result = new LeadTypeSettings()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.fields)) {
      data['fields'] = []
      for (let item of this.fields) data['fields'].push(item.toJSON())
    }
    data['rejectOnValidationError'] = this.rejectOnValidationError
    if (Array.isArray(this.postValidation)) {
      data['postValidation'] = []
      for (let item of this.postValidation) data['postValidation'].push(item)
    }
    data['entityIdOverrideField'] = this.entityIdOverrideField
    data['createdOnOverrideField'] = this.createdOnOverrideField
    data['updatePolicy'] = this.updatePolicy ? this.updatePolicy.toJSON() : <any>undefined
    data['integration'] = this.integration ? this.integration.toJSON() : <any>undefined
    return data
  }
}

export interface ILeadTypeSettings {
  fields?: FieldMapperConfig[] | undefined
  rejectOnValidationError?: boolean | undefined
  postValidation?: string[] | undefined
  entityIdOverrideField?: string | undefined
  createdOnOverrideField?: string | undefined
  updatePolicy?: LeadTypeUpdatePolicy | undefined
  integration?: LeadTypeIntegrationSettings | undefined
}

export class LeadTypeUpdatePolicy implements ILeadTypeUpdatePolicy {
  ignoreUpdates?: boolean | undefined
  updateExisting?: boolean | undefined
  allowUnsetProperty?: boolean | undefined
  leadIdField?: string | undefined

  constructor(data?: ILeadTypeUpdatePolicy) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ignoreUpdates = _data['ignoreUpdates']
      this.updateExisting = _data['updateExisting']
      this.allowUnsetProperty = _data['allowUnsetProperty']
      this.leadIdField = _data['leadIdField']
    }
  }

  static fromJS(data: any): LeadTypeUpdatePolicy {
    data = typeof data === 'object' ? data : {}
    let result = new LeadTypeUpdatePolicy()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['ignoreUpdates'] = this.ignoreUpdates
    data['updateExisting'] = this.updateExisting
    data['allowUnsetProperty'] = this.allowUnsetProperty
    data['leadIdField'] = this.leadIdField
    return data
  }
}

export interface ILeadTypeUpdatePolicy {
  ignoreUpdates?: boolean | undefined
  updateExisting?: boolean | undefined
  allowUnsetProperty?: boolean | undefined
  leadIdField?: string | undefined
}

export class LookupField implements ILookupField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: ILookupField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): LookupField {
    data = typeof data === 'object' ? data : {}
    let result = new LookupField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface ILookupField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class LookupFieldOptions implements ILookupFieldOptions {
  entity?: string | undefined
  query?: DataQuery | undefined
  valueProperty?: string | undefined
  nameProperty?: string | undefined
  items?: { [key: string]: any } | undefined
  readonly _t?: string | undefined
  linkUrl?: string | undefined

  constructor(data?: ILookupFieldOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entity = _data['entity']
      this.query = _data['query'] ? DataQuery.fromJS(_data['query']) : <any>undefined
      this.valueProperty = _data['valueProperty']
      this.nameProperty = _data['nameProperty']
      if (_data['items']) {
        this.items = {} as any
        for (let key in _data['items']) {
          if (_data['items'].hasOwnProperty(key)) (<any>this.items)![key] = _data['items'][key]
        }
      }
      ;(<any>this)._t = _data['_t']
      this.linkUrl = _data['linkUrl']
    }
  }

  static fromJS(data: any): LookupFieldOptions {
    data = typeof data === 'object' ? data : {}
    let result = new LookupFieldOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['entity'] = this.entity
    data['query'] = this.query ? this.query.toJSON() : <any>undefined
    data['valueProperty'] = this.valueProperty
    data['nameProperty'] = this.nameProperty
    if (this.items) {
      data['items'] = {}
      for (let key in this.items) {
        if (this.items.hasOwnProperty(key)) (<any>data['items'])[key] = (<any>this.items)[key]
      }
    }
    data['_t'] = this._t
    data['linkUrl'] = this.linkUrl
    return data
  }
}

export interface ILookupFieldOptions {
  entity?: string | undefined
  query?: DataQuery | undefined
  valueProperty?: string | undefined
  nameProperty?: string | undefined
  items?: { [key: string]: any } | undefined
  _t?: string | undefined
  linkUrl?: string | undefined
}

export class Menu implements IMenu {
  items?: MenuItem[] | undefined
  collapsible?: boolean | undefined
  readonly _t?: string | undefined
  icon?: Icons | undefined
  readonly type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IMenu) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any
        for (let item of _data['items']) this.items!.push(MenuItem.fromJS(item))
      }
      this.collapsible = _data['collapsible']
      ;(<any>this)._t = _data['_t']
      this.icon = _data['icon']
      ;(<any>this).type = _data['type']
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): Menu {
    data = typeof data === 'object' ? data : {}
    let result = new Menu()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.items)) {
      data['items'] = []
      for (let item of this.items) data['items'].push(item.toJSON())
    }
    data['collapsible'] = this.collapsible
    data['_t'] = this._t
    data['icon'] = this.icon
    data['type'] = this.type
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IMenu {
  items?: MenuItem[] | undefined
  collapsible?: boolean | undefined
  _t?: string | undefined
  icon?: Icons | undefined
  type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class MenuItem implements IMenuItem {
  readonly _t?: string | undefined
  icon?: Icons | undefined
  readonly type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IMenuItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this)._t = _data['_t']
      this.icon = _data['icon']
      ;(<any>this).type = _data['type']
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): MenuItem {
    data = typeof data === 'object' ? data : {}
    let result = new MenuItem()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['_t'] = this._t
    data['icon'] = this.icon
    data['type'] = this.type
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IMenuItem {
  _t?: string | undefined
  icon?: Icons | undefined
  type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class MergeUserCandidate implements IMergeUserCandidate {
  identityId?: string | undefined
  entityId?: string | undefined
  name?: string | undefined
  email?: string | undefined
  role?: EntityRoleId | undefined
  context?: string | undefined

  constructor(data?: IMergeUserCandidate) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.identityId = _data['identityId']
      this.entityId = _data['entityId']
      this.name = _data['name']
      this.email = _data['email']
      this.role = _data['role']
      this.context = _data['context']
    }
  }

  static fromJS(data: any): MergeUserCandidate {
    data = typeof data === 'object' ? data : {}
    let result = new MergeUserCandidate()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['identityId'] = this.identityId
    data['entityId'] = this.entityId
    data['name'] = this.name
    data['email'] = this.email
    data['role'] = this.role
    data['context'] = this.context
    return data
  }
}

export interface IMergeUserCandidate {
  identityId?: string | undefined
  entityId?: string | undefined
  name?: string | undefined
  email?: string | undefined
  role?: EntityRoleId | undefined
  context?: string | undefined
}

export class MergeUserCandidateMatch implements IMergeUserCandidateMatch {
  user1?: MergeUserCandidate | undefined
  user2?: MergeUserCandidate | undefined

  constructor(data?: IMergeUserCandidateMatch) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user1 = _data['user1'] ? MergeUserCandidate.fromJS(_data['user1']) : <any>undefined
      this.user2 = _data['user2'] ? MergeUserCandidate.fromJS(_data['user2']) : <any>undefined
    }
  }

  static fromJS(data: any): MergeUserCandidateMatch {
    data = typeof data === 'object' ? data : {}
    let result = new MergeUserCandidateMatch()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['user1'] = this.user1 ? this.user1.toJSON() : <any>undefined
    data['user2'] = this.user2 ? this.user2.toJSON() : <any>undefined
    return data
  }
}

export interface IMergeUserCandidateMatch {
  user1?: MergeUserCandidate | undefined
  user2?: MergeUserCandidate | undefined
}

export class NamedSlot implements INamedSlot {
  name?: string | undefined
  start?: Date | undefined
  end?: Date | undefined

  constructor(data?: INamedSlot) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name']
      this.start = _data['start'] ? new Date(_data['start'].toString()) : <any>undefined
      this.end = _data['end'] ? new Date(_data['end'].toString()) : <any>undefined
    }
  }

  static fromJS(data: any): NamedSlot {
    data = typeof data === 'object' ? data : {}
    let result = new NamedSlot()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['start'] = this.start ? this.start.toISOString() : <any>undefined
    data['end'] = this.end ? this.end.toISOString() : <any>undefined
    return data
  }
}

export interface INamedSlot {
  name?: string | undefined
  start?: Date | undefined
  end?: Date | undefined
}

export class NoteReq implements INoteReq {
  contentFormat?: ContentFormat | undefined
  content?: string | undefined
  subject?: string | undefined

  constructor(data?: INoteReq) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contentFormat = _data['contentFormat']
      this.content = _data['content']
      this.subject = _data['subject']
    }
  }

  static fromJS(data: any): NoteReq {
    data = typeof data === 'object' ? data : {}
    let result = new NoteReq()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['contentFormat'] = this.contentFormat
    data['content'] = this.content
    data['subject'] = this.subject
    return data
  }
}

export interface INoteReq {
  contentFormat?: ContentFormat | undefined
  content?: string | undefined
  subject?: string | undefined
}

export class NumberField implements INumberField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: INumberField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): NumberField {
    data = typeof data === 'object' ? data : {}
    let result = new NumberField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface INumberField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class NumberFieldOptions implements INumberFieldOptions {
  style?: NumberFieldOptionsStyle | undefined
  decimalPlaces?: number | undefined
  readonly _t?: string | undefined
  linkUrl?: string | undefined

  constructor(data?: INumberFieldOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.style = _data['style']
      this.decimalPlaces = _data['decimalPlaces']
      ;(<any>this)._t = _data['_t']
      this.linkUrl = _data['linkUrl']
    }
  }

  static fromJS(data: any): NumberFieldOptions {
    data = typeof data === 'object' ? data : {}
    let result = new NumberFieldOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['style'] = this.style
    data['decimalPlaces'] = this.decimalPlaces
    data['_t'] = this._t
    data['linkUrl'] = this.linkUrl
    return data
  }
}

export interface INumberFieldOptions {
  style?: NumberFieldOptionsStyle | undefined
  decimalPlaces?: number | undefined
  _t?: string | undefined
  linkUrl?: string | undefined
}

export enum NumberFieldOptionsStyle {
  Default = 'Default',
  Currency = 'Currency',
  Rating = 'Rating',
  Price = 'Price',
}

export class ObjectField implements IObjectField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IObjectField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): ObjectField {
    data = typeof data === 'object' ? data : {}
    let result = new ObjectField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IObjectField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class ObjectFieldOptions implements IObjectFieldOptions {
  objectType?: string | undefined
  form?: Form | undefined
  readonly _t?: string | undefined
  linkUrl?: string | undefined

  constructor(data?: IObjectFieldOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.objectType = _data['objectType']
      this.form = _data['form'] ? Form.fromJS(_data['form']) : <any>undefined
      ;(<any>this)._t = _data['_t']
      this.linkUrl = _data['linkUrl']
    }
  }

  static fromJS(data: any): ObjectFieldOptions {
    data = typeof data === 'object' ? data : {}
    let result = new ObjectFieldOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['objectType'] = this.objectType
    data['form'] = this.form ? this.form.toJSON() : <any>undefined
    data['_t'] = this._t
    data['linkUrl'] = this.linkUrl
    return data
  }
}

export interface IObjectFieldOptions {
  objectType?: string | undefined
  form?: Form | undefined
  _t?: string | undefined
  linkUrl?: string | undefined
}

export class ObjectLayoutItem implements IObjectLayoutItem {
  url?: string | undefined
  lazyLoad?: boolean | undefined
  name?: string | undefined
  label?: string | undefined
  weight?: number | undefined
  style?: LayoutItemCssStyle | undefined

  constructor(data?: IObjectLayoutItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.url = _data['url']
      this.lazyLoad = _data['lazyLoad']
      this.name = _data['name']
      this.label = _data['label']
      this.weight = _data['weight']
      this.style = _data['style'] ? LayoutItemCssStyle.fromJS(_data['style']) : <any>undefined
    }
  }

  static fromJS(data: any): ObjectLayoutItem {
    data = typeof data === 'object' ? data : {}
    let result = new ObjectLayoutItem()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['url'] = this.url
    data['lazyLoad'] = this.lazyLoad
    data['name'] = this.name
    data['label'] = this.label
    data['weight'] = this.weight
    data['style'] = this.style ? this.style.toJSON() : <any>undefined
    return data
  }
}

export interface IObjectLayoutItem {
  url?: string | undefined
  lazyLoad?: boolean | undefined
  name?: string | undefined
  label?: string | undefined
  weight?: number | undefined
  style?: LayoutItemCssStyle | undefined
}

export class ObjectStatus implements IObjectStatus {
  objectType?: string | undefined
  accountId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  name?: string | undefined

  constructor(data?: IObjectStatus) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.objectType = _data['objectType']
      this.accountId = _data['accountId']
      this.description = _data['description']
      this.entityId = _data['entityId']
      this.id = _data['id']
      this.name = _data['name']
    }
  }

  static fromJS(data: any): ObjectStatus {
    data = typeof data === 'object' ? data : {}
    let result = new ObjectStatus()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['objectType'] = this.objectType
    data['accountId'] = this.accountId
    data['description'] = this.description
    data['entityId'] = this.entityId
    data['id'] = this.id
    data['name'] = this.name
    return data
  }
}

export interface IObjectStatus {
  objectType?: string | undefined
  accountId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  name?: string | undefined
}

export class ObjectType implements IObjectType {
  createdOn?: Date | undefined
  objectStatusId?: string | undefined
  flowId?: string | undefined
  isActive?: boolean | undefined
  nativeType?: string | undefined
  initialFlowId?: string | undefined
  initialObjectStatusId?: string | undefined
  uniqueExternalId?: boolean | undefined
  rbac?: ObjectTypeRBAC | undefined
  fields?: { [key: string]: FieldTemplate } | undefined
  collectionName?: string | undefined
  isCustom?: boolean | undefined
  tags?: string[] | undefined
  accountId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  name?: string | undefined

  constructor(data?: IObjectType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.objectStatusId = _data['objectStatusId']
      this.flowId = _data['flowId']
      this.isActive = _data['isActive']
      this.nativeType = _data['nativeType']
      this.initialFlowId = _data['initialFlowId']
      this.initialObjectStatusId = _data['initialObjectStatusId']
      this.uniqueExternalId = _data['uniqueExternalId']
      this.rbac = _data['rbac'] ? ObjectTypeRBAC.fromJS(_data['rbac']) : <any>undefined
      if (_data['fields']) {
        this.fields = {} as any
        for (let key in _data['fields']) {
          if (_data['fields'].hasOwnProperty(key))
            (<any>this.fields)![key] = _data['fields'][key] ? FieldTemplate.fromJS(_data['fields'][key]) : new FieldTemplate()
        }
      }
      this.collectionName = _data['collectionName']
      this.isCustom = _data['isCustom']
      if (Array.isArray(_data['tags'])) {
        this.tags = [] as any
        for (let item of _data['tags']) this.tags!.push(item)
      }
      this.accountId = _data['accountId']
      this.description = _data['description']
      this.entityId = _data['entityId']
      this.id = _data['id']
      this.name = _data['name']
    }
  }

  static fromJS(data: any): ObjectType {
    data = typeof data === 'object' ? data : {}
    let result = new ObjectType()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['objectStatusId'] = this.objectStatusId
    data['flowId'] = this.flowId
    data['isActive'] = this.isActive
    data['nativeType'] = this.nativeType
    data['initialFlowId'] = this.initialFlowId
    data['initialObjectStatusId'] = this.initialObjectStatusId
    data['uniqueExternalId'] = this.uniqueExternalId
    data['rbac'] = this.rbac ? this.rbac.toJSON() : <any>undefined
    if (this.fields) {
      data['fields'] = {}
      for (let key in this.fields) {
        if (this.fields.hasOwnProperty(key)) (<any>data['fields'])[key] = this.fields[key] ? this.fields[key].toJSON() : <any>undefined
      }
    }
    data['collectionName'] = this.collectionName
    data['isCustom'] = this.isCustom
    if (Array.isArray(this.tags)) {
      data['tags'] = []
      for (let item of this.tags) data['tags'].push(item)
    }
    data['accountId'] = this.accountId
    data['description'] = this.description
    data['entityId'] = this.entityId
    data['id'] = this.id
    data['name'] = this.name
    return data
  }
}

export interface IObjectType {
  createdOn?: Date | undefined
  objectStatusId?: string | undefined
  flowId?: string | undefined
  isActive?: boolean | undefined
  nativeType?: string | undefined
  initialFlowId?: string | undefined
  initialObjectStatusId?: string | undefined
  uniqueExternalId?: boolean | undefined
  rbac?: ObjectTypeRBAC | undefined
  fields?: { [key: string]: FieldTemplate } | undefined
  collectionName?: string | undefined
  isCustom?: boolean | undefined
  tags?: string[] | undefined
  accountId?: string | undefined
  description?: string | undefined
  entityId?: string | undefined
  id?: string | undefined
  name?: string | undefined
}

export enum ObjectTypePermission {
  None = 'None',
  Read = 'Read',
  Update = 'Update',
  Create = 'Create',
  Delete = 'Delete',
  Import = 'Import',
  Export = 'Export',
  BulkDelete = 'BulkDelete',
  BulkTag = 'BulkTag',
  Customize = 'Customize',
}

export class ObjectTypeRBAC implements IObjectTypeRBAC {
  permissions?: { [key: string]: ObjectTypePermission } | undefined

  constructor(data?: IObjectTypeRBAC) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['permissions']) {
        this.permissions = {} as any
        for (let key in _data['permissions']) {
          if (_data['permissions'].hasOwnProperty(key)) (<any>this.permissions)![key] = _data['permissions'][key]
        }
      }
    }
  }

  static fromJS(data: any): ObjectTypeRBAC {
    data = typeof data === 'object' ? data : {}
    let result = new ObjectTypeRBAC()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (this.permissions) {
      data['permissions'] = {}
      for (let key in this.permissions) {
        if (this.permissions.hasOwnProperty(key)) (<any>data['permissions'])[key] = (<any>this.permissions)[key]
      }
    }
    return data
  }
}

export interface IObjectTypeRBAC {
  permissions?: { [key: string]: ObjectTypePermission } | undefined
}

export class ObjectTypeService implements IObjectTypeService {
  constructor(data?: IObjectTypeService) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): ObjectTypeService {
    data = typeof data === 'object' ? data : {}
    let result = new ObjectTypeService()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    return data
  }
}

export interface IObjectTypeService {}

export enum Operator {
  Eq = 'Eq',
  Ne = 'Ne',
  Gt = 'Gt',
  Gte = 'Gte',
  Lt = 'Lt',
  Lte = 'Lte',
  In = 'In',
}

export class Organization implements IOrganization {
  id?: string | undefined
  name?: string | undefined
  accountId?: string | undefined
  isActive?: boolean | undefined
  identities?: Identity[] | undefined
  timeZoneId?: string | undefined

  constructor(data?: IOrganization) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.accountId = _data['accountId']
      this.isActive = _data['isActive']
      if (Array.isArray(_data['identities'])) {
        this.identities = [] as any
        for (let item of _data['identities']) this.identities!.push(Identity.fromJS(item))
      }
      this.timeZoneId = _data['timeZoneId']
    }
  }

  static fromJS(data: any): Organization {
    data = typeof data === 'object' ? data : {}
    let result = new Organization()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['accountId'] = this.accountId
    data['isActive'] = this.isActive
    if (Array.isArray(this.identities)) {
      data['identities'] = []
      for (let item of this.identities) data['identities'].push(item.toJSON())
    }
    data['timeZoneId'] = this.timeZoneId
    return data
  }
}

export interface IOrganization {
  id?: string | undefined
  name?: string | undefined
  accountId?: string | undefined
  isActive?: boolean | undefined
  identities?: Identity[] | undefined
  timeZoneId?: string | undefined
}

export class OrganizationResp implements IOrganizationResp {
  id?: string | undefined
  name?: string | undefined
  description?: string | undefined
  address?: string | undefined
  city?: string | undefined
  country?: string | undefined
  email?: string | undefined
  phone?: string | undefined
  postalCode?: string | undefined
  state?: string | undefined
  websiteUrl?: string | undefined
  timeZoneId?: string | undefined

  constructor(data?: IOrganizationResp) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.description = _data['description']
      this.address = _data['address']
      this.city = _data['city']
      this.country = _data['country']
      this.email = _data['email']
      this.phone = _data['phone']
      this.postalCode = _data['postalCode']
      this.state = _data['state']
      this.websiteUrl = _data['websiteUrl']
      this.timeZoneId = _data['timeZoneId']
    }
  }

  static fromJS(data: any): OrganizationResp {
    data = typeof data === 'object' ? data : {}
    let result = new OrganizationResp()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['description'] = this.description
    data['address'] = this.address
    data['city'] = this.city
    data['country'] = this.country
    data['email'] = this.email
    data['phone'] = this.phone
    data['postalCode'] = this.postalCode
    data['state'] = this.state
    data['websiteUrl'] = this.websiteUrl
    data['timeZoneId'] = this.timeZoneId
    return data
  }
}

export interface IOrganizationResp {
  id?: string | undefined
  name?: string | undefined
  description?: string | undefined
  address?: string | undefined
  city?: string | undefined
  country?: string | undefined
  email?: string | undefined
  phone?: string | undefined
  postalCode?: string | undefined
  state?: string | undefined
  websiteUrl?: string | undefined
  timeZoneId?: string | undefined
}

export class Page implements IPage {
  readonly _t?: string | undefined
  menu?: Menu | undefined
  appMenu?: string | undefined
  hideAppBar?: boolean | undefined
  readonly type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IPage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this)._t = _data['_t']
      this.menu = _data['menu'] ? Menu.fromJS(_data['menu']) : <any>undefined
      this.appMenu = _data['appMenu']
      this.hideAppBar = _data['hideAppBar']
      ;(<any>this).type = _data['type']
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): Page {
    data = typeof data === 'object' ? data : {}
    let result = new Page()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['_t'] = this._t
    data['menu'] = this.menu ? this.menu.toJSON() : <any>undefined
    data['appMenu'] = this.appMenu
    data['hideAppBar'] = this.hideAppBar
    data['type'] = this.type
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IPage {
  _t?: string | undefined
  menu?: Menu | undefined
  appMenu?: string | undefined
  hideAppBar?: boolean | undefined
  type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class PageMenuItem implements IPageMenuItem {
  page?: string | undefined
  readonly _t?: string | undefined
  icon?: Icons | undefined
  readonly type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IPageMenuItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page']
      ;(<any>this)._t = _data['_t']
      this.icon = _data['icon']
      ;(<any>this).type = _data['type']
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): PageMenuItem {
    data = typeof data === 'object' ? data : {}
    let result = new PageMenuItem()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['page'] = this.page
    data['_t'] = this._t
    data['icon'] = this.icon
    data['type'] = this.type
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IPageMenuItem {
  page?: string | undefined
  _t?: string | undefined
  icon?: Icons | undefined
  type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export enum PalletColor {
  Default = 'Default',
  Primary = 'Primary',
  Secondary = 'Secondary',
  TextPrimary = 'TextPrimary',
  TextSecondary = 'TextSecondary',
  Error = 'Error',
}

export class Parameter implements IParameter {
  name?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  type?: BsonType | undefined

  constructor(data?: IParameter) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.type = _data['type']
    }
  }

  static fromJS(data: any): Parameter {
    data = typeof data === 'object' ? data : {}
    let result = new Parameter()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['type'] = this.type
    return data
  }
}

export interface IParameter {
  name?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  type?: BsonType | undefined
}

export class PasswordField implements IPasswordField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IPasswordField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): PasswordField {
    data = typeof data === 'object' ? data : {}
    let result = new PasswordField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IPasswordField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class Payment implements IPayment {
  source?: string | undefined
  externalUrl?: string | undefined
  organizationId?: string | undefined
  entityId?: string | undefined
  externalId?: string | undefined
  description?: string | undefined
  total?: number | undefined
  referenceDate?: Date | undefined
  balance?: number | undefined
  number?: number | undefined
  refs?: Reference[] | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined

  constructor(data?: IPayment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.source = _data['source']
      this.externalUrl = _data['externalUrl']
      this.organizationId = _data['organizationId']
      this.entityId = _data['entityId']
      this.externalId = _data['externalId']
      this.description = _data['description']
      this.total = _data['total']
      this.referenceDate = _data['referenceDate'] ? new Date(_data['referenceDate'].toString()) : <any>undefined
      this.balance = _data['balance']
      this.number = _data['number']
      if (Array.isArray(_data['refs'])) {
        this.refs = [] as any
        for (let item of _data['refs']) this.refs!.push(Reference.fromJS(item))
      }
      this.id = _data['id']
      this.accountId = _data['accountId']
      this.name = _data['name']
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.lastModifiedOn = _data['lastModifiedOn'] ? new Date(_data['lastModifiedOn'].toString()) : <any>undefined
      this.lastActor = _data['lastActor'] ? Actor.fromJS(_data['lastActor']) : <any>undefined
    }
  }

  static fromJS(data: any): Payment {
    data = typeof data === 'object' ? data : {}
    let result = new Payment()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['source'] = this.source
    data['externalUrl'] = this.externalUrl
    data['organizationId'] = this.organizationId
    data['entityId'] = this.entityId
    data['externalId'] = this.externalId
    data['description'] = this.description
    data['total'] = this.total
    data['referenceDate'] = this.referenceDate ? this.referenceDate.toISOString() : <any>undefined
    data['balance'] = this.balance
    data['number'] = this.number
    if (Array.isArray(this.refs)) {
      data['refs'] = []
      for (let item of this.refs) data['refs'].push(item.toJSON())
    }
    data['id'] = this.id
    data['accountId'] = this.accountId
    data['name'] = this.name
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['lastModifiedOn'] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined
    data['lastActor'] = this.lastActor ? this.lastActor.toJSON() : <any>undefined
    return data
  }
}

export interface IPayment {
  source?: string | undefined
  externalUrl?: string | undefined
  organizationId?: string | undefined
  entityId?: string | undefined
  externalId?: string | undefined
  description?: string | undefined
  total?: number | undefined
  referenceDate?: Date | undefined
  balance?: number | undefined
  number?: number | undefined
  refs?: Reference[] | undefined
  id?: string | undefined
  accountId?: string | undefined
  name?: string | undefined
  createdOn?: Date | undefined
  lastModifiedOn?: Date | undefined
  lastActor?: Actor | undefined
}

export class PhoneField implements IPhoneField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IPhoneField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): PhoneField {
    data = typeof data === 'object' ? data : {}
    let result = new PhoneField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IPhoneField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class PostalCodeField implements IPostalCodeField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IPostalCodeField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): PostalCodeField {
    data = typeof data === 'object' ? data : {}
    let result = new PostalCodeField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IPostalCodeField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class Reference implements IReference {
  id?: string | undefined
  type?: string | undefined
  tag?: string | undefined

  constructor(data?: IReference) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.type = _data['type']
      this.tag = _data['tag']
    }
  }

  static fromJS(data: any): Reference {
    data = typeof data === 'object' ? data : {}
    let result = new Reference()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['type'] = this.type
    data['tag'] = this.tag
    return data
  }
}

export interface IReference {
  id?: string | undefined
  type?: string | undefined
  tag?: string | undefined
}

export class ReferenceField implements IReferenceField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IReferenceField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): ReferenceField {
    data = typeof data === 'object' ? data : {}
    let result = new ReferenceField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IReferenceField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class ReferenceFieldOptions implements IReferenceFieldOptions {
  objectType?: string | undefined
  criteria?: Condition[] | undefined
  autoComplete?: boolean | undefined
  foreignFieldName?: string | undefined
  showDescription?: boolean | undefined
  showImage?: boolean | undefined
  actions?: FormAction[] | undefined
  items?: { [key: string]: any } | undefined
  readonly _t?: string | undefined
  linkUrl?: string | undefined

  constructor(data?: IReferenceFieldOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.objectType = _data['objectType']
      if (Array.isArray(_data['criteria'])) {
        this.criteria = [] as any
        for (let item of _data['criteria']) this.criteria!.push(Condition.fromJS(item))
      }
      this.autoComplete = _data['autoComplete']
      this.foreignFieldName = _data['foreignFieldName']
      this.showDescription = _data['showDescription']
      this.showImage = _data['showImage']
      if (Array.isArray(_data['actions'])) {
        this.actions = [] as any
        for (let item of _data['actions']) this.actions!.push(FormAction.fromJS(item))
      }
      if (_data['items']) {
        this.items = {} as any
        for (let key in _data['items']) {
          if (_data['items'].hasOwnProperty(key)) (<any>this.items)![key] = _data['items'][key]
        }
      }
      ;(<any>this)._t = _data['_t']
      this.linkUrl = _data['linkUrl']
    }
  }

  static fromJS(data: any): ReferenceFieldOptions {
    data = typeof data === 'object' ? data : {}
    let result = new ReferenceFieldOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['objectType'] = this.objectType
    if (Array.isArray(this.criteria)) {
      data['criteria'] = []
      for (let item of this.criteria) data['criteria'].push(item.toJSON())
    }
    data['autoComplete'] = this.autoComplete
    data['foreignFieldName'] = this.foreignFieldName
    data['showDescription'] = this.showDescription
    data['showImage'] = this.showImage
    if (Array.isArray(this.actions)) {
      data['actions'] = []
      for (let item of this.actions) data['actions'].push(item.toJSON())
    }
    if (this.items) {
      data['items'] = {}
      for (let key in this.items) {
        if (this.items.hasOwnProperty(key)) (<any>data['items'])[key] = (<any>this.items)[key]
      }
    }
    data['_t'] = this._t
    data['linkUrl'] = this.linkUrl
    return data
  }
}

export interface IReferenceFieldOptions {
  objectType?: string | undefined
  criteria?: Condition[] | undefined
  autoComplete?: boolean | undefined
  foreignFieldName?: string | undefined
  showDescription?: boolean | undefined
  showImage?: boolean | undefined
  actions?: FormAction[] | undefined
  items?: { [key: string]: any } | undefined
  _t?: string | undefined
  linkUrl?: string | undefined
}

export class ReferenceValue implements IReferenceValue {
  id?: string | undefined
  value?: string | undefined
  description?: string | undefined
  imageUrl?: string | undefined

  constructor(data?: IReferenceValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.value = _data['value']
      this.description = _data['description']
      this.imageUrl = _data['imageUrl']
    }
  }

  static fromJS(data: any): ReferenceValue {
    data = typeof data === 'object' ? data : {}
    let result = new ReferenceValue()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['value'] = this.value
    data['description'] = this.description
    data['imageUrl'] = this.imageUrl
    return data
  }
}

export interface IReferenceValue {
  id?: string | undefined
  value?: string | undefined
  description?: string | undefined
  imageUrl?: string | undefined
}

export class RelatedObjectsField implements IRelatedObjectsField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IRelatedObjectsField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): RelatedObjectsField {
    data = typeof data === 'object' ? data : {}
    let result = new RelatedObjectsField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IRelatedObjectsField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class RelatedObjectsFieldOptions implements IRelatedObjectsFieldOptions {
  url?: string | undefined
  criteria?: Condition[] | undefined
  readonly _t?: string | undefined
  linkUrl?: string | undefined

  constructor(data?: IRelatedObjectsFieldOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.url = _data['url']
      if (Array.isArray(_data['criteria'])) {
        this.criteria = [] as any
        for (let item of _data['criteria']) this.criteria!.push(Condition.fromJS(item))
      }
      ;(<any>this)._t = _data['_t']
      this.linkUrl = _data['linkUrl']
    }
  }

  static fromJS(data: any): RelatedObjectsFieldOptions {
    data = typeof data === 'object' ? data : {}
    let result = new RelatedObjectsFieldOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['url'] = this.url
    if (Array.isArray(this.criteria)) {
      data['criteria'] = []
      for (let item of this.criteria) data['criteria'].push(item.toJSON())
    }
    data['_t'] = this._t
    data['linkUrl'] = this.linkUrl
    return data
  }
}

export interface IRelatedObjectsFieldOptions {
  url?: string | undefined
  criteria?: Condition[] | undefined
  _t?: string | undefined
  linkUrl?: string | undefined
}

export class ResolveDisputeRequest implements IResolveDisputeRequest {
  value?: number | undefined
  description?: string | undefined
  notes?: string | undefined
  resolution?: DisputeResolution | undefined

  constructor(data?: IResolveDisputeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data['value']
      this.description = _data['description']
      this.notes = _data['notes']
      this.resolution = _data['resolution']
    }
  }

  static fromJS(data: any): ResolveDisputeRequest {
    data = typeof data === 'object' ? data : {}
    let result = new ResolveDisputeRequest()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['value'] = this.value
    data['description'] = this.description
    data['notes'] = this.notes
    data['resolution'] = this.resolution
    return data
  }
}

export interface IResolveDisputeRequest {
  value?: number | undefined
  description?: string | undefined
  notes?: string | undefined
  resolution?: DisputeResolution | undefined
}

export enum ResponseType {
  None = 'None',
  Organizer = 'Organizer',
  TentativelyAccepted = 'TentativelyAccepted',
  Accepted = 'Accepted',
  Declined = 'Declined',
  NotResponded = 'NotResponded',
}

export class ScheduleAppointmentRequest implements IScheduleAppointmentRequest {
  start?: Date | undefined
  end?: Date | undefined
  userId?: string | undefined
  notes?: string | undefined
  parentObjectId?: string | undefined
  readonly parentObjectType?: string | undefined
  parentFieldName?: string | undefined

  constructor(data?: IScheduleAppointmentRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.start = _data['start'] ? new Date(_data['start'].toString()) : <any>undefined
      this.end = _data['end'] ? new Date(_data['end'].toString()) : <any>undefined
      this.userId = _data['userId']
      this.notes = _data['notes']
      this.parentObjectId = _data['parentObjectId']
      ;(<any>this).parentObjectType = _data['parentObjectType']
      this.parentFieldName = _data['parentFieldName']
    }
  }

  static fromJS(data: any): ScheduleAppointmentRequest {
    data = typeof data === 'object' ? data : {}
    let result = new ScheduleAppointmentRequest()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['start'] = this.start ? this.start.toISOString() : <any>undefined
    data['end'] = this.end ? this.end.toISOString() : <any>undefined
    data['userId'] = this.userId
    data['notes'] = this.notes
    data['parentObjectId'] = this.parentObjectId
    data['parentObjectType'] = this.parentObjectType
    data['parentFieldName'] = this.parentFieldName
    return data
  }
}

export interface IScheduleAppointmentRequest {
  start?: Date | undefined
  end?: Date | undefined
  userId?: string | undefined
  notes?: string | undefined
  parentObjectId?: string | undefined
  parentObjectType?: string | undefined
  parentFieldName?: string | undefined
}

export class SchedulerFeatureSetting implements ISchedulerFeatureSetting {
  label?: string | undefined
  isAllowed?: boolean | undefined
  isVisible?: boolean | undefined
  fallbackInstructions?: string | undefined

  constructor(data?: ISchedulerFeatureSetting) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.label = _data['label']
      this.isAllowed = _data['isAllowed']
      this.isVisible = _data['isVisible']
      this.fallbackInstructions = _data['fallbackInstructions']
    }
  }

  static fromJS(data: any): SchedulerFeatureSetting {
    data = typeof data === 'object' ? data : {}
    let result = new SchedulerFeatureSetting()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['label'] = this.label
    data['isAllowed'] = this.isAllowed
    data['isVisible'] = this.isVisible
    data['fallbackInstructions'] = this.fallbackInstructions
    return data
  }
}

export interface ISchedulerFeatureSetting {
  label?: string | undefined
  isAllowed?: boolean | undefined
  isVisible?: boolean | undefined
  fallbackInstructions?: string | undefined
}

export class SchedulerPageSettings implements ISchedulerPageSettings {
  header?: string | undefined
  subHeader?: string | undefined
  settings?: { [key: string]: SchedulerFeatureSetting } | undefined

  constructor(data?: ISchedulerPageSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.header = _data['header']
      this.subHeader = _data['subHeader']
      if (_data['settings']) {
        this.settings = {} as any
        for (let key in _data['settings']) {
          if (_data['settings'].hasOwnProperty(key))
            (<any>this.settings)![key] = _data['settings'][key] ? SchedulerFeatureSetting.fromJS(_data['settings'][key]) : new SchedulerFeatureSetting()
        }
      }
    }
  }

  static fromJS(data: any): SchedulerPageSettings {
    data = typeof data === 'object' ? data : {}
    let result = new SchedulerPageSettings()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['header'] = this.header
    data['subHeader'] = this.subHeader
    if (this.settings) {
      data['settings'] = {}
      for (let key in this.settings) {
        if (this.settings.hasOwnProperty(key)) (<any>data['settings'])[key] = this.settings[key] ? this.settings[key].toJSON() : <any>undefined
      }
    }
    return data
  }
}

export interface ISchedulerPageSettings {
  header?: string | undefined
  subHeader?: string | undefined
  settings?: { [key: string]: SchedulerFeatureSetting } | undefined
}

export enum SchedulingPolicy {
  NextDay = 'NextDay',
  FromNow = 'FromNow',
}

export class SchedulingSettings implements ISchedulingSettings {
  minMinutesFromNow?: number | undefined
  maxMinutesFromNow?: number | undefined
  duration?: number | undefined
  startMinutesMod?: number | undefined
  eventBufferInMinutes?: number | undefined
  expiration?: number | undefined
  userPolicy?: UserPolicy | undefined
  schedulingPolicy?: SchedulingPolicy | undefined
  includeStatuses?: FreeBusyStatus[] | undefined
  excludeResponseTypes?: ResponseType[] | undefined
  excludeSensitivities?: Sensitivity[] | undefined

  constructor(data?: ISchedulingSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.minMinutesFromNow = _data['minMinutesFromNow']
      this.maxMinutesFromNow = _data['maxMinutesFromNow']
      this.duration = _data['duration']
      this.startMinutesMod = _data['startMinutesMod']
      this.eventBufferInMinutes = _data['eventBufferInMinutes']
      this.expiration = _data['expiration']
      this.userPolicy = _data['userPolicy']
      this.schedulingPolicy = _data['schedulingPolicy']
      if (Array.isArray(_data['includeStatuses'])) {
        this.includeStatuses = [] as any
        for (let item of _data['includeStatuses']) this.includeStatuses!.push(item)
      }
      if (Array.isArray(_data['excludeResponseTypes'])) {
        this.excludeResponseTypes = [] as any
        for (let item of _data['excludeResponseTypes']) this.excludeResponseTypes!.push(item)
      }
      if (Array.isArray(_data['excludeSensitivities'])) {
        this.excludeSensitivities = [] as any
        for (let item of _data['excludeSensitivities']) this.excludeSensitivities!.push(item)
      }
    }
  }

  static fromJS(data: any): SchedulingSettings {
    data = typeof data === 'object' ? data : {}
    let result = new SchedulingSettings()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['minMinutesFromNow'] = this.minMinutesFromNow
    data['maxMinutesFromNow'] = this.maxMinutesFromNow
    data['duration'] = this.duration
    data['startMinutesMod'] = this.startMinutesMod
    data['eventBufferInMinutes'] = this.eventBufferInMinutes
    data['expiration'] = this.expiration
    data['userPolicy'] = this.userPolicy
    data['schedulingPolicy'] = this.schedulingPolicy
    if (Array.isArray(this.includeStatuses)) {
      data['includeStatuses'] = []
      for (let item of this.includeStatuses) data['includeStatuses'].push(item)
    }
    if (Array.isArray(this.excludeResponseTypes)) {
      data['excludeResponseTypes'] = []
      for (let item of this.excludeResponseTypes) data['excludeResponseTypes'].push(item)
    }
    if (Array.isArray(this.excludeSensitivities)) {
      data['excludeSensitivities'] = []
      for (let item of this.excludeSensitivities) data['excludeSensitivities'].push(item)
    }
    return data
  }
}

export interface ISchedulingSettings {
  minMinutesFromNow?: number | undefined
  maxMinutesFromNow?: number | undefined
  duration?: number | undefined
  startMinutesMod?: number | undefined
  eventBufferInMinutes?: number | undefined
  expiration?: number | undefined
  userPolicy?: UserPolicy | undefined
  schedulingPolicy?: SchedulingPolicy | undefined
  includeStatuses?: FreeBusyStatus[] | undefined
  excludeResponseTypes?: ResponseType[] | undefined
  excludeSensitivities?: Sensitivity[] | undefined
}

export class Search implements ISearch {
  criteria?: Condition[] | undefined
  top?: number | undefined
  orderBy?: string | undefined
  skip?: number | undefined

  constructor(data?: ISearch) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['criteria'])) {
        this.criteria = [] as any
        for (let item of _data['criteria']) this.criteria!.push(Condition.fromJS(item))
      }
      this.top = _data['top']
      this.orderBy = _data['orderBy']
      this.skip = _data['skip']
    }
  }

  static fromJS(data: any): Search {
    data = typeof data === 'object' ? data : {}
    let result = new Search()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.criteria)) {
      data['criteria'] = []
      for (let item of this.criteria) data['criteria'].push(item.toJSON())
    }
    data['top'] = this.top
    data['orderBy'] = this.orderBy
    data['skip'] = this.skip
    return data
  }
}

export interface ISearch {
  criteria?: Condition[] | undefined
  top?: number | undefined
  orderBy?: string | undefined
  skip?: number | undefined
}

export class SelectField implements ISelectField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: ISelectField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): SelectField {
    data = typeof data === 'object' ? data : {}
    let result = new SelectField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface ISelectField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class SelectFieldOptions implements ISelectFieldOptions {
  items?: { [key: string]: any } | undefined
  readonly _t?: string | undefined
  linkUrl?: string | undefined

  constructor(data?: ISelectFieldOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['items']) {
        this.items = {} as any
        for (let key in _data['items']) {
          if (_data['items'].hasOwnProperty(key)) (<any>this.items)![key] = _data['items'][key]
        }
      }
      ;(<any>this)._t = _data['_t']
      this.linkUrl = _data['linkUrl']
    }
  }

  static fromJS(data: any): SelectFieldOptions {
    data = typeof data === 'object' ? data : {}
    let result = new SelectFieldOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (this.items) {
      data['items'] = {}
      for (let key in this.items) {
        if (this.items.hasOwnProperty(key)) (<any>data['items'])[key] = (<any>this.items)[key]
      }
    }
    data['_t'] = this._t
    data['linkUrl'] = this.linkUrl
    return data
  }
}

export interface ISelectFieldOptions {
  items?: { [key: string]: any } | undefined
  _t?: string | undefined
  linkUrl?: string | undefined
}

export enum Sensitivity {
  Normal = 'Normal',
  Personal = 'Personal',
  Private = 'Private',
  Confidential = 'Confidential',
}

export class SessionConfig implements ISessionConfig {
  id?: string | undefined
  entityId?: string | undefined
  name?: string | undefined
  timeZoneId?: string | undefined
  organization?: OrganizationResp | undefined
  appointment?: SparseAppointment | undefined
  lead?: SparseLead | undefined
  pages?: Pages | undefined
  primaryColorRgba?: string | undefined
  logoUrl?: string | undefined
  allowUnavailableSlots?: boolean | undefined

  constructor(data?: ISessionConfig) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.entityId = _data['entityId']
      this.name = _data['name']
      this.timeZoneId = _data['timeZoneId']
      this.organization = _data['organization'] ? OrganizationResp.fromJS(_data['organization']) : <any>undefined
      this.appointment = _data['appointment'] ? SparseAppointment.fromJS(_data['appointment']) : <any>undefined
      this.lead = _data['lead'] ? SparseLead.fromJS(_data['lead']) : <any>undefined
      this.pages = _data['pages'] ? Pages.fromJS(_data['pages']) : <any>undefined
      this.primaryColorRgba = _data['primaryColorRgba']
      this.logoUrl = _data['logoUrl']
      this.allowUnavailableSlots = _data['allowUnavailableSlots']
    }
  }

  static fromJS(data: any): SessionConfig {
    data = typeof data === 'object' ? data : {}
    let result = new SessionConfig()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['entityId'] = this.entityId
    data['name'] = this.name
    data['timeZoneId'] = this.timeZoneId
    data['organization'] = this.organization ? this.organization.toJSON() : <any>undefined
    data['appointment'] = this.appointment ? this.appointment.toJSON() : <any>undefined
    data['lead'] = this.lead ? this.lead.toJSON() : <any>undefined
    data['pages'] = this.pages ? this.pages.toJSON() : <any>undefined
    data['primaryColorRgba'] = this.primaryColorRgba
    data['logoUrl'] = this.logoUrl
    data['allowUnavailableSlots'] = this.allowUnavailableSlots
    return data
  }
}

export interface ISessionConfig {
  id?: string | undefined
  entityId?: string | undefined
  name?: string | undefined
  timeZoneId?: string | undefined
  organization?: OrganizationResp | undefined
  appointment?: SparseAppointment | undefined
  lead?: SparseLead | undefined
  pages?: Pages | undefined
  primaryColorRgba?: string | undefined
  logoUrl?: string | undefined
  allowUnavailableSlots?: boolean | undefined
}

export class Slot implements ISlot {
  id?: string | undefined
  start?: number | undefined
  duration?: number | undefined

  constructor(data?: ISlot) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.start = _data['start']
      this.duration = _data['duration']
    }
  }

  static fromJS(data: any): Slot {
    data = typeof data === 'object' ? data : {}
    let result = new Slot()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['start'] = this.start
    data['duration'] = this.duration
    return data
  }
}

export interface ISlot {
  id?: string | undefined
  start?: number | undefined
  duration?: number | undefined
}

export class SlotsResp implements ISlotsResp {
  suggestedSlots?: NamedSlot[] | undefined
  slots?: TimeSlot[] | undefined
  timeZoneId?: string | undefined

  constructor(data?: ISlotsResp) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['suggestedSlots'])) {
        this.suggestedSlots = [] as any
        for (let item of _data['suggestedSlots']) this.suggestedSlots!.push(NamedSlot.fromJS(item))
      }
      if (Array.isArray(_data['slots'])) {
        this.slots = [] as any
        for (let item of _data['slots']) this.slots!.push(TimeSlot.fromJS(item))
      }
      this.timeZoneId = _data['timeZoneId']
    }
  }

  static fromJS(data: any): SlotsResp {
    data = typeof data === 'object' ? data : {}
    let result = new SlotsResp()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    if (Array.isArray(this.suggestedSlots)) {
      data['suggestedSlots'] = []
      for (let item of this.suggestedSlots) data['suggestedSlots'].push(item.toJSON())
    }
    if (Array.isArray(this.slots)) {
      data['slots'] = []
      for (let item of this.slots) data['slots'].push(item.toJSON())
    }
    data['timeZoneId'] = this.timeZoneId
    return data
  }
}

export interface ISlotsResp {
  suggestedSlots?: NamedSlot[] | undefined
  slots?: TimeSlot[] | undefined
  timeZoneId?: string | undefined
}

export class SparseAppointment implements ISparseAppointment {
  id?: string | undefined
  name?: string | undefined
  description?: string | undefined
  start?: Date | undefined
  end?: Date | undefined
  localDate?: string | undefined
  localTime?: string | undefined
  timeZoneId?: string | undefined

  constructor(data?: ISparseAppointment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.name = _data['name']
      this.description = _data['description']
      this.start = _data['start'] ? new Date(_data['start'].toString()) : <any>undefined
      this.end = _data['end'] ? new Date(_data['end'].toString()) : <any>undefined
      this.localDate = _data['localDate']
      this.localTime = _data['localTime']
      this.timeZoneId = _data['timeZoneId']
    }
  }

  static fromJS(data: any): SparseAppointment {
    data = typeof data === 'object' ? data : {}
    let result = new SparseAppointment()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['name'] = this.name
    data['description'] = this.description
    data['start'] = this.start ? this.start.toISOString() : <any>undefined
    data['end'] = this.end ? this.end.toISOString() : <any>undefined
    data['localDate'] = this.localDate
    data['localTime'] = this.localTime
    data['timeZoneId'] = this.timeZoneId
    return data
  }
}

export interface ISparseAppointment {
  id?: string | undefined
  name?: string | undefined
  description?: string | undefined
  start?: Date | undefined
  end?: Date | undefined
  localDate?: string | undefined
  localTime?: string | undefined
  timeZoneId?: string | undefined
}

export class SparseLead implements ISparseLead {
  id?: string | undefined
  communicationPreferences?: { [key: string]: string } | undefined
  timeZoneId?: string | undefined
  description?: string | undefined
  createdOn?: Date | undefined
  name?: string | undefined
  address?: string | undefined
  city?: string | undefined
  country?: string | undefined
  email?: string | undefined
  phone?: string | undefined
  postalCode?: string | undefined
  state?: string | undefined
  notes?: string | undefined
  smsOptIn?: boolean | undefined

  constructor(data?: ISparseLead) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      if (_data['communicationPreferences']) {
        this.communicationPreferences = {} as any
        for (let key in _data['communicationPreferences']) {
          if (_data['communicationPreferences'].hasOwnProperty(key)) (<any>this.communicationPreferences)![key] = _data['communicationPreferences'][key]
        }
      }
      this.timeZoneId = _data['timeZoneId']
      this.description = _data['description']
      this.createdOn = _data['createdOn'] ? new Date(_data['createdOn'].toString()) : <any>undefined
      this.name = _data['name']
      this.address = _data['address']
      this.city = _data['city']
      this.country = _data['country']
      this.email = _data['email']
      this.phone = _data['phone']
      this.postalCode = _data['postalCode']
      this.state = _data['state']
      this.notes = _data['notes']
      this.smsOptIn = _data['smsOptIn']
    }
  }

  static fromJS(data: any): SparseLead {
    data = typeof data === 'object' ? data : {}
    let result = new SparseLead()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    if (this.communicationPreferences) {
      data['communicationPreferences'] = {}
      for (let key in this.communicationPreferences) {
        if (this.communicationPreferences.hasOwnProperty(key)) (<any>data['communicationPreferences'])[key] = (<any>this.communicationPreferences)[key]
      }
    }
    data['timeZoneId'] = this.timeZoneId
    data['description'] = this.description
    data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined
    data['name'] = this.name
    data['address'] = this.address
    data['city'] = this.city
    data['country'] = this.country
    data['email'] = this.email
    data['phone'] = this.phone
    data['postalCode'] = this.postalCode
    data['state'] = this.state
    data['notes'] = this.notes
    data['smsOptIn'] = this.smsOptIn
    return data
  }
}

export interface ISparseLead {
  id?: string | undefined
  communicationPreferences?: { [key: string]: string } | undefined
  timeZoneId?: string | undefined
  description?: string | undefined
  createdOn?: Date | undefined
  name?: string | undefined
  address?: string | undefined
  city?: string | undefined
  country?: string | undefined
  email?: string | undefined
  phone?: string | undefined
  postalCode?: string | undefined
  state?: string | undefined
  notes?: string | undefined
  smsOptIn?: boolean | undefined
}

export class TagsField implements ITagsField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: ITagsField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): TagsField {
    data = typeof data === 'object' ? data : {}
    let result = new TagsField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface ITagsField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class TagsFieldOptions implements ITagsFieldOptions {
  url?: string | undefined
  readonly _t?: string | undefined
  linkUrl?: string | undefined

  constructor(data?: ITagsFieldOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.url = _data['url']
      ;(<any>this)._t = _data['_t']
      this.linkUrl = _data['linkUrl']
    }
  }

  static fromJS(data: any): TagsFieldOptions {
    data = typeof data === 'object' ? data : {}
    let result = new TagsFieldOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['url'] = this.url
    data['_t'] = this._t
    data['linkUrl'] = this.linkUrl
    return data
  }
}

export interface ITagsFieldOptions {
  url?: string | undefined
  _t?: string | undefined
  linkUrl?: string | undefined
}

export class TextField implements ITextField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: ITextField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): TextField {
    data = typeof data === 'object' ? data : {}
    let result = new TextField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface ITextField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class TextFieldOptions implements ITextFieldOptions {
  multline?: boolean | undefined
  readonly _t?: string | undefined
  linkUrl?: string | undefined

  constructor(data?: ITextFieldOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.multline = _data['multline']
      ;(<any>this)._t = _data['_t']
      this.linkUrl = _data['linkUrl']
    }
  }

  static fromJS(data: any): TextFieldOptions {
    data = typeof data === 'object' ? data : {}
    let result = new TextFieldOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['multline'] = this.multline
    data['_t'] = this._t
    data['linkUrl'] = this.linkUrl
    return data
  }
}

export interface ITextFieldOptions {
  multline?: boolean | undefined
  _t?: string | undefined
  linkUrl?: string | undefined
}

export class TimeField implements ITimeField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: ITimeField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): TimeField {
    data = typeof data === 'object' ? data : {}
    let result = new TimeField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface ITimeField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class TimeSlot implements ITimeSlot {
  start?: Date | undefined
  end?: Date | undefined

  constructor(data?: ITimeSlot) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.start = _data['start'] ? new Date(_data['start'].toString()) : <any>undefined
      this.end = _data['end'] ? new Date(_data['end'].toString()) : <any>undefined
    }
  }

  static fromJS(data: any): TimeSlot {
    data = typeof data === 'object' ? data : {}
    let result = new TimeSlot()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['start'] = this.start ? this.start.toISOString() : <any>undefined
    data['end'] = this.end ? this.end.toISOString() : <any>undefined
    return data
  }
}

export interface ITimeSlot {
  start?: Date | undefined
  end?: Date | undefined
}

export class TimeSlotWithCount implements ITimeSlotWithCount {
  tag?: string | undefined
  count?: number | undefined
  start?: Date | undefined
  end?: Date | undefined

  constructor(data?: ITimeSlotWithCount) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tag = _data['tag']
      this.count = _data['count']
      this.start = _data['start'] ? new Date(_data['start'].toString()) : <any>undefined
      this.end = _data['end'] ? new Date(_data['end'].toString()) : <any>undefined
    }
  }

  static fromJS(data: any): TimeSlotWithCount {
    data = typeof data === 'object' ? data : {}
    let result = new TimeSlotWithCount()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['tag'] = this.tag
    data['count'] = this.count
    data['start'] = this.start ? this.start.toISOString() : <any>undefined
    data['end'] = this.end ? this.end.toISOString() : <any>undefined
    return data
  }
}

export interface ITimeSlotWithCount {
  tag?: string | undefined
  count?: number | undefined
  start?: Date | undefined
  end?: Date | undefined
}

export class TimeZone implements ITimeZone {
  displayName?: string | undefined
  id?: string | undefined

  constructor(data?: ITimeZone) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayName = _data['displayName']
      this.id = _data['id']
    }
  }

  static fromJS(data: any): TimeZone {
    data = typeof data === 'object' ? data : {}
    let result = new TimeZone()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['displayName'] = this.displayName
    data['id'] = this.id
    return data
  }
}

export interface ITimeZone {
  displayName?: string | undefined
  id?: string | undefined
}

export class TransactionResponse implements ITransactionResponse {
  invoice?: Invoice | undefined
  payment?: Payment | undefined
  adjustment?: Adjustment | undefined
  dispute?: Dispute | undefined

  constructor(data?: ITransactionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.invoice = _data['invoice'] ? Invoice.fromJS(_data['invoice']) : <any>undefined
      this.payment = _data['payment'] ? Payment.fromJS(_data['payment']) : <any>undefined
      this.adjustment = _data['adjustment'] ? Adjustment.fromJS(_data['adjustment']) : <any>undefined
      this.dispute = _data['dispute'] ? Dispute.fromJS(_data['dispute']) : <any>undefined
    }
  }

  static fromJS(data: any): TransactionResponse {
    data = typeof data === 'object' ? data : {}
    let result = new TransactionResponse()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['invoice'] = this.invoice ? this.invoice.toJSON() : <any>undefined
    data['payment'] = this.payment ? this.payment.toJSON() : <any>undefined
    data['adjustment'] = this.adjustment ? this.adjustment.toJSON() : <any>undefined
    data['dispute'] = this.dispute ? this.dispute.toJSON() : <any>undefined
    return data
  }
}

export interface ITransactionResponse {
  invoice?: Invoice | undefined
  payment?: Payment | undefined
  adjustment?: Adjustment | undefined
  dispute?: Dispute | undefined
}

export class Trigger implements ITrigger {
  type?: TriggerType | undefined
  name?: string | undefined

  constructor(data?: ITrigger) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type']
      this.name = _data['name']
    }
  }

  static fromJS(data: any): Trigger {
    data = typeof data === 'object' ? data : {}
    let result = new Trigger()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['name'] = this.name
    return data
  }
}

export interface ITrigger {
  type?: TriggerType | undefined
  name?: string | undefined
}

export enum TriggerType {
  SideEffect = 'SideEffect',
  System = 'System',
  User = 'User',
  Error = 'Error',
}

export class TrunkIdentity implements ITrunkIdentity {
  entityId?: string | undefined
  level?: string | undefined
  name?: string | undefined
  identityProviderId?: string | undefined
  externalId?: string | undefined

  constructor(data?: ITrunkIdentity) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityId = _data['entityId']
      this.level = _data['level']
      this.name = _data['name']
      this.identityProviderId = _data['identityProviderId']
      this.externalId = _data['externalId']
    }
  }

  static fromJS(data: any): TrunkIdentity {
    data = typeof data === 'object' ? data : {}
    let result = new TrunkIdentity()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['entityId'] = this.entityId
    data['level'] = this.level
    data['name'] = this.name
    data['identityProviderId'] = this.identityProviderId
    data['externalId'] = this.externalId
    return data
  }
}

export interface ITrunkIdentity {
  entityId?: string | undefined
  level?: string | undefined
  name?: string | undefined
  identityProviderId?: string | undefined
  externalId?: string | undefined
}

export class UIElement implements IUIElement {
  readonly type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IUIElement) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): UIElement {
    data = typeof data === 'object' ? data : {}
    let result = new UIElement()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IUIElement {
  type?: string | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class UpdateLeadRequest implements IUpdateLeadRequest {
  name?: string | undefined
  address?: string | undefined
  city?: string | undefined
  country?: string | undefined
  email?: string | undefined
  phone?: string | undefined
  postalCode?: string | undefined
  state?: string | undefined
  notes?: string | undefined
  smsOptIn?: boolean | undefined
  trustedFormCertUrl?: string | undefined
  lat?: string | undefined
  lng?: string | undefined
  extraProperties?: {[key: string]: any} | undefined;

  constructor(data?: IUpdateLeadRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name']
      this.address = _data['address']
      this.city = _data['city']
      this.country = _data['country']
      this.email = _data['email']
      this.phone = _data['phone']
      this.postalCode = _data['postalCode']
      this.state = _data['state']
      this.notes = _data['notes']
      this.smsOptIn = _data['smsOptIn']
      this.trustedFormCertUrl = _data['trustedFormCertUrl']
      this.lat = _data['lat']
      this.lng = _data['lng']
      this.extraProperties = _data['extraProperties']
    }
  }

  static fromJS(data: any): UpdateLeadRequest {
    data = typeof data === 'object' ? data : {}
    let result = new UpdateLeadRequest()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['name'] = this.name
    data['address'] = this.address
    data['city'] = this.city
    data['country'] = this.country
    data['email'] = this.email
    data['phone'] = this.phone
    data['postalCode'] = this.postalCode
    data['state'] = this.state
    data['notes'] = this.notes
    data['smsOptIn'] = this.smsOptIn
    data['trustedFormCertUrl'] = this.trustedFormCertUrl
    data['lat'] = this.lat
    data['lng'] = this.lng
    data['extraProperties'] = this.extraProperties
    return data
  }
}

export interface IUpdateLeadRequest {
  name?: string | undefined
  address?: string | undefined
  city?: string | undefined
  country?: string | undefined
  email?: string | undefined
  phone?: string | undefined
  postalCode?: string | undefined
  state?: string | undefined
  notes?: string | undefined
  smsOptIn?: boolean | undefined
  trustedFormCertUrl?: string | undefined
  lat?: string | undefined
  lng?: string | undefined
  extraProperties?: {[key: string]: any} | undefined;
}

export class UrlField implements IUrlField {
  readonly type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  readonly isReadOnly?: boolean | undefined
  readonly isVisible?: boolean | undefined

  constructor(data?: IUrlField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      ;(<any>this).type = _data['type']
      this.defaultValue = _data['defaultValue']
      this.isRequired = _data['isRequired']
      this.style = _data['style']
      this.options = _data['options'] ? FieldOptions.fromJS(_data['options']) : <any>undefined
      this.name = _data['name']
      this.label = _data['label']
      if (Array.isArray(_data['enable'])) {
        this.enable = [] as any
        for (let item of _data['enable']) this.enable!.push(item)
      }
      if (Array.isArray(_data['visible'])) {
        this.visible = [] as any
        for (let item of _data['visible']) this.visible!.push(item)
      }
      ;(<any>this).isReadOnly = _data['isReadOnly']
      ;(<any>this).isVisible = _data['isVisible']
    }
  }

  static fromJS(data: any): UrlField {
    data = typeof data === 'object' ? data : {}
    let result = new UrlField()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['type'] = this.type
    data['defaultValue'] = this.defaultValue
    data['isRequired'] = this.isRequired
    data['style'] = this.style
    data['options'] = this.options ? this.options.toJSON() : <any>undefined
    data['name'] = this.name
    data['label'] = this.label
    if (Array.isArray(this.enable)) {
      data['enable'] = []
      for (let item of this.enable) data['enable'].push(item)
    }
    if (Array.isArray(this.visible)) {
      data['visible'] = []
      for (let item of this.visible) data['visible'].push(item)
    }
    data['isReadOnly'] = this.isReadOnly
    data['isVisible'] = this.isVisible
    return data
  }
}

export interface IUrlField {
  type?: string | undefined
  defaultValue?: any | undefined
  isRequired?: boolean | undefined
  style?: any | undefined
  options?: FieldOptions | undefined
  name?: string | undefined
  label?: string | undefined
  enable?: string[] | undefined
  visible?: string[] | undefined
  isReadOnly?: boolean | undefined
  isVisible?: boolean | undefined
}

export class URLFieldOptions implements IURLFieldOptions {
  multline?: boolean | undefined
  readonly _t?: string | undefined
  linkUrl?: string | undefined

  constructor(data?: IURLFieldOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.multline = _data['multline']
      ;(<any>this)._t = _data['_t']
      this.linkUrl = _data['linkUrl']
    }
  }

  static fromJS(data: any): URLFieldOptions {
    data = typeof data === 'object' ? data : {}
    let result = new URLFieldOptions()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['multline'] = this.multline
    data['_t'] = this._t
    data['linkUrl'] = this.linkUrl
    return data
  }
}

export interface IURLFieldOptions {
  multline?: boolean | undefined
  _t?: string | undefined
  linkUrl?: string | undefined
}

export class User implements IUser {
  id?: string | undefined
  organizationId?: string | undefined
  accountId?: string | undefined
  role?: EntityRoleId | undefined
  name?: string | undefined
  isActive?: boolean | undefined
  identities?: Identity[] | undefined
  email?: string | undefined
  timeZoneId?: string | undefined

  constructor(data?: IUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id']
      this.organizationId = _data['organizationId']
      this.accountId = _data['accountId']
      this.role = _data['role']
      this.name = _data['name']
      this.isActive = _data['isActive']
      if (Array.isArray(_data['identities'])) {
        this.identities = [] as any
        for (let item of _data['identities']) this.identities!.push(Identity.fromJS(item))
      }
      this.email = _data['email']
      this.timeZoneId = _data['timeZoneId']
    }
  }

  static fromJS(data: any): User {
    data = typeof data === 'object' ? data : {}
    let result = new User()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['id'] = this.id
    data['organizationId'] = this.organizationId
    data['accountId'] = this.accountId
    data['role'] = this.role
    data['name'] = this.name
    data['isActive'] = this.isActive
    if (Array.isArray(this.identities)) {
      data['identities'] = []
      for (let item of this.identities) data['identities'].push(item.toJSON())
    }
    data['email'] = this.email
    data['timeZoneId'] = this.timeZoneId
    return data
  }
}

export interface IUser {
  id?: string | undefined
  organizationId?: string | undefined
  accountId?: string | undefined
  role?: EntityRoleId | undefined
  name?: string | undefined
  isActive?: boolean | undefined
  identities?: Identity[] | undefined
  email?: string | undefined
  timeZoneId?: string | undefined
}

export class UserAction implements IUserAction {
  eventId?: string | undefined
  name?: string | undefined
  form?: Form | undefined

  constructor(data?: IUserAction) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.eventId = _data['eventId']
      this.name = _data['name']
      this.form = _data['form'] ? Form.fromJS(_data['form']) : <any>undefined
    }
  }

  static fromJS(data: any): UserAction {
    data = typeof data === 'object' ? data : {}
    let result = new UserAction()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['eventId'] = this.eventId
    data['name'] = this.name
    data['form'] = this.form ? this.form.toJSON() : <any>undefined
    return data
  }
}

export interface IUserAction {
  eventId?: string | undefined
  name?: string | undefined
  form?: Form | undefined
}

export class UserActionRequest implements IUserActionRequest {
  eventId?: string | undefined
  objectType?: string | undefined
  action?: string | undefined
  parameters?: { [key: string]: any } | undefined
  selectedIds?: string[] | undefined

  constructor(data?: IUserActionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.eventId = _data['eventId']
      this.objectType = _data['objectType']
      this.action = _data['action']
      if (_data['parameters']) {
        this.parameters = {} as any
        for (let key in _data['parameters']) {
          if (_data['parameters'].hasOwnProperty(key)) (<any>this.parameters)![key] = _data['parameters'][key]
        }
      }
      if (Array.isArray(_data['selectedIds'])) {
        this.selectedIds = [] as any
        for (let item of _data['selectedIds']) this.selectedIds!.push(item)
      }
    }
  }

  static fromJS(data: any): UserActionRequest {
    data = typeof data === 'object' ? data : {}
    let result = new UserActionRequest()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['eventId'] = this.eventId
    data['objectType'] = this.objectType
    data['action'] = this.action
    if (this.parameters) {
      data['parameters'] = {}
      for (let key in this.parameters) {
        if (this.parameters.hasOwnProperty(key)) (<any>data['parameters'])[key] = (<any>this.parameters)[key]
      }
    }
    if (Array.isArray(this.selectedIds)) {
      data['selectedIds'] = []
      for (let item of this.selectedIds) data['selectedIds'].push(item)
    }
    return data
  }
}

export interface IUserActionRequest {
  eventId?: string | undefined
  objectType?: string | undefined
  action?: string | undefined
  parameters?: { [key: string]: any } | undefined
  selectedIds?: string[] | undefined
}

export enum UserPolicy {
  AnyInOrganization = 'AnyInOrganization',
  SameOfLastAppt = 'SameOfLastAppt',
  SameOfNextAppt = 'SameOfNextAppt',
}

export class UserWithSchedulingSettings implements IUserWithSchedulingSettings {
  userId?: string | undefined
  appointmentTypeId?: string | undefined
  name?: string | undefined

  constructor(data?: IUserWithSchedulingSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId']
      this.appointmentTypeId = _data['appointmentTypeId']
      this.name = _data['name']
    }
  }

  static fromJS(data: any): UserWithSchedulingSettings {
    data = typeof data === 'object' ? data : {}
    let result = new UserWithSchedulingSettings()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['userId'] = this.userId
    data['appointmentTypeId'] = this.appointmentTypeId
    data['name'] = this.name
    return data
  }
}

export interface IUserWithSchedulingSettings {
  userId?: string | undefined
  appointmentTypeId?: string | undefined
  name?: string | undefined
}

export class WorkingHoursSetting implements IWorkingHoursSetting {
  startMinutes?: number | undefined
  endMinutes?: number | undefined

  constructor(data?: IWorkingHoursSetting) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.startMinutes = _data['startMinutes']
      this.endMinutes = _data['endMinutes']
    }
  }

  static fromJS(data: any): WorkingHoursSetting {
    data = typeof data === 'object' ? data : {}
    let result = new WorkingHoursSetting()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['startMinutes'] = this.startMinutes
    data['endMinutes'] = this.endMinutes
    return data
  }
}

export interface IWorkingHoursSetting {
  startMinutes?: number | undefined
  endMinutes?: number | undefined
}

export class Pages implements IPages {
  contactInfo?: SchedulerPageSettings | undefined
  scheduler?: SchedulerPageSettings | undefined
  appointmentConfirmation?: SchedulerPageSettings | undefined
  appointmentScheduled?: SchedulerPageSettings | undefined

  constructor(data?: IPages) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property]
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contactInfo = _data['contactInfo'] ? SchedulerPageSettings.fromJS(_data['contactInfo']) : <any>undefined
      this.scheduler = _data['scheduler'] ? SchedulerPageSettings.fromJS(_data['scheduler']) : <any>undefined
      this.appointmentConfirmation = _data['appointmentConfirmation'] ? SchedulerPageSettings.fromJS(_data['appointmentConfirmation']) : <any>undefined
      this.appointmentScheduled = _data['appointmentScheduled'] ? SchedulerPageSettings.fromJS(_data['appointmentScheduled']) : <any>undefined
    }
  }

  static fromJS(data: any): Pages {
    data = typeof data === 'object' ? data : {}
    let result = new Pages()
    result.init(data)
    return result
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {}
    data['contactInfo'] = this.contactInfo ? this.contactInfo.toJSON() : <any>undefined
    data['scheduler'] = this.scheduler ? this.scheduler.toJSON() : <any>undefined
    data['appointmentConfirmation'] = this.appointmentConfirmation ? this.appointmentConfirmation.toJSON() : <any>undefined
    data['appointmentScheduled'] = this.appointmentScheduled ? this.appointmentScheduled.toJSON() : <any>undefined
    return data
  }
}

export interface IPages {
  contactInfo?: SchedulerPageSettings | undefined
  scheduler?: SchedulerPageSettings | undefined
  appointmentConfirmation?: SchedulerPageSettings | undefined
  appointmentScheduled?: SchedulerPageSettings | undefined
}

export class ApiException extends Error {
  override message: string
  status: number
  response: string
  headers: { [key: string]: any }
  result: any

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super()

    this.message = message
    this.status = status
    this.response = response
    this.headers = headers
    this.result = result
  }

  protected isApiException = true

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): any {
  throw new ApiException(message, status, response, headers, result)
}

export interface IAuthorizedApiBaseConfig {
  token: string
}
